import React, {
  useState,
  useEffect,
  useContext,
  useRef,
} from 'react';

import {
  useResponsiveParams,
  QuantaFormik,
  QuantaForm,
  MixedGridGroup,
  Text,
  Button,
  useQuantaFormikContext,
  NotificationList,
  Label,
  SearchResultsModal,
} from 'quanta-ui';
// import Loading from '../../../../../../lib/layout/loading';1/6
import { Loading } from 'quanta-flows/modules/layout';
import { useLazyQuery, useQuery } from '@apollo/client';
import {
  CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL,
  // GET_VIEW_RENEW_POLICY_VAR_DETAILS,
  GET_CUSTOMER_TYPE_DOMAIN,
  GET_DATE_TIME,
  // PAY_PREMIUM_LIST,
  GET_MEDICAL_QUESTIONS,
  ROLLOVER_COMPANY_LIST,
  PRODUCT_CUSTOMER_DROPDOWN_DETAILS,
  PINCODE_LOOKUP,
  CUSTOMER_ORGANISATIONAL_DROPDOWN_DETAIL,
  // GET_PRODUCT_DETAILS,
  RENEWAL_MANDATE_DETAILS,
  RENEWAL_PROPOSAL,
  GET_INTERMEDIARY_LIST,
  LOAD_USER_PROFILE,
  GET_FIELDUSER_LIST,
  MOBILE_NUMBER_STARTING_WITH,
  CHARACTER_LIMIT_LIST,
  COVER_TYPE_LIMIT,
} from 'quanta-flows/modules/policy/renewal/health'
import { PAY_PREMIUM_LIST ,GET_PRODUCT_DETAILS,GET_PLAN_COVER_DETAILS,GET_VIEW_RENEW_POLICY_VAR_DETAILS} from '../../queries';
// import useFetchQuery from '../../../../../../lib/graphql/useFetchQuery';
import { useFetchQuery } from 'quanta-flows';
// import useMutationQuery from '../../../../../../lib/graphql/useMutationQuery';
import { useMutationQuery } from 'quanta-flows';
// import {
//   updatePlanPremium,
//   updatePlanWithPrevPlan,
//   updatePrevPlanWithPlan,
//   updateViewRenewPolicy,
// } from '../../_graphql/state';
import { 
  updatePlanPremium, 
  updatePlanWithPrevPlan,
  updatePrevPlanWithPlan,
  updateViewRenewPolicy,} from 'quanta-flows/modules/policy/renewal/health/state';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCalculator,
  faSearch,
  faCheck,
  faExclamationTriangle,
  faFileMedical,
  //faInfoCircle,
  faPlus,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import ModalMedicalQuestionaire from './modal-medical-questionaire';
// import { ModalMedicalQuestionaire } from 'quanta-flows/modules/policy/renewal/health';
//  import CurrencyFormater from '../../../../../../lib/intl/CurrencyFormater';
import { CurrencyFormater } from 'quanta-flows';
import moment from 'moment';
 import ModalAddMembers from './modal-add-members';
// import { ModalAddMembers } from 'quanta-flows/modules/policy/renewal/health';
// import { QuantaConfigContext } from '../../../../../../lib/config/ConfigProvider';
import { QuantaConfigContext } from 'quanta-flows';
// import { Error } from '../../../../../../lib/layout';
import { Error } from 'quanta-flows/modules/layout';
// import {
//   updateAllIntermediaryFields,
//   updateBusinessLocation,
//   updateFieldUser,
//   updateIntermediary,
// } from '../../../../../common/intermediary-select/_graphql/state';
import { updateAllIntermediaryFields,
  updateBusinessLocation,
 updateFieldUser,
 updateIntermediary,
 } from 'quanta-flows/modules/common/intermediary/state';
// import ProposerCustomerEditable from '../../../../../common/proposer-customer/proposer-customer-editable';
import {ProposerCustomerEditable} from 'quanta-flows/modules/common/proposer/edit';

export default function RenewReviewConfirmDetails({
  setParentAlerts,
  setLoadingStep,
  setCustomLoadingMessage,
  planName,
  planCode,
  productCode,
  productName,
  renewalMode,
  expandedCard,
  renderExpandedCards,
  setEnableRenew,
  renewalFlag,
  ...props
}) {
  const [displayEditExternals,setDisplayEditExtenals] = useState([]);
  const [displayEditExternalsPreviousInsured,setDisplayEditExternalsPreviousInsured] = useState([]);
  const [pedValue, setpedValue] = useState(null);
  const [RenewalPaymentMandatevalue, setRenewalPaymentMandatevalue] = useState('');
  const fetchQuery = useFetchQuery();
  const mutateQuery = useMutationQuery();
  const { branding } = useContext(QuantaConfigContext);
  const initLoadRef = useRef([]);
  const { loading, error, data, previousData } = useQuery(
    GET_VIEW_RENEW_POLICY_VAR_DETAILS,
    {
      skip: new Set(initLoadRef.current).size >= 16 ? true : false,
      onCompleted: (data) => {
        initLoadRef.current = [...initLoadRef.current, 1];
      },
    },
  );
  const {
    loading: dateTimeLoading,
    error: errorTimeLoading,
    data: dateTimeData,
  } = useQuery(GET_DATE_TIME, {
    onCompleted: (data) => {
      initLoadRef.current = [...initLoadRef.current, 2];
    },
  });
const getMedicalQuestionsMapped = (values, insured) => {
  let responseObj = {};
  responseObj = {
    relationship: insured,
    questions: Object.keys(values?.medicalUnderwriting[`${insured}`]).map(
      (k) => {
        let answerText = '';
      let checkboxAnswer = '';
        const question = productQuestionList.find(
          (question) => question.srNo === k,
        );
        if (question) {
          if (!question.isParent) {
            const parentQuestion = productQuestionList.find((q) =>
              q.childQuesNo.find(
                (c) =>
                  c.toLowerCase() === question.srNo.toLowerCase(),
              ),
            );
            if (
              parentQuestion &&
              ((values?.medicalUnderwriting[`${insured}`][
                `${parentQuestion.srNo}`
              ].checkboxAnswer === 'Yes' &&
                !parentQuestion.condToChild) ||
                (values?.medicalUnderwriting[`${insured}`][
                  `${parentQuestion.srNo}`
                ].checkboxAnswer === 'No' &&
                  parentQuestion.condToChild))
            ) {
              answerText = '';
            } else {
              answerText =
                question.isChkTxtReq &&
                  values?.medicalUnderwriting[`${insured}`][k] === 'Yes'
                ? values?.medicalUnderwriting[`${insured}`][k]
                  .textareaAnswer
                : question.isChkTxtReq &&
                  values?.medicalUnderwriting[`${insured}`][k]
                    .checkboxAnswer === 'No'
                  ? values?.medicalUnderwriting[`${insured}`][k]
                    .checkboxAnswer
                  : question.isChkReq
                    ? values?.medicalUnderwriting[`${insured}`][k]
                      .checkboxAnswer
                    : values?.medicalUnderwriting[`${insured}`][k]
                      .textareaAnswer;
          }
        }
        else {
          if (
            viewRenewPolicy?.businessType === 'Renewal Business'
          ) {
            (k=='MASTER')?(
              answerText = (values?.medicalUnderwriting[`${insured}`][k]
                .checkboxAnswer == 'Yes')?'Yes':'No'
            ):(answerText =
              values?.medicalUnderwriting[`${insured}`][k]
                .textareaAnswer);
            // answerText =
            //   values?.medicalUnderwriting[`${insured}`][k]
            //     .textareaAnswer
        } else {
            answerText =
              question.isChkTxtReq &&
                values?.medicalUnderwriting[`${insured}`][k]
                  .checkboxAnswer === 'Yes' //1st
                ? values?.medicalUnderwriting[`${insured}`][k]
                  .textareaAnswer
                : question.isChkTxtReq &&
                  values?.medicalUnderwriting[`${insured}`][k]
                    .checkboxAnswer === 'No' //2nd
                  ? values?.medicalUnderwriting[`${insured}`][k]
                    .checkboxAnswer
                  : question.isChkReq //3rd
                    ? values?.medicalUnderwriting[`${insured}`][k]
                      .checkboxAnswer
                    : values?.medicalUnderwriting[`${insured}`][k]
                      .textareaAnswer;
          }
        }
      } else {
        answerText =
          values?.medicalUnderwriting[`${insured}`][k]
            .checkboxAnswer;
      }
      checkboxAnswer =
        values?.medicalUnderwriting[`${insured}`][k].checkboxAnswer;
      if (viewRenewPolicy?.businessType === 'Renewal Business') {
        if (
          values?.medicalUnderwriting[`${insured}`][k]
            .checkboxAnswer === '' &&
          values?.medicalUnderwriting[`${insured}`][k]
            .textareaAnswer != ''
        ) {
          checkboxAnswer = 'Yes';
          answerText =
            values?.medicalUnderwriting[`${insured}`][k]
              .textareaAnswer;
        }
      }
        return {
          srNo: k,
          answer: {
          checkboxAnswer,
          // checkboxAnswer:
          //   values?.medicalUnderwriting[`${insured}`][k]
          //     .checkboxAnswer,
            answerText,
            textareaAnswer:
            values?.medicalUnderwriting[`${insured}`][k]
              .textareaAnswer,
          },
        };
    }),
  };
  return responseObj;
};
  const {
    loading: loadingRenewalMandateData,
    error: errorRenewalMandateData,
    data: renewalMandateData,
  } = useQuery(RENEWAL_MANDATE_DETAILS, {
    fetchPolicy: 'cache-first',
    variables: {
      productCode,
    },
    onCompleted: (data) => {
      initLoadRef.current = [...initLoadRef.current, 3];
    },
  });

  const {
    loading: loadingQuestions,
    error: errorQuestions,
    data: dataQuestions,
  } = useQuery(GET_MEDICAL_QUESTIONS, {
    variables: {
      input: {
      productCode,
      },
    },
    fetchPolicy: 'cache-first',
    onCompleted: (data) => {
      initLoadRef.current = [...initLoadRef.current, 4];
    },
  });

  const {
    loading: loadingRollOverCompanyList,
    error: errorRollOverCompanyList,
    data: dataRollOverCompanyList,
  } = useQuery(ROLLOVER_COMPANY_LIST, {
    fetchPolicy: 'cache-first',
    onCompleted: (data) => {
      initLoadRef.current = [...initLoadRef.current, 5];
    },
  });

  const [
    getApplicableMembers,
    {
      loading: loadingApplicableMemberTypes,
      error: errorApplicableMemberTypes,
      data: dataApplicableMemberTypes,
    },
  ] = useLazyQuery(GET_PRODUCT_DETAILS, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      initLoadRef.current = [...initLoadRef.current, 6];
    },
  });
  const {
    loading: dropDownLoadingCustomer,
    error: dropDownErrorCustomer,
    data: dropDownDetails,
  } = useQuery(CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL, {
    fetchPolicy: 'cache-first',
    onCompleted: (data) => {
      initLoadRef.current = [...initLoadRef.current, 7];
    },
  });

  const {
    loading: dropDownLoadingOrganisation,
    error: dropDownErrorOrganisation,
    data: dropDownDetailsOrganisation,
  } = useQuery(CUSTOMER_ORGANISATIONAL_DROPDOWN_DETAIL, {
    fetchPolicy: 'cache-first',
    onCompleted: (data) => {
      initLoadRef.current = [...initLoadRef.current, 8];
    },
  });

  const {
    loading: loadingProductCustomerDropdown,
    error: errorProductCustomerDropdown,
    data: dataProductCustomerDropdown,
  } = useQuery(PRODUCT_CUSTOMER_DROPDOWN_DETAILS, {
    fetchPolicy: 'cache-first',
    variables: {
      productCode,
    },
    onCompleted: (data) => {
      initLoadRef.current = [...initLoadRef.current, 9];
    },
  });

  const {
    loading: loadingPaymentType,
    error: errorPaymentType,
    data: dataPaymentType,
  } = useQuery(PAY_PREMIUM_LIST, {
    fetchPolicy: 'cache-first',
    onCompleted: (data) => {
      initLoadRef.current = [...initLoadRef.current, 10];
    },
  });
  const {
    loading: loadingCustTypeDomain,
    error: errorCustTypeDomain,
    data: dataCustTypeDomain,
  } = useQuery(GET_CUSTOMER_TYPE_DOMAIN, {
    fetchPolicy: 'cache-first',
    onCompleted: (data) => {
      initLoadRef.current = [...initLoadRef.current, 11];
    },
  });

  const {
    loading: loadingMyIntermediaries,
    error: errorMyIntermediaries,
    data: dataMyIntermediaries,
  } = useQuery(GET_INTERMEDIARY_LIST, {
    fetchPolicy: 'cache-first',
    onCompleted: (data) => {
      const { myIntermediaries } = data;
      const defaultIntermediary = myIntermediaries?.find(
        (imd) => imd.isSelected,
      );
      const defaultBusinessLocation = myIntermediaries?.find(
        (imd) => imd.isSelected,
      )?.businessLocations[0];
      updateIntermediary(
        defaultIntermediary?.intermediaryCode,
        defaultIntermediary?.intermediaryName,
      );
      updateBusinessLocation(
        defaultBusinessLocation?.code,
        defaultBusinessLocation?.name,
      );
      initLoadRef.current = [...initLoadRef?.current, 12];
    },
  });

  const {
    loading: loadingProfileData,
    error: errorProfileData,
    data: profileData,
  } = useQuery(LOAD_USER_PROFILE, {
    fetchPolicy: 'cache-first',
    onCompleted: (data) => {
      const { checkAuth, userMyDetail } = data;
      const { associatedCoreEntity } = checkAuth.organisation;
      const { userType } = userMyDetail;
      if (userType?.typeName.toLowerCase() === 'field user') {
        updateFieldUser(
          associatedCoreEntity.type,
          associatedCoreEntity.value,
        );
      } else {
        updateFieldUser('', '');
      }
      initLoadRef.current = [...initLoadRef?.current, 13];
    },
  });

  const {
    loading: loadingMobileNumberLength,
    error: errorMobileNumberLength,
    data: dataMobileNumberLength,
  } = useQuery(MOBILE_NUMBER_STARTING_WITH, {
    fetchPolicy: 'cache-first',
    onCompleted: (data) => {
      initLoadRef.current = [...initLoadRef?.current, 14];
    },
  });

  const {
    loading: loadingNameLimit,
    error: errorNameLimit,
    data: dataNameLimit,
  } = useQuery(CHARACTER_LIMIT_LIST, {
    fetchPolicy: 'cache-first',
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 15];
    },
  });

  const {
    loading: loadingCoverTypeLimit,
    error: errorCoverTypeLimit,
    data: dataCoverTypeLimit,
  } = useQuery(COVER_TYPE_LIMIT, {
    fetchPolicy: 'cache-first',
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 16];
    },
  });

  useEffect(() => {
    if (dateTimeData) {
      getApplicableMembers({
        variables: {
          input: {
          productCode,
          startDate: dateTimeData?.datetimeValue?.date,
          },
        },
      });
    }
  }, [dateTimeData]);

  const repeat = useResponsiveParams({
    for_mobile: 1,
    for_desktop: 3,
  });
  const repeatFormsReadOnly = useResponsiveParams({
    for_mobile: 2,
    for_desktop: 3,
  });
  const repeatFormsReadOnly1 = useResponsiveParams({
    for_mobile: 2,
    for_desktop: 1,
  });
  const repeatFormsonEdit1 = useResponsiveParams({
    for_mobile: 1,
    for_desktop: 1,
  });
  const repeatFormsonEdit = useResponsiveParams({
    for_mobile: 1,
    for_desktop: 3,
  });
  const screenType = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop',
  });
  const pedData =(values)=>{
    values?.insuredDetails.map((insured)=>
    {
    //  console.log( "insured.pedWaitingPeriod",insured.pedWaitingPeriod)
    })
  }
  const submitInsuredArr = (values) => {
 let name;
    let submitArr = [];
    insuredDetails.forEach((insured)=>
    {
       name=insured?.pedWaitingPeriod
      })
   setpedValue(name)
    // return submitArr;
  };
  const MINOR_THRESHOLD_AGE = 18;

  const validate = (values) => {
    let errors = {};
    errors.proposerDetails = {};
    errors.insuredDetails = {};
    errors.nomineeDetails = {};
    errors.prevInsuranceDetails = {};
    errors.intermediaryData = {};
    errors.renewalPaymentMandate;
    
    let errorCount = 0;
    if (renewalMandateDetails?.renewalPaymentMandate.toString().toLowerCase()=== 'yes'||renewalMandateDetails?.renewalPaymentMandate===true)
    { 
      errors.renewalPaymentMandate= 'Renew is not applicable since Renewal Mandate is opted on its previous New Business/RollOver';
      errorCount+=1;
    }
    if (!values?.intermediaryData?.intermediary) {
      errors.intermediaryData.intermediary = '* Required';
    }
    if (!values?.intermediaryData?.businessLocation) {
      errors.intermediaryData.businessLocation = '* Required';
    }
    /* Proposer Form Start*/
      //P2_632
      else if (values?.proposerDetails?.panNumber?.substring(3, 4)?.toString()?.toLowerCase() !== 'p' &&
        values?.proposerDetails?.customerType?.toString()?.toLowerCase() === 'individual') {
      
        errors.proposerDetails.panNumber = '* 4th Letter should be P';
      }
      //P2_632
    if (!values.proposerDetails.permAddressLine1) {
      errors.proposerDetails.permAddressLine1 = '* Required';
    }
    if (!values.proposerDetails.permPincode) {
      errors.proposerDetails.permPincode = '* Required';
    } else if (
      values.proposerDetails.permPincode &&
      (values.proposerDetails.permPincode.length !== 6 ||
        !values.proposerDetails.permPincode.match(/^[0-9]+$/))
    ) {
      errors.proposerDetails.permPincode =
        '* Pincode must be of 6 digits';
    } else if (
      values.proposerDetails.permPincode &&
      values.proposerDetails.permPincode.length === 6 &&
      (!values.proposerDetails.permCityTownVillage ||
        !values.proposerDetails.permState ||
        !values.proposerDetails.permDistrict)
    ) {
      errors.proposerDetails.permPincode =
        '* Click the search icon to fetch city, district and state';
    }
    if (!values.proposerDetails.permCommAddressYN) {
      if (!values.proposerDetails.commAddressLine1) {
        errors.proposerDetails.commAddressLine1 = '* Required';
      }
      if (!values.proposerDetails.commPincode) {
        errors.proposerDetails.commPincode = '* Required';
      } else if (
        values.proposerDetails.commPincode &&
        (values.proposerDetails.commPincode.length !== 6 ||
          !values.proposerDetails.commPincode.match(/^[0-9]+$/))
      ) {
        errors.proposerDetails.commPincode =
          '* Pincode must be of 6 digits';
      } else if (
        values.proposerDetails.commPincode &&
        (!values.proposerDetails.commCityTownVillage ||
          !values.proposerDetails.commState ||
          !values.proposerDetails.commDistrict)
      ) {
        errors.proposerDetails.commPincode =
          '* Click the search icon to fetch city, district and state';
      }
    }
    if (!values.proposerDetails.mobileNo) {
      errors.proposerDetails.mobileNo = '* Required';
    }
    if (
      values?.proposerDetails?.mobileNo &&
      parseInt(values?.proposerDetails?.mobileNo[0]) <
        parseInt(mobileNumberStartingWith?.value)
    ) {
      errors.proposerDetails.mobileNo = `* Mobile number must start with digit ${mobileNumberStartingWith?.value} to 9`;
    }
    if (
      values.proposerDetails.mobileNo &&
      (values.proposerDetails.mobileNo.length !== 10 ||
        !values.proposerDetails.mobileNo.match(/^[0-9]+$/))
    ) {
      errors.proposerDetails.mobileNo =
        '* Mobile number must be of 10 digits';
    }
    if (!values.proposerDetails.emailID) {
      errors.proposerDetails.emailID = '* Required';
    }
    if (values.proposerDetails.emailID) {
      let email_check = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
      );
      if (!email_check.test(values.proposerDetails.emailID)) {
        errors.proposerDetails.emailID =
          '* Please enter valid email address';
      }
    }
    if (
      values?.proposerDetails?.customerType ===
      getDomainData(customerTypeList, 'Organisation', 'value', 'code')
    ) {
      if (values.proposerDetails.faxNo) {
        if (
          values.proposerDetails.faxNo.toString().length !== 10 ||
          !values.proposerDetails.faxNo.toString().match(/^[0-9]+$/)
        ) {
          errors.proposerDetails.faxNo =
            '* Fax Number must be of 10 digits';
        }
      }
      if (values.proposerDetails.altPhoneNo) {
        if (
          values.proposerDetails.altPhoneNo.toString().length !==
            10 ||
          !values.proposerDetails.altPhoneNo
            .toString()
            .match(/^[0-9]+$/)
        ) {
          errors.proposerDetails.altPhoneNo =
            '* Telephone number must be of 10 digits';
        }
      }
      if (values.proposerDetails.phoneNo) {
        if (
          values.proposerDetails.phoneNo.toString().length !== 10 ||
          !values.proposerDetails.phoneNo.toString().match(/^[0-9]+$/)
        ) {
          errors.proposerDetails.phoneNo =
            '* Telephone number must be of 10 digits';
        }
      }
      if (
        values?.proposerDetails?.altMobileNo &&
        parseInt(values?.proposerDetails?.altMobileNo[0]) <
          parseInt(mobileNumberStartingWith?.value)
      ) {
        errors.proposerDetails.altMobileNo = `* Mobile number must start with digit ${mobileNumberStartingWith?.value} to 9`;
      }
      if (values.proposerDetails.altMobileNo) {
        if (
          values.proposerDetails.altMobileNo.toString().length !==
            10 ||
          !values.proposerDetails.altMobileNo
            .toString()
            .match(/^[0-9]+$/)
        ) {
          errors.proposerDetails.altMobileNo =
            '* Mobile number must be of 10 digits';
        }
      }
    }
    /* Proposer Form End */
    /* Insured Members Start */
    Object.keys(values?.insuredDetails)
      ?.filter(
        (insured) =>
          !values?.insuredDetails[insured]?.isHardDeleted &&
          !values?.insuredDetails[insured]?.isMemberDeleted,
      )
      ?.forEach((insured) => {
        errors.insuredDetails[insured] = {};
        if (
          values?.insuredDetails[insured]?.title?.toLowerCase() !==
          getDomainData(
            salutationList,
            values.insuredDetails[insured].title,
            'code',
            'code',
          )?.toLowerCase()
        ) {
          errors.insuredDetails[insured].title =
            '* Enter valid title';
        } else if (
          getDomainData(
            salutationList,
            values.insuredDetails[insured].title,
            'code',
            'gender',
          )?.toLowerCase() &&
          values?.insuredDetails[insured]?.gender?.toLowerCase() !==
            getDomainData(
              salutationList,
              values.insuredDetails[insured].title,
              'code',
              'gender',
            )?.toLowerCase() &&
          (getDomainData(
            genderList,
            values.insuredDetails[insured].gender,
            'code',
            'value',
          )?.toLowerCase() === 'male' ||
            getDomainData(
              genderList,
              values.insuredDetails[insured].gender,
              'code',
              'value',
            )?.toLowerCase() === 'female')
        ) {
          errors.insuredDetails[insured].title =
            '* Title mismatch with gender';
        }
        if (!values?.insuredDetails[insured]?.title) {
          errors.insuredDetails[insured].title = '* Required';
        }
        if (!values?.insuredDetails[insured]?.gender) {
          errors.insuredDetails[insured].gender = '* Required';
        }
        if (!values?.insuredDetails[insured]?.maritalStatus) {
          errors.insuredDetails[insured].maritalStatus = '* Required';
        }
        const firstNameValue = characterLimitList?.find(
          (characterLimit) =>
            characterLimit.code.toLowerCase() === 'first name',
        );
        if (!values?.insuredDetails[insured]?.firstName) {
          errors.insuredDetails[insured].firstName = '* Required';
        }
        if (
          values?.insuredDetails[insured]?.firstName?.length >
          parseInt(firstNameValue?.value)
        ) {
          errors.insuredDetails[
            insured
          ].firstName = `* First Name cannot be greater than ${firstNameValue?.value} characters`;
        }
        if (
          values.insuredDetails[insured].firstName &&
          values.insuredDetails[insured].firstName.match(/\d/)
        ) {
          errors.insuredDetails[insured].firstName =
            '* First name cannot be alphanumeric';
        }
        const middleNameValue = characterLimitList?.find(
          (characterLimit) =>
            characterLimit.code.toLowerCase() === 'middle name',
        );
        if (
          values?.insuredDetails[insured]?.middleName?.length >
          parseInt(middleNameValue?.value)
        ) {
          errors.insuredDetails[
            insured
          ].middleName = `* Middle Name cannot be greater than ${middleNameValue?.value} characters`;
        }
        if (
          values.insuredDetails[insured].middleName &&
          values.insuredDetails[insured].middleName.match(/\d/)
        ) {
          errors.insuredDetails[insured].middleName =
            '* Middle name cannot be alphanumeric';
        }
        const lastNameValue = characterLimitList?.find(
          (characterLimit) =>
            characterLimit.code.toLowerCase() === 'last name',
        );
        if (!values?.insuredDetails[insured]?.lastName) {
          errors.insuredDetails[insured].lastName = '* Required';
        }
        if (
          values?.insuredDetails[insured]?.lastName?.length >
          parseInt(lastNameValue?.value)
        ) {
          errors.insuredDetails[
            insured
          ].lastName = `* Last Name cannot be greater than ${lastNameValue?.value} characters`;
        }
        if (
          values.insuredDetails[insured].lastName &&
          values.insuredDetails[insured].lastName.match(/\d/)
        ) {
          errors.insuredDetails[insured].lastName =
            '* Last name cannot be alphanumeric';
        }
        if (!values?.insuredDetails[insured]?.dob) {
          errors.insuredDetails[insured].dob = '* Required';
        }
        if (values?.insuredDetails[insured]?.dob) {
          if (
            moment(
              values?.insuredDetails[insured]?.dob,
              'DD/MM/YYYY',
            ).isAfter()
          ) {
            errors.insuredDetails[insured].dob =
              '* Date of Birth cannot be a future date';
          }
        }
        if (!values?.insuredDetails[insured]?.weight) {
          errors.insuredDetails[insured].weight = '* Required';
        }
        if (!values?.insuredDetails[insured]?.height) {
          errors.insuredDetails[insured].height = '* Required';
        }
      });
    /* Insured Members End */
    /*Nominee form start*/
    Object.keys(values?.nomineeDetails)
      ?.filter(
        (nominee) =>
          !values?.nomineeDetails[nominee]?.isHardDeleted &&
          !values?.insuredDetails[nominee]?.isMemberDeleted,
      )
      ?.forEach((nominee) => {
        errors.nomineeDetails[nominee] = {};

        if (!values?.nomineeDetails[nominee]?.name) {
          errors.nomineeDetails[nominee].name = '* Required';
        }
        if (
          values.nomineeDetails[nominee].name &&
          values.nomineeDetails[nominee].name.match(/\d/)
        ) {
          errors.nomineeDetails[nominee].name =
            '* Name cannot be alphanumeric';
        }
        if (!values?.nomineeDetails[nominee]?.dob) {
          errors.nomineeDetails[nominee].dob = '* Required';
        }
        if (values?.nomineeDetails[nominee]?.dob) {
          if (
            moment(
              values?.nomineeDetails[nominee]?.dob,
              'DD/MM/YYYY',
            ).isAfter()
          ) {
            errors.nomineeDetails[nominee].dob =
              '* Date of Birth cannot be a future date';
          }
        }
        if (
          !values?.nomineeDetails[nominee]?.relationshipWithInsured
        ) {
          errors.nomineeDetails[nominee].relationshipWithInsured =
            '* Required';
        }
        if (
          values?.nomineeDetails[nominee]?.dob &&
          moment(new Date(), 'DD/MM/YYYY').diff(
            moment(values.nomineeDetails[nominee].dob, 'DD/MM/YYYY'),
            'years',
          ) < MINOR_THRESHOLD_AGE
        ) {
          if (!values.nomineeDetails[nominee].nameOfAppointee) {
            errors.nomineeDetails[nominee].nameOfAppointee =
              '* Required';
          }
          if (
            values.nomineeDetails[nominee].nameOfAppointee &&
            values.nomineeDetails[nominee].nameOfAppointee.match(/\d/)
          ) {
            errors.nomineeDetails[nominee].nameOfAppointee =
              '* Name cannot be alphanumeric';
          }
          if (
            !values?.nomineeDetails[nominee]
              ?.relationshipWithAppointee
          ) {
            errors.nomineeDetails[nominee].relationshipWithAppointee =
              '* Required';
          }
        }
      });
    /* Nominee Form End*/
    /* Previous Insured Form Start */
    Object.keys(values?.prevInsuranceDetails)
      ?.filter(
        (prevInsured) =>
          !values?.prevInsuranceDetails[prevInsured]?.isHardDeleted &&
          !values?.insuredDetails[prevInsured]?.isMemberDeleted,
      )
      ?.forEach((prevInsured) => {
        errors.prevInsuranceDetails[prevInsured] = {};
        if (
          (values?.prevInsuranceDetails[prevInsured]
            ?.prevInsurerName ||
            values?.prevInsuranceDetails[prevInsured]?.prevPolicyNo ||
            values?.prevInsuranceDetails[prevInsured]
              ?.prevPolicyStartDate ||
            values?.prevInsuranceDetails[prevInsured]
              ?.prevPolicyEndDate ||
            values?.prevInsuranceDetails[prevInsured]
              ?.prevPolicySI !== '') &&
          !values?.prevInsuranceDetails[prevInsured]?.prevClaimLodged
        ) {
          errors.prevInsuranceDetails[prevInsured].prevClaimLodged =
            '* Required';
        }
        if (
          values?.prevInsuranceDetails[prevInsured]
            ?.prevInsurerName ||
          values?.prevInsuranceDetails[prevInsured]?.prevPolicyNo ||
          values?.prevInsuranceDetails[prevInsured]
            ?.prevPolicyStartDate ||
          values?.prevInsuranceDetails[prevInsured]
            ?.prevPolicyEndDate ||
          values?.prevInsuranceDetails[prevInsured]?.prevPolicySI !==
            '' ||
          values.prevInsuranceDetails[prevInsured].claimAmount !==
            '' ||
          values?.prevInsuranceDetails[prevInsured]?.cbAmount !==
            '' ||
          values?.prevInsuranceDetails[
            prevInsured
          ]?.prevClaimLodged?.toLowerCase() === 'yes'
        ) {
          if (
            !values?.prevInsuranceDetails[prevInsured]
              ?.prevInsurerName
          ) {
            errors.prevInsuranceDetails[prevInsured].prevInsurerName =
              '* Required';
          }
          if (
            values?.prevInsuranceDetails[prevInsured]
              ?.prevInsurerName &&
            values.prevInsuranceDetails[
              prevInsured
            ].prevInsurerName.match(/\d/)
          ) {
            errors.prevInsuranceDetails[prevInsured].prevInsurerName =
              '* Name cannot be alphanumeric';
          }
          if (
            !values?.prevInsuranceDetails[prevInsured]?.prevPolicyNo
          ) {
            errors.prevInsuranceDetails[prevInsured].prevPolicyNo =
              '* Required';
          }
          if (
            !values?.prevInsuranceDetails[prevInsured]
              ?.prevPolicyStartDate
          ) {
            errors.prevInsuranceDetails[
              prevInsured
            ].prevPolicyStartDate = '* Required';
          }
          if (
            values?.prevInsuranceDetails[prevInsured]
              ?.prevPolicyStartDate
          ) {
            if (
              moment(
                values?.prevInsuranceDetails[prevInsured]
                  ?.prevPolicyStartDate,
                'DD/MM/YYYY',
              ).isAfter()
            ) {
              errors.prevInsuranceDetails[
                prevInsured
              ].prevPolicyStartDate = `* Cannot accept future date`;
            } else if (
              values?.prevInsuranceDetails[prevInsured]
                ?.prevPolicyEndDate &&
              moment(
                values?.prevInsuranceDetails[prevInsured]
                  ?.prevPolicyStartDate,
                'DD/MM/YYYY',
              )?.isAfter(
                moment(
                  values?.prevInsuranceDetails[prevInsured]
                    ?.prevPolicyEndDate,
                  'DD/MM/YYYY',
                ),
              )
            ) {
              errors.prevInsuranceDetails[
                prevInsured
              ].prevPolicyStartDate = `* Start Date cannot be after end date`;
            }
          }
          if (
            !values?.prevInsuranceDetails[prevInsured]
              ?.prevPolicyEndDate
          ) {
            errors.prevInsuranceDetails[
              prevInsured
            ].prevPolicyEndDate = '* Required';
          } else if (
            values?.prevInsuranceDetails[prevInsured]
              ?.prevPolicyStartDate &&
            moment(
              values?.prevInsuranceDetails[prevInsured]
                ?.prevPolicyEndDate,
              'DD/MM/YYYY',
            )?.isBefore(
              moment(
                values?.prevInsuranceDetails[prevInsured]
                  ?.prevPolicyStartDate,
                'DD/MM/YYYY',
              ),
            )
          ) {
            errors.prevInsuranceDetails[
              prevInsured
            ].prevPolicyEndDate = `* End Date cannot be before start date`;
          }
          if (
            !values?.prevInsuranceDetails[prevInsured]?.prevPolicySI
          ) {
            errors.prevInsuranceDetails[prevInsured].prevPolicySI =
              '* Required';
          }
          if (
            values.prevInsuranceDetails[prevInsured].prevPolicySI
              ?.toString()
              .startsWith('0')
          ) {
            errors.prevInsuranceDetails[
              prevInsured
            ].prevInsuranceDetails.prevPolicySI =
              '* Sum Insured cannot be equal to or start with 0';
          }
          // if (
          //   !values?.prevInsuranceDetails[prevInsured]?.prevClaimLodged
          // ) {
          //   errors.prevInsuranceDetails[prevInsured].prevClaimLodged =
          //     '* Required';
          // }
          if (
            values.prevInsuranceDetails[
              prevInsured
            ].prevClaimLodged?.toLowerCase() === 'yes' &&
            !values.prevInsuranceDetails[prevInsured].claimAmount
          ) {
            errors.prevInsuranceDetails[prevInsured].claimAmount =
              '* Required';
          }
          if (
            values.prevInsuranceDetails[
              prevInsured
            ].prevClaimLodged?.toLowerCase() === 'yes' &&
            values.prevInsuranceDetails[prevInsured].claimAmount
              ?.toString()
              ?.startsWith('0')
          ) {
            errors.prevInsuranceDetails[prevInsured].claimAmount =
              '* Claim Amount cannot be equal to or start with 0';
          }
          if (
            values.prevInsuranceDetails[
              prevInsured
            ].prevClaimLodged?.toLowerCase() === 'yes' &&
            !values?.prevInsuranceDetails[prevInsured]?.cbAmount
          ) {
            errors.prevInsuranceDetails[prevInsured].cbAmount =
              '* Required';
          }
          if (
            values.prevInsuranceDetails[
              prevInsured
            ].prevClaimLodged?.toLowerCase() === 'yes' &&
            values.prevInsuranceDetails[prevInsured].cbAmount
              ?.toString()
              ?.startsWith('0')
          ) {
            errors.prevInsuranceDetails[prevInsured].cbAmount =
              '* Cumulative Bonus Amt cannot be equal to or start with 0';
          }
        }
      });
    /* Previous Insured Form End */
    if (!props?.forwardedPremiumFormRef?.current?.values?.planName) {
      errors.planName = '* Required';
      errorCount += 1;
    }
    if (
      props?.forwardedPremiumFormRef?.current?.values?.coverType
        ?.toString()
        ?.toLowerCase() === 'floater basis' &&
      !isNaN(
        parseInt(
          maxInsuredLimitList?.find(
            (coverLimit) =>
              coverLimit?.code?.toString()?.toLowerCase() ===
              'floater basis',
          )?.value,
        ),
      ) &&
      Object.keys(values?.insuredDetails)?.filter(
        (insured) =>
          !values?.insuredDetails[insured]?.isHardDeleted &&
          !values?.insuredDetails[insured]?.isMemberDeleted,
      )?.length >
        parseInt(
          maxInsuredLimitList?.find(
            (coverLimit) =>
              coverLimit?.code?.toString()?.toLowerCase() ===
              'floater basis',
          )?.value,
        )
    ) {
      errors.memberLimit = `* Insured members cannot be more than ${
        maxInsuredLimitList?.find(
          (coverLimit) =>
            coverLimit?.code?.toString()?.toLowerCase() ===
            'floater basis',
        )?.value
      }`;
      errorCount += 1;
    } else if (
      props?.forwardedPremiumFormRef?.current?.values?.coverType
        ?.toString()
        ?.toLowerCase() === 'individual basis' &&
      !isNaN(
        parseInt(
          maxInsuredLimitList?.find(
            (coverLimit) =>
              coverLimit?.code?.toString()?.toLowerCase() ===
              'individual basis',
          )?.value,
        ),
      ) &&
      Object.keys(values?.insuredDetails)?.filter(
        (insured) =>
          !values?.insuredDetails[insured]?.isHardDeleted &&
          !values?.insuredDetails[insured]?.isMemberDeleted,
      )?.length >
        parseInt(
          maxInsuredLimitList?.find(
            (coverLimit) =>
              coverLimit?.code?.toString()?.toLowerCase() ===
              'individual basis',
          )?.value,
        )
    ) {
      errors.memberLimit = `* Insured members cannot be more than ${
        maxInsuredLimitList?.find(
          (coverLimit) =>
            coverLimit?.code?.toString()?.toLowerCase() ===
            'individual basis',
        )?.value
      }`;
      errorCount += 1;
    }
    if (
      !props?.forwardedPremiumFormRef?.current?.values?.totalPremium
    ) {
      errors.totalPremium = '* Required';
      errorCount += 1;
    }
    if (
      !props?.forwardedPremiumFormRef?.current?.values
        ?.isPlansAndCoversEditable
    ) {
      errors.isPlansAndCoversEditable =
        '* Data should be saved before proceeding';
      errorCount += 1;
    }
    errorCount += Object.keys(errors.proposerDetails).length;
    Object.keys(errors.insuredDetails)
      ?.filter(
        (insured) => !values?.insuredDetails[insured]?.isHardDeleted,
      )
      ?.forEach((insured) => {
        errorCount += Object.keys(
          errors.insuredDetails[`${insured}`],
        ).length;
      });
    Object.keys(errors.nomineeDetails)
      ?.filter(
        (nominee) => !values?.nomineeDetails[nominee]?.isHardDeleted,
      )
      ?.forEach((nominee) => {
        errorCount += Object.keys(
          errors.nomineeDetails[`${nominee}`],
        ).length;
      });
    Object.keys(errors.prevInsuranceDetails)
      ?.filter(
        (prevInsured) =>
          !values?.prevInsuranceDetails[prevInsured]?.isHardDeleted,
      )
      ?.forEach((prevInsured) => {
        errorCount += Object.keys(
          errors.prevInsuranceDetails[`${prevInsured}`],
        ).length;
      });
    Object.keys(errors.intermediaryData)?.forEach((intermediary) => {
      errorCount += 1;
    });
    for (
      let i = 0;
      i < Object.keys(values?.medicalUnderwriting)?.length;
      i++
    ) {
      const member = Object.keys(values?.medicalUnderwriting)[i];
      const masterQuestion = productQuestionList?.find(
        (question) =>
          question?.srNo?.toString()?.toLowerCase() === 'master',
      );
      if (
        values?.medicalUnderwriting[`${member}`][
          'MASTER'
        ]?.checkboxAnswer
          ?.toString()
          ?.toLowerCase() === 'no'
      ) {
        // if (
        //   !productQuestionList
        //     ?.filter((question) =>
        //       masterQuestion?.childQuesNo?.includes(question?.srNo),
        //     )
        //     ?.find(
        //       (question) =>
        //         (question?.condToChild === null &&
        //           (values?.medicalUnderwriting[`${member}`][
        //             `${question?.srNo}`
        //           ]?.textareaAnswer ||
        //             values?.medicalUnderwriting[`${member}`][
        //               `${question?.srNo}`
        //             ]?.checkboxAnswer
        //               ?.toString()
        //               ?.toLowerCase() === 'yes')) ||
        //         (question?.condToChild &&
        //           values?.medicalUnderwriting[`${member}`][
        //             `${question?.srNo}`
        //           ]?.checkboxAnswer
        //             ?.toString()
        //             ?.toLowerCase() === 'yes') ||
        //         (question?.condToChild === false &&
        //           values?.medicalUnderwriting[`${member}`][
        //             `${question?.srNo}`
        //           ]
        //             ?.toString()
        //             ?.toLowerCase() === 'no'),
        //     )
        // ) {
        //   errors.medicalUnderwritingMasterQuestion = `* Medical Questionaire is not complete for ${member}.`;
        //   errorCount += 1;
        //   break;
        // }
        productQuestionList
          ?.filter(
            (question) =>
              question?.srNo?.toString()?.toLowerCase() !==
                'master' &&
              question?.isParent &&
              ((question?.condToChild === true &&
                values?.medicalUnderwriting[`${member}`][
                  `${question?.srNo}`
                ]?.checkboxAnswer
                  ?.toString()
                  ?.toLowerCase() === 'yes') ||
                (question?.condToChild === false &&
                  values?.medicalUnderwriting[`${member}`][
                    `${question?.srNo}`
                  ]?.checkboxAnswer
                    ?.toString()
                    ?.toLowerCase() === 'no')),
          )
          ?.forEach((question) => {
            question?.childQuesNo?.forEach((childQuestion) => {
              if (
                values?.medicalUnderwriting[`${member}`][
                  `${childQuestion}`
                ]?.checkboxAnswer
                  ?.toString()
                  ?.toLowerCase() === 'no' &&
                !values?.medicalUnderwriting[`${member}`][
                  `${childQuestion}`
                ]?.textareaAnswer
              ) {
                if (!errors?.medicalUnderwriting) {
                  errors = {
                    ...errors,
                    medicalUnderwriting: {
                      [`${member}`]: {},
                    },
                  };
                }
                if (childQuestion?.isChkReq) {
                  errorCount += 1;
                  errors.medicalUnderwriting[`${member}`][
                    `${childQuestion}`
                  ] = { checkboxAnswer: `* Required` };
                } else {
                  errorCount += 1;
                  errors.medicalUnderwriting[`${member}`][
                    `${childQuestion}`
                  ] = { textareaAnswer: `* Required` };
                }
              }
            });
          });
      }
    }
    if (errorCount === 0) {
      return {};
    }
    return errors;
  };

  const getDomainDataStrict = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find(
      (d) =>
        d[`${searchType}`]?.toString()?.toLowerCase() ===
        searchText?.toString()?.toLowerCase(),
    )
      ? domainArr.find(
          (d) =>
            d[`${searchType}`]?.toString()?.toLowerCase() ===
            searchText?.toString()?.toLowerCase(),
        )[`${returnType}`]
      : '';
  };

  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find(
      (d) =>
        d[`${searchType}`]?.toString()?.toLowerCase() ===
        searchText?.toString()?.toLowerCase(),
    )
      ? domainArr.find(
          (d) =>
            d[`${searchType}`]?.toString()?.toLowerCase() ===
            searchText?.toString()?.toLowerCase(),
        )[`${returnType}`]
      : searchText === null || searchText === undefined
      ? ''
      : `${searchText}`;
  };

  const reformData = (val, returnType, isString) => {
    return val && val.toString().trim() !== ''
      ? isString === undefined || isString === true
        ? `${val}`
        : val
      : returnType;
  };

  const RenewReviewForm = ({ validate }) => {
    const { values, setFieldValue } = useQuantaFormikContext();
    const [alerts, setAlerts] = useState([]);
    const [valueChanges, setValueChanges] = useState(values);
    const [proposerDetailsCardToggle, setProposerDetailsCardToggle] =
      useState(true);
    const [insuredDetailsCardToggle, setInsuredDetailsCardToggle] =
      useState(true);
    const [nomineeDetailsCardToggle, setNomineeDetailsCardToggle] =
      useState(true);
    const [
      prevInsuredDetailsCardToggle,
      setPrevInsuredDetailsCardToggle,
    ] = useState(true);
    const [RenewalMandateCardToggle, setRenewalMandateCardToggle] =
      useState(true);
    const [loadingPermCustAddr, setLoadingPermCustAddr] =
      useState(false);
    const [loadingCommCustAddr, setLoadingCommCustAddr] =
      useState(false);

    const [filteredMemberList, setFilteredMemberList] = useState([]);
    const [modalAddMemberDisplay, setModalAddMemberDisplay] =
      useState(false);
    const [
      medicalQuestionaireDisplay,
      setMedicalQuestionaireDisplay,
    ] = useState(false);

    const [
      medicalUnderwritingDataBeforeEdit,
      setMedicalUnderwritingDataBeforeEdit,
    ] = useState(null);

    const [loadingFieldUserList, setLoadingFieldUserList] =
      useState(false);
    const [errorFieldUserList, setErrorFieldUserList] =
      useState(null);
    const [
      intermediaryDetailsCardToggle,
      setIntermediaryDetailsCardToggle,
    ] = useState(true);

    useEffect(() => {
      if (
        props?.forwardedAlertsRef?.current &&
        props?.forwardedAlertsRef?.current?.length > 0
      ) {
        setAlerts([]);
      }
    }, [props?.forwardedAlertsRef?.current]);
    useEffect(() => {
      let isMounted = true;
      if (
        values?.intermediaryData?.initFetchFieldUserListRequired &&
        isMounted
      ) {
        const fieldUserQuery = fetchQuery({
          query: GET_FIELDUSER_LIST,
          fetchPolicy: 'network-only',
          variables: {
            input: {
              intermediaryCode:
                values?.intermediaryData?.intermediary,
              officeId: values?.intermediaryData?.businessLocation,
            },
          },
        });
        if (
          isMounted &&
          values?.intermediaryData?.initFetchFieldUserListRequired
        ) {
          setLoadingFieldUserList(true);
        }

        fieldUserQuery
          .then((result) => {
            if (loadingFieldUserList) {
              setLoadingFieldUserList(false);
            }
            if (
              isMounted &&
              values?.intermediaryData?.initFetchFieldUserListRequired
            ) {
              setLoadingFieldUserList(false);
              setErrorFieldUserList(null);
              setFieldValue(
                `intermediaryData.fieldUserList`,
                result?.data?.getFiledUserByIMID,
              );
              setFieldValue(
                `intermediaryData.initFetchFieldUserListRequired`,
                false,
              );
              if (
                !values?.intermediaryData?.fieldUser &&
                viewRenewPolicy?.intermediaryDetails?.fieldUserCode &&
                values?.intermediaryData?.intermediary
                  ?.toString()
                  ?.toLowerCase() ===
                  viewRenewPolicy?.intermediaryDetails?.code
                    ?.toString()
                    ?.toLowerCase() &&
                values?.intermediaryData?.businessLocation
                  ?.toString()
                  ?.toLowerCase() ===
                  viewRenewPolicy?.intermediaryDetails?.location
                    ?.toString()
                    ?.toLowerCase()
              ) {
                setFieldValue(
                  `intermediaryData.fieldUser`,
                  viewRenewPolicy?.intermediaryDetails?.fieldUserCode,
                );
              }
            }
          })
          .catch((error) => {
            if (loadingFieldUserList) {
              setLoadingFieldUserList(false);
            }
            if (
              isMounted &&
              values?.intermediaryData?.initFetchFieldUserListRequired
            ) {
              setFieldValue(
                `intermediaryData.initFetchFieldUserListRequired`,
                false,
              );
              setLoadingFieldUserList(false);
              setErrorFieldUserList(error?.message);
            }
          });
      }
      return () => {
        isMounted = false;
      };
    }, [
      values?.intermediaryData?.intermediary,
      values?.intermediaryData?.businessLocation,
      values?.intermediaryData?.initFetchFieldUserListRequired,
    ]);

    useEffect(() => {
      getMemberList();
      setProposerDetailsCardToggle(
        !expandedCard?.current?.find(
          (exp) => exp?.cardName === 'proposerDetails',
        )?.cardFlag,
      );
      setInsuredDetailsCardToggle(
        !expandedCard?.current?.find(
          (exp) => exp?.cardName === 'insuredDetails',
        )?.cardFlag,
      );
      setNomineeDetailsCardToggle(
        !expandedCard?.current?.find(
          (exp) => exp?.cardName === 'nomineeDetails',
        )?.cardFlag,
      );
      setPrevInsuredDetailsCardToggle(
        !expandedCard?.current?.find(
          (exp) => exp?.cardName === 'prevInsuredDetails',
        )?.cardFlag,
      );
      setRenewalMandateCardToggle(
        !expandedCard?.current?.find(
          (exp) => exp?.cardName === 'RenewalMandate',
        )?.cardFlag,
      );
    }, [
      applicableMemberTypes,
      Object.keys(values?.insuredDetails)?.length,
      expandedCard?.current,
      expandedCard?.current?.find(
        (exp) => exp?.cardName === 'proposerDetails',
      )?.cardFlag,
      expandedCard?.current?.find(
        (exp) => exp?.cardName === 'insuredDetails',
      )?.cardFlag,
      expandedCard?.current?.find(
        (exp) => exp?.cardName === 'nomineeDetails',
      )?.cardFlag,
      expandedCard?.current?.find(
        (exp) => exp?.cardName === 'prevInsuredDetails',
      )?.cardFlag,
      expandedCard?.current?.find(
        (exp) => exp?.cardName === 'RenewalMandate',
      )?.cardFlag,
    ]);

    const getMemberList = () => {
      if (
        values?.insuredDetails &&
        applicableMemberTypes &&
        applicableMemberTypes?.length > 0
      ) {
        setFilteredMemberList(
          applicableMemberTypes?.filter(
            (memberType) =>
              memberType?.maxAllowed >
              Object.keys(values?.insuredDetails)
                ?.filter(
                  (insured) =>
                    !values?.insuredDetails[insured]?.isHardDeleted,
                )
                ?.filter((insured) =>
                  insured
                    ?.toString()
                    ?.toLowerCase()
                    ?.startsWith(
                      memberType?.label?.toString()?.toLowerCase(),
                    ),
                )?.length,
          ),
        );
      }
    };

    const onPermAddrLookup = async (val, setFieldValue) => {
      if (
        !(
          val.toString().length !== 6 ||
          !val.toString().match(/^[0-9]+$/)
        )
      ) {
        let queryOutput = fetchQuery({
          query: PINCODE_LOOKUP,
          variables: {
            filter: {
            pincode: val,
            },
          },
        });
        try {
          setAlerts([]);
          if (
            props.forwardedAlertsRef &&
            props.forwardedAlertsRef.current
          ) {
            props.forwardedAlertsRef.current = [];
          }
          setLoadingPermCustAddr(true);
          let { data } = await queryOutput;
          setLoadingPermCustAddr(false);
          setFieldValue(
            'proposerDetails.permCityTownVillage',
            data?.pincodeInfo?.city,
          );
          setFieldValue(
            'proposerDetails.permDistrict',
            data?.pincodeInfo?.district,
          );
          setFieldValue(
            'proposerDetails.permState',
            data?.pincodeInfo?.state,
          );
          if (values?.proposerDetails?.permCommAddressYN) {
            setFieldValue(
              'proposerDetails.commCityTownVillage',
              data?.pincodeInfo?.city,
            );
            setFieldValue(
              'proposerDetails.commDistrict',
              data?.pincodeInfo?.district,
            );
            setFieldValue(
              'proposerDetails.commState',
              data?.pincodeInfo?.state,
            );
          }
        } catch (error) {
          setAlerts([
            {
              header: 'Address fetch failed',
              id: alerts?.length + 1,
              content: (
                <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                  <span>{error?.message}</span>
                </div>
              ),
              type: 'error',
              timeout: null,
              disableClose: false,
            },
          ]);
          setLoadingPermCustAddr(false);
          setFieldValue('proposerDetails.permCityTownVillage', '');
          setFieldValue('proposerDetails.permDistrict', '');
          setFieldValue('proposerDetails.permState', '');
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    };

    const onCommAddrLookup = async (val, setFieldValue) => {
      if (
        !(
          val.toString().length !== 6 ||
          !val.toString().match(/^[0-9]+$/)
        )
      ) {
        let queryOutput = fetchQuery({
          query: PINCODE_LOOKUP,
          variables: {
            filter: {
            pincode: val,
            },
          },
        });
        try {
          setAlerts([]);
          if (
            props.forwardedAlertsRef &&
            props.forwardedAlertsRef.current
          ) {
            props.forwardedAlertsRef.current = [];
          }
          setLoadingCommCustAddr(true);
          let { data } = await queryOutput;
          setLoadingCommCustAddr(false);
          setFieldValue(
            'proposerDetails.commCityTownVillage',
            data?.pincodeInfo?.city,
          );
          setFieldValue(
            'proposerDetails.commDistrict',
            data?.pincodeInfo?.district,
          );
          setFieldValue(
            'proposerDetails.commState',
            data?.pincodeInfo?.state,
          );
        } catch (error) {
          setAlerts([
            {
              header: 'Address fetch failed',
              id: alerts?.length + 1,
              content: (
                <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                  <span>{error?.message}</span>
                </div>
              ),
              type: 'error',
              timeout: null,
              disableClose: false,
            },
          ]);
          setLoadingCommCustAddr(false);
          setFieldValue('proposerDetails.commCityTownVillage', '');
          setFieldValue('proposerDetails.commDistrict', '');
          setFieldValue('proposerDetails.commState', '');
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    };

    const intermediaryDetailsData = [
      {
        grid_type: 'input',
        title: (
          <Text
            severity={'info'}
            className={'font-semibold'}
            type={'normal'}
          >
            Intermediary
          </Text>
        ),
        clickToEdit: true,
        initDisplayEdit: viewRenewPolicy?.isProposalRenewed
          ? false
          : expandedCard.current
              .find((exp) => exp?.cardName === 'intermediaryDetails')
              ?.subSections?.includes(
                'intermediaryCodeLocationFieldUserDetails',
              ),
        onValueChanges: (values) => {
          setValueChanges(values);
        },
        editDisplayDisabled:
          viewRenewPolicy?.isProposalRenewed ||
          renewalFlag?.toString()?.toLowerCase() === 'expired' ||
          typeName?.toString()?.trim()?.toLowerCase() ===
            'field user',
        onEdit: (_) => {
          setEnableRenew(false);
          setFieldValue(`countEditsOpen`, values?.countEditsOpen + 1);
          expandedCard.current = [
            ...expandedCard.current.filter(
              (exp) => exp?.cardName !== 'intermediaryDetails',
            ),
            {
              ...expandedCard.current.find(
                (exp) => exp?.cardName === 'intermediaryDetails',
              ),
              cardFlag: true,
              subSections: [
                ...expandedCard.current.find(
                  (exp) => exp?.cardName === 'intermediaryDetails',
                )?.subSections,
                'intermediaryCodeLocationFieldUserDetails',
              ],
            },
          ];
          if (
            props.forwardedAlertsRef &&
            props.forwardedAlertsRef.current
          ) {
            props.forwardedAlertsRef.current = [];
          }
          updateViewRenewPolicy({
            isProposalReadyForRenewal: false,
          });
          setIntermediaryDetailsCardToggle(false);
        },
        onCancel: (_, valuesBeforeEdit) => {
          if (values?.countEditsOpen === 1) {
            updateViewRenewPolicy({
              isProposalReadyForRenewal: true,
            });
            setEnableRenew(true);
          }
          setFieldValue(`countEditsOpen`, values?.countEditsOpen - 1);
          setFieldValue(
            'intermediaryData.intermediary',
            valuesBeforeEdit?.intermediaryData?.intermediary,
          );
          setFieldValue(
            'intermediaryData.businessLocation',
            valuesBeforeEdit?.intermediaryData?.businessLocation,
          );
          setFieldValue(
            'intermediaryData.fieldUser',
            valuesBeforeEdit?.intermediaryData?.fieldUser,
          );
          expandedCard.current = [
            ...expandedCard.current.filter(
              (exp) => exp?.cardName !== 'intermediaryDetails',
            ),
            {
              ...expandedCard.current.find(
                (exp) => exp?.cardName === 'intermediaryDetails',
              ),
              cardFlag: false,
              subSections: [
                ...expandedCard.current
                  .find(
                    (exp) => exp?.cardName === 'intermediaryDetails',
                  )
                  ?.subSections?.filter(
                    (subSection) =>
                      subSection !==
                      'intermediaryCodeLocationFieldUserDetails',
                  ),
              ],
            },
          ];
          if (
            props.forwardedAlertsRef &&
            props.forwardedAlertsRef.current
          ) {
            props.forwardedAlertsRef.current = [];
          }
          setIntermediaryDetailsCardToggle(true);
        },
        onSave: (_) => {
          if (values?.countEditsOpen === 1) {
          updateViewRenewPolicy({
            isProposalReadyForRenewal: true,
          });
            setEnableRenew(true);
          }
          setFieldValue(`countEditsOpen`, values?.countEditsOpen - 1);
          expandedCard.current = [
            ...expandedCard.current.filter(
              (exp) => exp?.cardName !== 'intermediaryDetails',
            ),
            {
              ...expandedCard.current.find(
                (exp) => exp?.cardName === 'intermediaryDetails',
              ),
              cardFlag: false,
              subSections: [
                ...expandedCard.current
                  .find(
                    (exp) => exp?.cardName === 'intermediaryDetails',
                  )
                  ?.subSections?.filter(
                    (subSection) =>
                      subSection !==
                      'intermediaryCodeLocationFieldUserDetails',
                  ),
              ],
            },
          ];
          if (
            props.forwardedAlertsRef &&
            props.forwardedAlertsRef.current
          ) {
            props.forwardedAlertsRef.current = [];
          }
          setIntermediaryDetailsCardToggle(true);
        },
        disableSubmit:
          (validate(values)?.intermediaryData !== undefined &&
            Object.keys(validate(values)?.intermediaryData)?.length >
              0) ||
          loadingFieldUserList ||
          values?.isCalculatingPremium,
        disableEdit: values?.isCalculatingPremium || 
        viewRenewPolicy?.proposalStatus ==='Renewal Collected',
        disableCancel: values?.isCalculatingPremium,
        resetOnCancel: false,
        isBorderRequired: true,
        borderClassName: 'border-b border-neutral pb-4',
        grid_data: [
          {
            type: 'select',
            name: 'intermediaryData.intermediary',
            // disabled:
            //   viewRenewPolicy?.isProposalRenewed ||
            //   values?.isCalculatingPremium,
            disabled: true,
            label: (
              <div>
                Intermediary Name <Text severity={'error'}>*</Text>
              </div>
            ),
            labelReadOnly: 'Intermediary Name',
            readOnlyValue: getDomainDataStrict(
              myIntermediaries,
              values?.intermediaryData?.intermediary,
              'intermediaryCode',
              'intermediaryName',
            )
              ? getDomainDataStrict(
                  myIntermediaries,
                  values?.intermediaryData?.intermediary,
                  'intermediaryCode',
                  'intermediaryName',
                )
              : null,
            data:
              myIntermediaries && myIntermediaries?.length > 0
                ? myIntermediaries?.map((intermediary) => {
                    return {
                      label: intermediary?.intermediaryName
                        ? `${intermediary?.intermediaryName}`
                        : '',
                      value: intermediary?.intermediaryCode
                        ? `${intermediary?.intermediaryCode}`
                        : '',
                    };
                  })
                : [],
            onDataChange: async (val, _) => {
              try {
                setFieldValue(`intermediaryData.fieldUserList`, []);
                setErrorFieldUserList(null);
                setFieldValue(
                  `intermediaryData.businessLocation`,
                  myIntermediaries?.find(
                    (intermediary) =>
                      intermediary?.intermediaryCode
                        ?.toString()
                        ?.toLowerCase() ===
                      val?.toString()?.toLowerCase(),
                  )?.businessLocations[0]?.code,
                );
                setFieldValue(`intermediaryData.fieldUser`, '');
                const fieldUserQuery = fetchQuery({
                  query: GET_FIELDUSER_LIST,
                  variables: {
                    input: {
                      intermediaryCode: `${val}`,
                      officeId: myIntermediaries?.find(
                        (intermediary) =>
                          intermediary?.intermediaryCode
                            ?.toString()
                            ?.toLowerCase() ===
                          val?.toString()?.toLowerCase(),
                      )?.businessLocations[0]?.code,
                    },
                  },
                });
                setLoadingFieldUserList(true);
                const { data: fieldUserListData } =
                  await fieldUserQuery;
                setLoadingFieldUserList(false);
                setFieldValue(
                  `intermediaryData.fieldUserList`,
                  fieldUserListData?.getFiledUserByIMID,
                );
              } catch (error) {
                setLoadingFieldUserList(false);
                setErrorFieldUserList(error?.message);
                setFieldValue(`intermediaryData.fieldUserList`, []);
              }
            },
          },
          {
            type: 'select',
            name: 'intermediaryData.businessLocation',
            disabled:
              viewRenewPolicy?.isProposalRenewed ||
              values?.isCalculatingPremium,
            label: (
              <div>
                Business Location <Text severity={'error'}>*</Text>
              </div>
            ),
            labelReadOnly: 'Business Location',
            readOnlyValue: !values?.intermediaryData?.businessLocation
              //SA42485
               //? viewRenewPolicy?.intermediaryDetails?.location
              ? myIntermediaries
                  ?.find(
                    (intermediary) =>
                      intermediary?.intermediaryCode
                        ?.toString()
                        ?.toLowerCase() ===
                        viewRenewPolicy?.intermediaryDetails?.code
                          ?.toString()
                          ?.toLowerCase() &&
                      intermediary?.businessLocations?.find(
                        (businessLocation) =>
                          (businessLocation?.code
                            ?.toString()
                            ?.toLowerCase()).substring(1) ===
                            viewRenewPolicy?.intermediaryDetails?.location
                            ?.toString()
                            ?.toLowerCase(),
                      ),
                  )
                  ?.businessLocations?.find(
                    (businessLocation) =>
                    (businessLocation?.code
                      ?.toString()
                      ?.toLowerCase()).substring(1) ===
                      viewRenewPolicy?.intermediaryDetails?.location
                        ?.toString()
                        ?.toLowerCase(),
                  )?.name
              //EA42485
              : myIntermediaries?.find(
                  (intermediary) =>
                    intermediary?.intermediaryCode
                      ?.toString()
                      ?.toLowerCase() ===
                      values?.intermediaryData?.intermediary
                        ?.toString()
                        ?.toLowerCase() &&
                    intermediary?.businessLocations?.find(
                      (businessLocation) =>
                        businessLocation?.code
                          ?.toString()
                          ?.toLowerCase() ===
                        values?.intermediaryData?.businessLocation
                          ?.toString()
                          ?.toLowerCase(),
                    ),
                )
              ? myIntermediaries
                  ?.find(
                    (intermediary) =>
                      intermediary?.intermediaryCode
                        ?.toString()
                        ?.toLowerCase() ===
                        values?.intermediaryData?.intermediary
                          ?.toString()
                          ?.toLowerCase() &&
                      intermediary?.businessLocations?.find(
                        (businessLocation) =>
                          businessLocation?.code
                            ?.toString()
                            ?.toLowerCase() ===
                          values?.intermediaryData?.businessLocation
                            ?.toString()
                            ?.toLowerCase(),
                      ),
                  )
                  ?.businessLocations?.find(
                    (businessLocation) =>
                      businessLocation?.code
                        ?.toString()
                        ?.toLowerCase() ===
                      values?.intermediaryData?.businessLocation
                        ?.toString()
                        ?.toLowerCase(),
                  )?.name
              : '',
            data:
              myIntermediaries && myIntermediaries?.length > 0
                ? myIntermediaries
                    ?.find(
                      (intermediary) =>
                        intermediary?.intermediaryCode
                          ?.toString()
                          ?.toLowerCase() ===
                        values?.intermediaryData?.intermediary
                          ?.toString()
                          ?.toLowerCase(),
                    )
                    ?.businessLocations?.map((businessLocation) => {
                      return {
                        label: businessLocation?.name
                          ? `${businessLocation?.name}`
                          : businessLocation?.code
                          ? `${businessLocation?.code}`
                          : '',
                        value: businessLocation?.code
                          ? `${businessLocation?.code}`
                          : '',
                      };
                    })
                : [],
            onDataChange: async (val, _) => {
              try {
                setFieldValue(`intermediaryData.fieldUserList`, []);
                setFieldValue(`intermediaryData.fieldUser`, '');
                setErrorFieldUserList(null);
                const fieldUserQuery = fetchQuery({
                  query: GET_FIELDUSER_LIST,
                  variables: {
                    input: {
                      intermediaryCode: `${values?.intermediaryData?.intermediary}`,
                      officeId: `${val}`,
                    },
                  },
                });
                setLoadingFieldUserList(true);
                const { data: fieldUserListData } =
                  await fieldUserQuery;
                setLoadingFieldUserList(false);
                setFieldValue(
                  `intermediaryData.fieldUserList`,
                  fieldUserListData?.getFiledUserByIMID,
                );
              } catch (error) {
                setErrorFieldUserList(error?.message);
                setLoadingFieldUserList(false);
                setFieldValue(`intermediaryData.fieldUserList`, []);
              }
            },
          },
          loadingFieldUserList
            ? {
                type: 'render',
                component: () => {
                  return (
                    <Label
                      severity={'none'}
                      text={
                        <div>
                          Field User <Text severity={'error'}></Text>
                        </div>
                      }
                    >
                      <Loading
                        textSize="normal"
                        className="flex justify-start items-center space-x-2 text-opacity-50 text-primary w-full"
                      />
                    </Label>
                  );
                },
              }
            : // : errorFieldUserList
              // ? {
              //     type: 'render',
              //     component: () => {
              //       return (
              //         <Label
              //           severity={'none'}
              //           text={
              //             <div>
              //               Field User <Text severity={'error'}>*</Text>
              //             </div>
              //           }
              //         >
              //           <Error
              //             className="flex justify-start items-center space-x-2 text-base text-opacity-50 text-red-600 w-full"
              //             error={errorFieldUserList}
              //           />
              //         </Label>
              //       );
              //     },
              //   }
              {
                type: 'select',
                name: 'intermediaryData.fieldUser',
                disabled:
                  viewRenewPolicy?.isProposalRenewed ||
                  values?.isCalculatingPremium,
                label: (
                  <div>
                    Field User <Text severity={'error'}></Text>
                  </div>
                ),
                labelReadOnly: 'Field User',
                readOnlyValue:
                  values?.intermediaryData?.fieldUserList &&
                  getDomainDataStrict(
                    values?.intermediaryData?.fieldUserList,
                    values?.intermediaryData?.fieldUser,
                    'fieldUserCode',
                    'fieldUserName',
                  )
                    ? getDomainDataStrict(
                        values?.intermediaryData?.fieldUserList,
                        values?.intermediaryData?.fieldUser,
                        'fieldUserCode',
                        'fieldUserName',
                      )
                    : '',
                data:
                  values?.intermediaryData?.fieldUserList &&
                  values?.intermediaryData?.fieldUserList?.length > 0
                    ? values?.intermediaryData?.fieldUserList?.map(
                        (fieldUser) => {
                          return {
                            label: fieldUser?.fieldUserName
                              ? `${fieldUser?.fieldUserName}`
                              : '',
                            code: fieldUser?.fieldUserCode
                              ? `${fieldUser?.fieldUserCode}`
                              : '',
                          };
                        },
                      )
                    : [],
              },
        ]?.filter((d) => d),
      },
    ];
    //SA42485
    (productCode==='2885')?
    values.intermediaryData.businessLocation=myIntermediaries
                  ?.find(
                    (intermediary) =>
                      intermediary?.intermediaryCode
                        ?.toString()
                        ?.toLowerCase() ===
                        viewRenewPolicy?.intermediaryDetails?.code
                          ?.toString()
                          ?.toLowerCase() &&
                      intermediary?.businessLocations?.find(
                        (businessLocation) =>
                          (businessLocation?.code
                            ?.toString()
                            ?.toLowerCase()).substring(1) ===
                            viewRenewPolicy?.intermediaryDetails?.location
                            ?.toString()
                            ?.toLowerCase(),
                      ),
                  )
                  ?.businessLocations?.find(
                    (businessLocation) =>
                    (businessLocation?.code
                      ?.toString()
                      ?.toLowerCase()).substring(1) ===
                      viewRenewPolicy?.intermediaryDetails?.location
                        ?.toString()
                        ?.toLowerCase(),
                  )?.code:"";
    //EA42485
    const insuredDetailsData = [
      ...(Object.keys(values?.insuredDetails)?.length > 0
        ? Object.keys(values?.insuredDetails)?.map((insured, idx) => {
            return {
              title: (
                <Text
                  type="normal"
                  className={`${
                    values?.insuredDetails[insured]?.isMemberDeleted
                      ? 'text-neutral-darker'
                      : ''
                  }`}
                >
                  {insured}
                </Text>
              ),
              grid_type: 'input',
              isBorderRequired: idx !== 0,
              disableSubmit:
                values?.planLoading ||
                values?.isCalculatingPremium ||
                values?.insuredDetails[insured]?.isHardDeleted ||
                values?.insuredDetails[insured]?.isMemberDeleted
                  ? true
                  : Object.keys(validate(values))?.length > 0 &&
                    Object.keys(
                      validate(values)?.insuredDetails[insured],
                    ).length > 0,
              borderClassName: 'border-t-2 border-neutral pt-4',
              clickToEdit: true,
              resetOnCancel: false,
              isSectionDeleted:
                values?.insuredDetails[insured]?.isHardDeleted,
              isDeleteRequired:
                !viewRenewPolicy?.isProposalRenewed &&
                renewalFlag?.toString()?.toLowerCase() !==
                  'expired' &&
                Object.keys(values?.insuredDetails)?.filter(
                  (ins) =>
                    !values?.insuredDetails[ins]?.isMemberDeleted &&
                    !values?.insuredDetails[ins]?.isHardDeleted,
                )?.length > 1
                  ? true
                  : false,
              onValueChanges: (values) => {
                setValueChanges(values);
              },
              displayEditExternal: displayEditExternals?.find((d)=>d === insured) ? true: false,
              onEdit: (_) => {
                setEnableRenew(false);
                setFieldValue(
                  `countEditsOpen`,
                  values?.countEditsOpen + 1,
                );
                expandedCard.current = [
                  ...expandedCard.current.filter(
                    (exp) => exp?.cardName !== 'insuredDetails',
                  ),
                  {
                    ...expandedCard.current.find(
                      (exp) => exp?.cardName === 'insuredDetails',
                    ),
                    cardFlag: true,
                    subSections: [
                      ...expandedCard?.current?.find(
                        (exp) => exp?.cardName === 'insuredDetails',
                      )?.subSections,
                      `${insured}`,
                    ],
                  },
                ];
                if (
                  props.forwardedAlertsRef &&
                  props.forwardedAlertsRef.current
                ) {
                  props.forwardedAlertsRef.current = [];
                }
                updateViewRenewPolicy({
                  isProposalReadyForRenewal: false,
                });
                setInsuredDetailsCardToggle(false);
                // setEnableRenew(false);
                setDisplayEditExtenals([...displayEditExternals,insured]);
              },
              onDelete: (_, valuesBeforeEdit) => {
                setAlerts([]);
                if (
                  props.forwardedAlertsRef &&
                  props.forwardedAlertsRef.current
                ) {
                  props.forwardedAlertsRef.current = [];
                }
                updateViewRenewPolicy({ planLoading: true });
                setFieldValue('planLoading', true);
                fetchQuery({
                  query: GET_PLAN_COVER_DETAILS,
                  variables: {
                    input: {
                    sumInsured:
                        props?.forwardedPremiumFormRef?.current
                          ?.values?.sumInsured,
                    deductSumInsured:
                        props?.forwardedPremiumFormRef?.current
                          ?.values?.deductSumInsured,
                    productCode,
                    startDate: dateTimeData?.datetimeValue?.date,
                    members: [
                      ...Object?.keys(values?.insuredDetails)
                        ?.filter(
                          (ins) =>
                            !values?.insuredDetails[ins]
                              ?.isMemberDeleted &&
                            !values?.insuredDetails[ins]
                              ?.isSoftAdded &&
                            insured?.toString()?.toLowerCase() !==
                              ins?.toString()?.toLowerCase(),
                        )
                        ?.map((insured) => {
                          return {
                            relationship: insured,
                            gender:
                                values?.insuredDetails[insured]
                                  ?.gender,
                              dob: values?.insuredDetails[insured]
                                ?.dob,
                              age: values?.insuredDetails[insured]
                                ?.age,
                          };
                        }),
                    ],
                    imdCode: values?.intermediaryData?.intermediary,
                    },
                  },
                })
                  ?.then((response) => {
                    updateViewRenewPolicy({ planLoading: false });
                    setFieldValue('planLoading', false);
                    const { data: dataPlanCovers } = response;
                if (values?.insuredDetails[insured]?.memberID) {
                  setFieldValue(
                    `insuredDetails.${insured}.isMemberDeleted`,
                    true,
                  );
                  if (valueChanges) {
                    setFieldValue(
                      `nomineeDetails.${insured}`,
                      valueChanges?.nomineeDetails[insured],
                    );
                  }
                } else {
                  /**Hard delete */
                      setDisplayEditExtenals(displayEditExternals?.filter((d)=>d !== insured));
                  setFieldValue(
                    `insuredDetails.${insured}.isHardDeleted`,
                    true,
                  );
                  setFieldValue(
                    `nomineeDetails.${insured}.isHardDeleted`,
                    true,
                  );
                  setFieldValue(
                    `prevInsuranceDetails.${insured}.isHardDeleted`,
                    true,
                  );
                  setFieldValue(
                    `isHealthDeclarationSelected`,
                    initialHealthDeclarationSelected,
                  );
                  let valuesAfterDeleteMedicalUnderwriting = {};
                  Object.keys(values?.insuredDetails)?.forEach(
                    (ins) => {
                      if (
                            ins?.toLowerCase() !==
                            insured?.toLowerCase()
                      ) {
                        // valuesAfterDeleteInsured[ins] =
                        //   values?.insuredDetails[ins];
                        if (
                              !values?.insuredDetails[ins]
                                ?.isSoftAdded
                        ) {
                          // valuesAfterDeleteNominee[ins] =
                          //   values?.nomineeDetails[ins];
                          // valuesAfterDeletePrevInsured[ins] =
                          //   values?.prevInsuranceDetails[ins];
                              valuesAfterDeleteMedicalUnderwriting[
                                ins
                              ] = values?.medicalUnderwriting[ins];
                        }
                      }
                    },
                  );
                  // setFieldValue(
                  //   `insuredDetails`,
                  //   valuesAfterDeleteInsured,
                  // );
                  // setFieldValue(
                  //   `nomineeDetails`,
                  //   valuesAfterDeleteNominee,
                  // );
                  // setFieldValue(
                  //   `prevInsuranceDetails`,
                  //   valuesAfterDeletePrevInsured,
                  // );
                  setFieldValue(
                    `medicalUnderwriting`,
                    valuesAfterDeleteMedicalUnderwriting,
                  );
                  setValueChanges(values);
                }
                    fetchQuery({
                      query: GET_VIEW_RENEW_POLICY_VAR_DETAILS,
                    })?.then((response) => {
                      const { data: dataViewRenewPolicy } = response;
                      if (
                        !dataPlanCovers?.planAndCovers?.find(
                          (plan) =>
                            plan?.name?.toString()?.toLowerCase() ===
                            dataViewRenewPolicy?.viewRenewPolicy?.planName
                              ?.toString()
                              ?.toLowerCase(),
                        )
                      ) {
                setAlerts([
                  {
                    header: 'Member details removed',
                            id:
                              (alerts?.length + 1) *
                              Date.now() *
                              Math.random() *
                              10000,
                    content: (
                      <div className="flex flex-col flex-wrap space-y-2 w-full h-full">
                        <div className="flex justify-start space-x-2 w-full items-start">
                          <Text
                            severity="warning"
                            type="large"
                            className="flex flex-col justify-start items-start"
                          >
                            •
                          </Text>
                          <Text>
                                    {insured} details has been removed
                                    for renewal
                          </Text>
                        </div>
                        <div className="flex justify-start space-x-2 w-full items-start">
                          <Text
                            severity="warning"
                            type="large"
                            className="flex flex-col justify-start items-start"
                          >
                            •
                          </Text>
                          <Text>
                            Choose plan and covers apart from{' '}
                            {insured}
                          </Text>
                        </div>
                      </div>
                    ),
                    type: 'warning',
                    timeout: null,
                    disableClose: false,
                  },
                  ...alerts,
                ]);
                updatePrevPlanWithPlan();
                updateViewRenewPolicy({
                  planName: '',
                  totalPremium: '',
                  isProposalReadyForRenewal: true,
                });
                      } else {
                setAlerts([
                  {
                            header: 'Member details removed',
                            id:
                              (alerts?.length + 1) *
                              Date.now() *
                              Math.random() *
                              10000,
                    content: (
                      <div className="flex flex-col flex-wrap space-y-2 w-full h-full">
                        <div className="flex justify-start space-x-2 w-full items-start">
                          <Text
                            severity="warning"
                            type="large"
                            className="flex flex-col justify-start items-start"
                          >
                            •
                          </Text>
                          <Text>
                                    {insured} details has been removed
                                    for renewal
                                  </Text>
                                </div>
                                <div className="flex justify-start space-x-2 w-full items-start">
                                  <Text
                                    severity="warning"
                                    type="large"
                                    className="flex flex-col justify-start items-start"
                                  >
                                    •
                                  </Text>
                                  <Text>
                                    Recalculate the premium before
                                    proceeding
                                  </Text>
                                </div>
                              </div>
                            ),
                            type: 'warning',
                            timeout: null,
                            disableClose: false,
                          },
                          ...alerts,
                        ]);
                        updatePrevPlanWithPlan();
                        updateViewRenewPolicy({
                          totalPremium: '',
                          isProposalReadyForRenewal: true,
                        });
                      }
                      if (
                        props.forwardedAlertsRef &&
                        props.forwardedAlertsRef.current
                      ) {
                        props.forwardedAlertsRef.current = [];
                      }
                      expandedCard.current = [
                        ...expandedCard.current.filter(
                          (exp) => exp?.cardName !== 'insuredDetails',
                        ),
                        {
                          ...expandedCard.current.find(
                            (exp) =>
                              exp?.cardName === 'insuredDetails',
                          ),
                          cardFlag: false,
                          subSections: [
                            ...expandedCard?.current
                              ?.find(
                                (exp) =>
                                  exp?.cardName === 'insuredDetails',
                              )
                              ?.subSections?.filter(
                                (subSection) =>
                                  subSection !== `${insured}`,
                              ),
                          ],
                        },
                      ];
                      setInsuredDetailsCardToggle(true);
                    });
                  })
                  ?.catch((error) => {
                    updateViewRenewPolicy({ planLoading: false });
                    setFieldValue('planLoading', false);
                  });
              },
              onUndo: (_, valuesBeforeEdit) => {
                setAlerts([]);
                if (
                  props.forwardedAlertsRef &&
                  props.forwardedAlertsRef.current
                ) {
                  props.forwardedAlertsRef.current = [];
                }
                updateViewRenewPolicy({ planLoading: true });
                setFieldValue('planLoading', true);
                fetchQuery({
                  query: GET_PLAN_COVER_DETAILS,
                  variables: {
                    input: {
                    sumInsured:
                        props?.forwardedPremiumFormRef?.current
                          ?.values?.sumInsured,
                    deductSumInsured:
                          props?.forwardedPremiumFormRef?.current
                            ?.values?.deductSumInsured,
                    productCode,
                    startDate: dateTimeData?.datetimeValue?.date,
                    members: [
                      ...Object?.keys(values?.insuredDetails)
                        ?.filter(
                          (ins) =>
                            !values?.insuredDetails[ins]
                              ?.isMemberDeleted &&
                              !values?.insuredDetails[ins]
                                ?.isSoftAdded,
                        )
                        ?.map((insured) => {
                          return {
                            relationship: insured,
                            gender:
                                values?.insuredDetails[insured]
                                  ?.gender,
                              dob: values?.insuredDetails[insured]
                                ?.dob,
                              age: values?.insuredDetails[insured]
                                ?.age,
                          };
                        }),
                      {
                        relationship: insured,
                        gender:
                          values?.insuredDetails[insured]?.gender,
                        dob: values?.insuredDetails[insured]?.dob,
                        age: values?.insuredDetails[insured]?.age,
                      },
                    ],
                    imdCode: values?.intermediaryData?.intermediary,
                    },
                  },
                })
                  ?.then((response) => {
                    updateViewRenewPolicy({ planLoading: false });
                    setFieldValue('planLoading', false);
                    const { data: dataPlanCovers } = response;
                    setFieldValue(
                      `insuredDetails.${insured}`,
                      valuesBeforeEdit
                        ? valuesBeforeEdit?.insuredDetails[insured]
                        : values?.insuredDetails[insured],
                    );
                    setFieldValue(
                      `insuredDetails.${insured}.isMemberDeleted`,
                      false,
                    );
                    fetchQuery({
                      query: GET_VIEW_RENEW_POLICY_VAR_DETAILS,
                    })
                      ?.then((response) => {
                        if (
                          !dataPlanCovers?.planAndCovers?.find(
                            (plan) =>
                              plan?.name
                                ?.toString()
                                ?.toLowerCase() ===
                              response?.data?.viewRenewPolicy?.planName
                                ?.toString()
                                ?.toLowerCase(),
                          )
                        ) {
                          setAlerts([
                            {
                              header: 'Member details added back',
                              id:
                                (alerts?.length + 1) *
                                Date.now() *
                                Math.random() *
                                10000,
                              content: (
                                <div className="flex flex-col flex-wrap space-y-2 w-full h-full">
                                  <div className="flex justify-start space-x-2 w-full items-start">
                                    <Text
                                      severity="warning"
                                      type="large"
                                      className="flex flex-col justify-start items-start"
                                    >
                                      •
                                    </Text>
                                    <Text>
                                      {insured} details has been added
                                      back
                                    </Text>
                                  </div>
                                  <div className="flex justify-start space-x-2 w-full items-start">
                                    <Text
                                      severity="warning"
                                      type="large"
                                      className="flex flex-col justify-start items-start"
                                    >
                                      •
                                    </Text>
                                    <Text>
                                      {
                                        response?.data
                                          ?.viewRenewPolicy?.planName
                                      }{' '}
                                      is not applicable for the
                                      available added members. Choose
                                      a new plan.
                                    </Text>
                                  </div>
                                </div>
                              ),
                              type: 'warning',
                              timeout: null,
                              disableClose: false,
                            },
                            ...alerts,
                          ]);
                          updateViewRenewPolicy({
                            planName: '',
                            totalPremium: '',
                            isProposalReadyForRenewal: true,
                          });
                        } else {
                          setAlerts([
                            {
                              header: 'Member details added back',
                              id:
                                (alerts?.length + 1) *
                                Date.now() *
                                Math.random() *
                                10000,
                              content: (
                                <div className="flex flex-col flex-wrap space-y-2 w-full h-full">
                                  <div className="flex justify-start space-x-2 w-full items-start">
                                    <Text
                                      severity="warning"
                                      type="large"
                                      className="flex flex-col justify-start items-start"
                                    >
                                      •
                                    </Text>
                                    <Text>
                                      {insured} details has been added
                                      back
                                    </Text>
                                  </div>
                                </div>
                              ),
                              type: 'warning',
                              timeout: null,
                              disableClose: false,
                            },
                            ...alerts,
                          ]);
                          if (
                            response?.data?.viewRenewPolicy
                              ?.totalPremium
                          ) {
                            updatePlanWithPrevPlan(false);
                          } else {
                            updatePlanWithPrevPlan(true);
                          }
                        }
                        if (
                          props.forwardedAlertsRef &&
                          props.forwardedAlertsRef.current
                        ) {
                          props.forwardedAlertsRef.current = [];
                        }
                        expandedCard.current = [
                          ...expandedCard.current.filter(
                            (exp) =>
                              exp?.cardName !== 'insuredDetails',
                          ),
                          {
                            ...expandedCard.current.find(
                              (exp) =>
                                exp?.cardName === 'insuredDetails',
                            ),
                            cardFlag: false,
                            subSections: [
                              ...expandedCard?.current
                                ?.find(
                                  (exp) =>
                                    exp?.cardName ===
                                    'insuredDetails',
                                )
                                ?.subSections?.filter(
                                  (subSection) =>
                                    subSection !== `${insured}`,
                                ),
                            ],
                          },
                        ];
                        setInsuredDetailsCardToggle(true);
                        return response?.data;
                      })
                      ?.catch((_) => {
                        updateViewRenewPolicy({ planLoading: false });
                        setFieldValue('planLoading', false);
                      });
                  })
                  ?.catch((_) => {
                    updateViewRenewPolicy({ planLoading: false });
                    setFieldValue('planLoading', false);
                  });
              },
              onSave: (_) => {
                setEnableRenew(true);
                setParentAlerts([]);
                setAlerts([]);
                if (
                  props.forwardedAlertsRef &&
                  props.forwardedAlertsRef.current
                ) {
                  props.forwardedAlertsRef.current = [];
                }
                if (values?.insuredDetails[insured]?.isSoftAdded) {
                  updateViewRenewPolicy({ planLoading: true });
                  setFieldValue('planLoading', true);
                  fetchQuery({
                    query: GET_PLAN_COVER_DETAILS,
                    variables: {
                      input: {
                      sumInsured:
                        props?.forwardedPremiumFormRef?.current
                          ?.values?.sumInsured,
                      deductSumInsured:
                         parseInt( props?.forwardedPremiumFormRef?.current
                            ?.values?.deductSumInsured),
                      productCode,
                      startDate: dateTimeData?.datetimeValue?.date,
                      members: [
                        ...Object?.keys(values?.insuredDetails)
                          ?.filter(
                            (insured) =>
                              !values?.insuredDetails[insured]
                                ?.isMemberDeleted &&
                              !values?.insuredDetails[insured]
                                ?.isSoftAdded,
                          )
                          ?.map((insured) => {
                            return {
                              relationship: insured,
                              gender:
                                values?.insuredDetails[insured]
                                  ?.gender,
                              dob: values?.insuredDetails[insured]
                                ?.dob,
                              age: values?.insuredDetails[insured]
                                ?.age,
                            };
                          }),
                        {
                          relationship: insured,
                          gender:
                            values?.insuredDetails[insured]?.gender,
                          dob: values?.insuredDetails[insured]?.dob,
                          age: values?.insuredDetails[insured]?.age,
                        },
                      ],
                        imdCode:
                          values?.intermediaryData?.intermediary,
                      },
                    },
                  })
                    ?.then((response) => {
                      updateViewRenewPolicy({ planLoading: false });
                      setFieldValue('planLoading', false);
                      const { data: dataPlanCovers } = response;
                      if (
                        !dataPlanCovers?.planAndCovers?.find(
                          (plan) =>
                            plan?.name?.toString()?.toLowerCase() ===
                            props?.forwardedPremiumFormRef?.current?.values?.planName
                              ?.toString()
                              ?.toLowerCase(),
                        )
                      ) {
                        setParentAlerts([
                          {
                            header: 'Member added',
                            id:
                              (alerts?.length + 1) *
                              Date.now() *
                              Math.random() *
                              10000,
                            content: (
                              <div className="flex flex-col flex-wrap space-y-2 w-full h-full">
                                <div className="flex justify-start space-x-2 w-full items-start">
                                  <Text
                                    severity="warning"
                                    type="large"
                                    className="flex flex-col justify-start items-start"
                                  >
                                    •
                                  </Text>
                                  <Text>
                                    {insured} has been added
                                    successfully
                                  </Text>
                                </div>
                                <div className="flex justify-start space-x-2 w-full items-start">
                                  <Text
                                    severity="warning"
                                    type="large"
                                    className="flex flex-col justify-start items-start"
                                  >
                                    •
                                  </Text>
                                  <Text>
                                    Please fill the details for{' '}
                                    {insured} in Nominee details,
                                    Previous Insured section
                                  </Text>
                                </div>
                                <div className="flex justify-start space-x-2 w-full items-start">
                                  <Text
                                    severity="warning"
                                    type="large"
                                    className="flex flex-col justify-start items-start"
                                  >
                                    •
                                  </Text>
                                  <Text>
                                    Choose your plans and covers
                                    including {insured}
                                  </Text>
                                </div>
                              </div>
                            ),
                            type: 'warning',
                            timeout: null,
                            disableClose: false,
                          },
                          ...alerts,
                        ]);
                        if (values?.countEditsOpen === 1) {
                          updateViewRenewPolicy({
                            planName: '',
                            totalPremium: '',
                            isProposalReadyForRenewal: true,
                          });
                        } else {
                          updateViewRenewPolicy({
                            planName: '',
                            totalPremium: '',
                          });
                        }
                      } else {
                        fetchQuery({
                          query: GET_VIEW_RENEW_POLICY_VAR_DETAILS,
                        })
                          ?.then((response) => {
                            const {
                              viewRenewPolicy:
                                viewRenewPolicyForCheck,
                            } = response?.data;
                            let selectedAddOnCovers = new Set();
                            viewRenewPolicyForCheck?.planData?.plans
                              ?.find(
                                (plan) =>
                                  plan?.name
                                    ?.toString()
                                    ?.toLowerCase() ===
                                  viewRenewPolicyForCheck?.planName
                                    ?.toString()
                                    ?.toLowerCase(),
                              )
                              ?.packs?.forEach((pack) => {
                                pack?.addOnCovers
                                  ?.filter(
                                    (addOnCover) =>
                                      addOnCover?.selected,
                                  )
                                  ?.forEach((addOnCover) => {
                                    selectedAddOnCovers?.add(
                                      addOnCover?.index,
                                    );
                                  });
                              });
                            setParentAlerts([
                              {
                                header: 'Member added',
                                id:
                                  (alerts?.length + 1) *
                                  Date.now() *
                                  Math.random() *
                                  10000,
                                content: (
                                  <div className="flex flex-col flex-wrap space-y-2 w-full h-full">
                                    <div className="flex justify-start space-x-2 w-full items-start">
                                      <Text
                                        severity="warning"
                                        type="large"
                                        className="flex flex-col justify-start items-start"
                                      >
                                        •
                                      </Text>
                                      <Text>
                                        {insured} has been added
                                        successfully
                                      </Text>
                                    </div>
                                    <div className="flex justify-start space-x-2 w-full items-start">
                                      <Text
                                        severity="warning"
                                        type="large"
                                        className="flex flex-col justify-start items-start"
                                      >
                                        •
                                      </Text>
                                      <Text>
                                        Please fill the details for{' '}
                                        {insured} in Nominee details,
                                        Previous Insured section
                                      </Text>
                                    </div>
                                    <div className="flex justify-start space-x-2 w-full items-start">
                                      <Text
                                        severity="warning"
                                        type="large"
                                        className="flex flex-col justify-start items-start"
                                      >
                                        •
                                      </Text>
                                      <Text>
                                        Recalculate the premium before
                                        proceeding
                          </Text>
                        </div>
                      </div>
                    ),
                    type: 'warning',
                    timeout: null,
                    disableClose: false,
                  },
                  ...alerts,
                ]);
                if (
                  props.forwardedAlertsRef &&
                  props.forwardedAlertsRef.current
                ) {
                  props.forwardedAlertsRef.current = [];
                }
                            if (values?.countEditsOpen === 1) {
                updateViewRenewPolicy({
                                totalPremium: '',
                  isProposalReadyForRenewal: true,
                                planData: {
                                  plans:
                                    dataPlanCovers?.planAndCovers?.map(
                                      (planCover) => {
                                        return {
                                          ...planCover,
                                          packs:
                                            planCover?.packs?.map(
                                              (pack) => {
                                                return {
                                                  ...pack,
                                                  addOnCovers:
                                                    pack?.addOnCovers?.map(
                                                      (
                                                        addOnCover,
                                                      ) => {
                                                        if (
                                                          selectedAddOnCovers?.has(
                                                            addOnCover?.index,
                                                          )
                                                        ) {
                                                          return {
                                                            ...addOnCover,
                                                            selected: true,
                                                          };
                                                        }
                                                        return addOnCover;
                                                      },
                                                    ),
                                                };
                                              },
                  ),
                                          premium: null,
                                        };
                                      },
                    ),
                                },
                              });
                            } else {
                              updateViewRenewPolicy({
                                totalPremium: '',
                                planData: {
                                  plans:
                                    dataPlanCovers?.planAndCovers?.map(
                                      (planCover) => {
                                        return {
                                          ...planCover,
                                          packs:
                                            planCover?.packs?.map(
                                              (pack) => {
                                                return {
                                                  ...pack,
                                                  addOnCovers:
                                                    pack?.addOnCovers?.map(
                                                      (
                                                        addOnCover,
                                                      ) => {
                                                        if (
                                                          selectedAddOnCovers?.has(
                                                            addOnCover?.index,
                        )
                                                        ) {
                                                          return {
                                                            ...addOnCover,
                                                            selected: true,
                                                          };
                                                        }
                                                        return addOnCover;
                                                      },
                        ),
                                                };
                  },
                                            ),
                                          premium: null,
                                        };
                                      },
                                    ),
              },
                              });
                            }
                          })
                          ?.catch((error) => error);
                      }
                  setFieldValue(
                    `insuredDetails.${insured}.isSoftAdded`,
                    false,
                  );
                  if (
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted
                  ) {
                    setFieldValue(
                      `insuredDetails.${insured}.isMemberDeleted`,
                      false,
                    );
                  }
                  setFieldValue(`nomineeDetails`, {
                    ...values?.nomineeDetails,
                    [insured]: {
                      name: '',
                      dob: '',
                      relationshipWithInsured: '',
                      relationshipWithAppointee: '',
                      nameOfAppointee: '',
                      isSoftAdded: true,
                      isHardDeleted: false,
                    },
                  });
                  setFieldValue(`prevInsuranceDetails`, {
                    ...values?.prevInsuranceDetails,
                    [insured]: {
                      prevInsurerName: '',
                      prevPolicyNo: '',
                      prevPolicyStartDate: '',
                      prevPolicyEndDate: '',
                      prevPolicySI: '',
                      prevClaimLodged: '',
                      claimAmount: '',
                      cbAmount: '',
                      isSoftAdded: true,
                      isHardDeleted: false,
                    },
                  });
                  let questionObj = {};
                  productQuestionList.forEach(
                    (medicalQuestionaire) => {
                          questionObj[`${medicalQuestionaire.srNo}`] =
                            {
                        checkboxAnswer:
                          medicalQuestionaire?.srNo?.toLowerCase() ===
                          'master'
                            ? !productQuestionList?.find(
                                (q) =>
                                        q?.srNo?.toLowerCase() ===
                                        'master',
                              )?.condToChild
                              ? 'Yes'
                              : 'No'
                            : 'No',
                        textareaAnswer: '',
                      };
                    },
                  );
                  setFieldValue(`medicalUnderwriting`, {
                    ...values?.medicalUnderwriting,
                    [insured]: questionObj,
                  });
                      setFieldValue(
                        `countEditsOpen`,
                        values?.countEditsOpen - 1,
                      );
                  expandedCard.current = [
                    ...expandedCard.current.filter(
                      (exp) => exp?.cardName !== 'insuredDetails',
                    ),
                    {
                      ...expandedCard.current.find(
                            (exp) =>
                              exp?.cardName === 'insuredDetails',
                      ),
                      cardFlag: false,
                      subSections: [
                        ...expandedCard?.current
                          ?.find(
                            (exp) =>
                              exp?.cardName === 'insuredDetails',
                          )
                          ?.subSections?.filter(
                            (subSection) =>
                              subSection !== `${insured}`,
                          ),
                      ],
                    },
                  ];
                  setInsuredDetailsCardToggle(true);
                    })
                    ?.catch((error) => {
                      updateViewRenewPolicy({ planLoading: false });
                      setFieldValue('planLoading', false);
                    });
                } else {
                  setDisplayEditExtenals(displayEditExternals?.filter((d)=>d !== insured));
                  if (
                    props.forwardedAlertsRef &&
                    props.forwardedAlertsRef.current
                  ) {
                    props.forwardedAlertsRef.current = [];
                  }
                  if (values?.countEditsOpen === 1) {
                  updateViewRenewPolicy({
                    isProposalReadyForRenewal: true,
                  });
                  }
                  setFieldValue(
                    `countEditsOpen`,
                    values?.countEditsOpen - 1,
                  );
                  expandedCard.current = [
                    ...expandedCard.current.filter(
                      (exp) => exp?.cardName !== 'insuredDetails',
                    ),
                    {
                      ...expandedCard.current.find(
                        (exp) => exp?.cardName === 'insuredDetails',
                      ),
                      cardFlag: false,
                    },
                  ];
                  setInsuredDetailsCardToggle(true);
                }
              },
              onCancel: (_, valuesBeforeEdit) => {
                if (!values?.insuredDetails[insured]?.isSoftAdded) {
                  setFieldValue(
                    `insuredDetails.${insured}`,
                    valuesBeforeEdit?.insuredDetails[insured],
                  );
                  if(values?.countEditsOpen === 1) {
                    setEnableRenew(true);
                  }
                  setFieldValue(
                    `countEditsOpen`,
                    values?.countEditsOpen - 1,
                  );
                } else {
                  /**Hard delete */
                  setFieldValue(
                    `insuredDetails.${insured}.isHardDeleted`,
                    true,
                  );
                  // let valuesAfterDeleteInsured = {},
                  //   valuesAfterDeleteNominee = {},
                  //   valuesAfterDeletePrevInsured = {};

                  // Object.keys(values?.insuredDetails)?.forEach(
                  //   (ins) => {
                  //     if (
                  //       ins?.toLowerCase() !== insured?.toLowerCase()
                  //     ) {
                  //       valuesAfterDeleteInsured[ins] =
                  //         values?.insuredDetails[ins];
                  //     }
                  //   },
                  // );
                  // Object.keys(values?.nomineeDetails)?.forEach(
                  //   (nom) => {
                  //     if (
                  //       nom?.toLowerCase() !== insured?.toLowerCase()
                  //     ) {
                  //       valuesAfterDeleteNominee[nom] =
                  //         values?.nomineeDetails[nom];
                  //     }
                  //   },
                  // );
                  // Object.keys(values?.prevInsuranceDetails)?.forEach(
                  //   (prevInsured) => {
                  //     if (
                  //       prevInsured?.toLowerCase() !==
                  //       insured?.toLowerCase()
                  //     ) {
                  //       valuesAfterDeletePrevInsured[prevInsured] =
                  //         values?.prevInsuranceDetails[prevInsured];
                  //     }
                  //   },
                  // );
                  // setFieldValue(
                  //   `insuredDetails`,
                  //   valuesAfterDeleteInsured,
                  // );
                  // setFieldValue(
                  //   `nomineeDetails`,
                  //   valuesAfterDeleteNominee,
                  // );
                  // setFieldValue(
                  //   `prevInsuranceDetails`,
                  //   valuesAfterDeletePrevInsured,
                  // );
                  // setValueChanges(values);
                }
                if (
                  props.forwardedAlertsRef &&
                  props.forwardedAlertsRef.current
                ) {
                  props.forwardedAlertsRef.current = [];
                }
                if (values?.countEditsOpen === 1) {
                  // setEnableRenew(true);-- sharmila changes for unable to cal prem when new mem added
                updateViewRenewPolicy({
                  isProposalReadyForRenewal: true,
                });
                   setEnableRenew(true); 
                }
                setFieldValue(
                  `countEditsOpen`,
                  values?.countEditsOpen - 1,
                );
                expandedCard.current = [
                  ...expandedCard.current.filter(
                    (exp) => exp?.cardName !== 'insuredDetails',
                  ),
                  {
                    ...expandedCard.current.find(
                      (exp) => exp?.cardName === 'insuredDetails',
                    ),
                    cardFlag: false,
                    subSections: [
                      ...expandedCard?.current
                        ?.find(
                          (exp) => exp?.cardName === 'insuredDetails',
                        )
                        ?.subSections?.filter(
                          (subSection) => subSection !== `${insured}`,
                        ),
                    ],
                  },
                ];
                setInsuredDetailsCardToggle(true);
              },
              disableCancel:
                values?.planLoading ||
                values?.isCalculatingPremium ||
                Object.keys(values?.insuredDetails)?.filter(
                  (ins) =>
                    !values?.insuredDetails[ins]?.isMemberDeleted,
                )?.length === 1,
              disableEdit:
                values?.isCalculatingPremium || values?.planLoading,
              disableDelete:
                values?.isCalculatingPremium || values?.planLoading,
              disableUndo:
                values?.isCalculatingPremium || values?.planLoading,
              initDisplayUndo:
                viewRenewPolicy?.isProposalRenewed
                ? false
                : values?.insuredDetails[insured]?.isMemberDeleted,
              initDisplayEdit: viewRenewPolicy?.isProposalRenewed
                ? false
                : !values?.insuredDetails[insured]?.isSoftAdded
                ? false
                : true ||
                  expandedCard.current
                    .find((exp) => exp?.cardName === 'insuredDetails')
                    ?.subSections?.include(`${insured}`),
              editDisplayDisabled:
                (values?.insuredDetails[insured]?.memberID
                  ? true
                  : false) || viewRenewPolicy?.isProposalRenewed ||
                  renewalFlag?.toString()?.toLowerCase() === 'expired',
              grid_data: [
                submitInsuredArr(values),
                values?.insuredDetails[insured]?.memberID
                  ? {
                      label: (
                        <div
                          className={`${
                            values?.insuredDetails[insured]
                              ?.isMemberDeleted
                              ? 'text-neutral-darker'
                              : ''
                          }`}
                        >
                          Member ID <Text severity="error">*</Text>
                        </div>
                      ),
                      type: 'text',
                      name: `insuredDetails.${insured}.memberID`,
                      isTextDisabled:
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted,
                      disabled:
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted,
                      readOnlyValue: `${values?.insuredDetails[insured]?.memberID}`,
                      labelReadOnly: (
                        <div
                          className={`${
                            values?.insuredDetails[insured]
                              ?.isMemberDeleted
                              ? 'text-neutral-darker'
                              : ''
                          }`}
                        >
                          Member ID <Text severity="error"></Text>
                        </div>
                      ),
                    }
                  : null,
                values?.insuredDetails[insured]?.memberStatus
                  ? {
                      label: (
                        <div
                          className={`${
                            values?.insuredDetails[insured]
                              ?.isMemberDeleted
                              ? 'text-neutral-darker'
                              : ''
                          }`}
                        >
                          Member Status{' '}
                          <Text severity="error">*</Text>
                        </div>
                      ),
                      type: 'text',
                      name: `insuredDetails.${insured}.memberStatus`,
                      isTextDisabled:
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted,
                      disabled:
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted,
                      readOnlyValue: `${values?.insuredDetails[insured]?.memberStatus}`,
                      labelReadOnly: (
                        <div
                          className={`${
                            values?.insuredDetails[insured]
                              ?.isMemberDeleted
                              ? 'text-neutral-darker'
                              : ''
                          }`}
                        >
                          Member Status <Text severity="error"></Text>
                        </div>
                      ),
                    }
                  : null,
                values?.insuredDetails[insured]?.ppcTestLevel
                  ? {
                      type: 'text',
                      disabled: true,
                      isTextDisabled:
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted,
                      label: (
                        <div
                          className={`${
                            values?.insuredDetails[insured]
                              ?.isMemberDeleted
                              ? 'text-neutral-darker'
                              : ''
                          }`}
                        >
                          PPC Test Level{' '}
                          <Text severity="error"></Text>
                        </div>
                      ),
                      readOnlyValue:
                        values?.insuredDetails[insured]?.ppcTestLevel,
                      name: `insuredDetails.${insured}.cbBonusPct`,
                    }
                  : null,
                {
                  label: (
                    <div
                      className={`${
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted
                          ? 'text-neutral-darker'
                          : ''
                      }`}
                    >
                      Title <Text severity="error">*</Text>
                    </div>
                  ),
                  isTextDisabled:
                    values?.insuredDetails[insured]?.isMemberDeleted,
                  labelReadOnly: (
                    <div
                      className={`${
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted
                          ? 'text-neutral-darker'
                          : ''
                      }`}
                    >
                      Title <Text severity="error"></Text>
                    </div>
                  ),
                  type: 'select',
                  searchable: true,
                  disabled:
                    values?.insuredDetails[insured]
                      ?.isMemberDeleted ||
                    values?.isCalculatingPremium ||
                    values?.planLoading,
                  readOnlyValue: getDomainData(
                    salutationList,
                    values?.insuredDetails[insured]?.title,
                    'code',
                    'value',
                  )?.toString(),
                  name: `insuredDetails.${insured}.title`,
                  data:
                    salutationList && salutationList?.length > 0
                      ? salutationList?.filter(
                          (salutation) =>
                            salutation?.gender?.toLowerCase() ===
                            values?.insuredDetails[
                              insured
                            ]?.gender?.toLowerCase(),
                        )?.length === 0
                        ? salutationList?.map((salutation) => {
                            return {
                              label: salutation?.value
                                ? salutation?.value
                                : '',
                              value: salutation?.code
                                ? salutation?.code
                                : '',
                            };
                          })
                        : salutationList
                            ?.filter(
                              (salutation) =>
                                salutation?.gender?.toLowerCase() ===
                                  values?.insuredDetails[
                                    insured
                                  ]?.gender?.toLowerCase() ||
                                !salutation?.gender,
                            )
                            ?.map((salutation) => {
                              return {
                                label: salutation?.value
                                  ? salutation?.value
                                  : '',
                                value: salutation?.code
                                  ? salutation?.code
                                  : '',
                              };
                            })
                      : [],
                  onDataChange: (val, setFieldValue) => {
                    if (
                      getDomainData(
                        salutationList,
                        val,
                        'value',
                        'code',
                      )
                    ) {
                      setFieldValue(
                        `insuredDetails.${insured}.title`,
                        getDomainData(
                          salutationList,
                          val,
                          'value',
                          'code',
                        ),
                      );
                    }
                  },
                },
                {
                  label: (
                    <div
                      className={`${
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted
                          ? 'text-neutral-darker'
                          : ''
                      }`}
                    >
                      Gender <Text severity="error">*</Text>
                    </div>
                  ),
                  labelReadOnly: (
                    <div
                      className={`${
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted
                          ? 'text-neutral-darker'
                          : ''
                      }`}
                    >
                      Gender <Text severity="error"></Text>
                    </div>
                  ),
                  isTextDisabled:
                    values?.insuredDetails[insured]?.isMemberDeleted,
                  type: 'select',
                  disabled:
                    values?.insuredDetails[insured]
                      ?.isGenderReadOnly ||
                    values?.insuredDetails[insured]
                      ?.isMemberDeleted ||
                    values?.isCalculatingPremium ||
                    values?.planLoading,
                  readOnlyValue: getDomainData(
                    genderList,
                    values?.insuredDetails[insured]?.gender,
                    'code',
                    'value',
                  )?.toString(),
                  name: `insuredDetails.${insured}.gender`,
                  data:
                    genderList && genderList?.length > 0
                      ? genderList?.map((gender) => {
                          return {
                            label: gender?.value ? gender?.value : '',
                            value: gender?.code ? gender?.code : '',
                          };
                        })
                      : [],
                },
                {
                  label: (
                    <div
                      className={`${
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted
                          ? 'text-neutral-darker'
                          : ''
                      }`}
                    >
                      Date of Birth <Text severity="error">*</Text>
                    </div>
                  ),
                  labelReadOnly: (
                    <div
                      className={`${
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted
                          ? 'text-neutral-darker'
                          : ''
                      }`}
                    >
                      Date of Birth <Text severity="error"></Text>
                    </div>
                  ),
                  isTextDisabled:
                    values?.insuredDetails[insured]?.isMemberDeleted,
                  disabled:
                    values?.insuredDetails[insured]
                      ?.isMemberDeleted ||
                    values?.isCalculatingPremium ||
                    values?.planLoading,
                  type: 'date',
                  name: `insuredDetails.${insured}.dob`,
                },
                {
                  label: (
                    <div
                      className={`${
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted
                          ? 'text-neutral-darker'
                          : ''
                      }`}
                    >
                      First Name <Text severity="error">*</Text>
                    </div>
                  ),
                  labelReadOnly: (
                    <div
                      className={`${
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted
                          ? 'text-neutral-darker'
                          : ''
                      }`}
                    >
                      First Name <Text severity="error"></Text>
                    </div>
                  ),
                  isTextDisabled:
                    values?.insuredDetails[insured]?.isMemberDeleted,
                  disabled:
                    values?.insuredDetails[insured]
                      ?.isMemberDeleted ||
                    values?.isCalculatingPremium ||
                    values?.planLoading,
                  type: 'text',
                  name: `insuredDetails.${insured}.firstName`,
                },
                {
                  label: (
                    <div
                      className={`${
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted
                          ? 'text-neutral-darker'
                          : ''
                      }`}
                    >
                      Middle Name <Text severity="error"></Text>
                    </div>
                  ),
                  type: 'text',
                  isTextDisabled:
                    values?.insuredDetails[insured]?.isMemberDeleted,
                  disabled:
                    values?.insuredDetails[insured]
                      ?.isMemberDeleted ||
                    values?.isCalculatingPremium ||
                    values?.planLoading,
                  name: `insuredDetails.${insured}.middleName`,
                },
                {
                  label: (
                    <div
                      className={`${
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted
                          ? 'text-neutral-darker'
                          : ''
                      }`}
                    >
                      Last Name <Text severity="error">*</Text>
                    </div>
                  ),
                  labelReadOnly: (
                    <div
                      className={`${
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted
                          ? 'text-neutral-darker'
                          : ''
                      }`}
                    >
                      Last Name <Text severity="error"></Text>
                    </div>
                  ),
                  isTextDisabled:
                    values?.insuredDetails[insured]?.isMemberDeleted,
                  disabled:
                    values?.insuredDetails[insured]
                      ?.isMemberDeleted ||
                    values?.isCalculatingPremium ||
                    values?.planLoading,
                  type: 'text',
                  name: `insuredDetails.${insured}.lastName`,
                },
                {
                  label: (
                    <div
                      className={`${
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted
                          ? 'text-neutral-darker'
                          : ''
                      }`}
                    >
                      Marital Status <Text severity="error">*</Text>
                    </div>
                  ),
                  labelReadOnly: (
                    <div
                      className={`${
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted
                          ? 'text-neutral-darker'
                          : ''
                      }`}
                    >
                      Marital Status <Text severity="error"></Text>
                    </div>
                  ),
                  readOnlyValue: getDomainData(
                    maritalStatusList,
                    values?.insuredDetails[insured]?.maritalStatus,
                    'code',
                    'value',
                  )?.toString(),
                  type: 'select',
                  isTextDisabled:
                    values?.insuredDetails[insured]?.isMemberDeleted,
                  disabled:
                    values?.insuredDetails[insured]
                      ?.isMemberDeleted ||
                    values?.isCalculatingPremium ||
                    values?.planLoading,
                  name: `insuredDetails.${insured}.maritalStatus`,
                  data:
                    maritalStatusList && maritalStatusList?.length > 0
                      ? maritalStatusList?.map((maritalStatus) => {
                          return {
                            label: maritalStatus?.value
                              ? maritalStatus?.value
                              : '',
                            value: maritalStatus?.code
                              ? maritalStatus?.code
                              : '',
                          };
                        })
                      : [],
                },
                {
                  type: 'number',
                  min: 0,
                  label: (
                    <div
                      className={`${
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted
                          ? 'text-neutral-darker'
                          : ''
                      }`}
                    >
                      Height <Text severity="error">*</Text>
                    </div>
                  ),
                  labelReadOnly: (
                    <div
                      className={`${
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted
                          ? 'text-neutral-darker'
                          : ''
                      }`}
                    >
                      Height <Text severity="error"></Text>
                    </div>
                  ),
                  isTextDisabled:
                    values?.insuredDetails[insured]?.isMemberDeleted,
                  disabled:
                    values?.insuredDetails[insured]
                      ?.isMemberDeleted ||
                    values?.isCalculatingPremium ||
                    values?.planLoading,
                  readOnlyValue: values?.insuredDetails[insured]
                    ?.height
                    ? `${values?.insuredDetails[
                        insured
                      ]?.height?.toString()} cm(s)`
                    : '',
                  iconPost: 'cms',
                  className:
                    values?.insuredDetails[insured]
                      ?.isMemberDeleted ||
                    values?.isCalculatingPremium ||
                    values?.planLoading
                      ? `border-neutral-dark`
                      : ``,
                  name: `insuredDetails.${insured}.height`,
                },
                {
                  type: 'number',
                  min: 0,
                  label: (
                    <div
                      className={`${
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted
                          ? 'text-neutral-darker'
                          : ''
                      }`}
                    >
                      Weight <Text severity="error">*</Text>
                    </div>
                  ),
                  labelReadOnly: (
                    <div
                      className={`${
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted
                          ? 'text-neutral-darker'
                          : ''
                      }`}
                    >
                      Weight <Text severity="error"></Text>
                    </div>
                  ),
                  disabled:
                    values?.insuredDetails[insured]
                      ?.isMemberDeleted ||
                    values?.isCalculatingPremium ||
                    values?.planLoading,
                  isTextDisabled:
                    values?.insuredDetails[insured]?.isMemberDeleted,
                  readOnlyValue: values?.insuredDetails[insured]
                    ?.weight
                    ? `${values?.insuredDetails[
                        insured
                      ]?.weight?.toString()} Kg(s)`
                    : '',
                  iconPost: 'Kgs',
                  className:
                    values?.insuredDetails[insured]
                      ?.isMemberDeleted ||
                    values?.isCalculatingPremium ||
                    values?.planLoading
                      ? `border-neutral-dark`
                      : ``,
                  name: `insuredDetails.${insured}.weight`,
                },
                {
                  type: 'select',
                  label: (
                    <div
                      className={`${
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted
                          ? 'text-neutral-darker'
                          : ''
                      }`}
                    >
                      Occupation <Text severity="error">*</Text>
                    </div>
                  ),
                  readOnlyValue: getDomainData(
                    PRD_OccupationList,
                    values?.insuredDetails[insured]?.occupation,
                    'code',
                    'value',
                  )?.toString(),
                  name: `insuredDetails.${insured}.occupation`,
                  disabled:
                    values?.insuredDetails[insured]
                      ?.isMemberDeleted ||
                    values?.isCalculatingPremium ||
                    values?.planLoading,
                  isTextDisabled:
                    values?.insuredDetails[insured]?.isMemberDeleted,
                  onDataChange: (val, _) => {
                    if (
                      getDomainData(
                        PRD_OccupationList,
                        val,
                        'code',
                        'value',
                      )?.toLowerCase() !== 'others'
                    ) {
                      setFieldValue(
                        `insuredDetails.${insured}.otherOccupation`,
                        '',
                      );
                    }
                  },
                  data:
                    PRD_OccupationList &&
                    PRD_OccupationList?.length > 0
                      ? PRD_OccupationList?.map((occupation) => {
                          return {
                            label: occupation?.value
                              ? occupation?.value
                              : '',
                            value: occupation?.code
                              ? occupation?.code
                              : '',
                          };
                        })
                      : [],
                },
                {
                  type: 'text',
                  maxLength: 100,
                  disabled:
                    values?.insuredDetails[
                      insured
                    ]?.occupation?.toLowerCase() !==
                      getDomainData(
                        PRD_OccupationList,
                        'Others',
                        'value',
                        'code',
                      )?.toLowerCase() ||
                    values?.insuredDetails[insured]
                      ?.isMemberDeleted ||
                    values?.isCalculatingPremium ||
                    values?.planLoading,
                  placeholder:
                    values?.insuredDetails[
                      insured
                    ]?.occupation?.toLowerCase() !==
                    getDomainData(
                      PRD_OccupationList,
                      'Others',
                      'value',
                      'code',
                    )?.toLowerCase()
                      ? ''
                      : 'Max 100 characters allowed',
                  isTextDisabled:
                    values?.insuredDetails[insured]?.isMemberDeleted,
                  label: (
                    <div
                      className={`${
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted
                          ? 'text-neutral-darker'
                          : ''
                      }`}
                    >
                      If Other Occupation{' '}
                      <Text severity="error"></Text>
                    </div>
                  ),
                  name: `insuredDetails.${insured}.otherOccupation`,
                },
                {
                  type: 'select',
                  isTextDisabled:
                    values?.insuredDetails[insured]?.isMemberDeleted,
                  label: (
                    <div
                      className={`${
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted
                          ? 'text-neutral-darker'
                          : ''
                      }`}
                    >
                      Pre-Existing Disease Waiting Period{' '}
                      <Text severity="error"></Text>
                    </div>
                  ),
                  disabled:
                    values?.insuredDetails[insured]
                      ?.isMemberDeleted ||
                    values?.isCalculatingPremium ||
                    values?.planLoading || values?.insuredDetails[insured]?.isSoftAdded || values?.countEditsOpen,
                  readOnlyValue: getDomainData(
                    PRD_PreExistDiseaseWaitPeriod,
                    values?.insuredDetails[insured]?.pedWaitingPeriod,
                    'code',
                    'value',
                  )?.toString(),
                  name: `insuredDetails.${insured}.pedWaitingPeriod`,
                  data:
                    PRD_PreExistDiseaseWaitPeriod &&
                    PRD_PreExistDiseaseWaitPeriod?.length > 0
                      ? PRD_PreExistDiseaseWaitPeriod?.map(
                          (waitingPeriod) => {
                            return {
                              label: waitingPeriod?.value
                                ? waitingPeriod?.value
                                : '',
                              value: waitingPeriod?.code
                                ? waitingPeriod?.code
                                : '',
                            };
                          },
                        )
                      : [],
                },
                values?.insuredDetails[insured]?.cbBonusPct
                  ? {
                      type: 'number',
                      min: 0,
                      disabled: true,
                      isTextDisabled:
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted,
                      label: (
                        <div
                          className={`${
                            values?.insuredDetails[insured]
                              ?.isMemberDeleted
                              ? 'text-neutral-darker'
                              : ''
                          }`}
                        >
                          Cumulative Bonus{' '}
                          <Text severity="error"></Text>
                        </div>
                      ),
                      readOnlyValue: getDomainData(
                        PRD_CumulativeBonus,
                        values?.insuredDetails[insured]?.cbBonusPct,
                        'code',
                        'value',
                      )?.toString(),
                      name: `insuredDetails.${insured}.cbBonusPct`,
                    }
                  : null,
                {
                  type: 'checkbox',
                  disabled:
                    values?.insuredDetails[insured]?.memberID ||
                    values?.isCalculatingPremium ||
                    values?.planLoading
                    ? true
                    : false,
                  colSpan: repeatFormsonEdit,
                  isTextDisabled:
                    values?.insuredDetails[insured]?.isMemberDeleted,
                  label: (
                    <div
                      className={`${
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted
                          ? 'text-neutral-darker'
                          : ''
                      }`}
                    >
                      Do you want to port this member from another
                      insurer?
                      <Text severity="error"></Text>
                    </div>
                  ),
                  readOnlyValue: values?.insuredDetails[insured]
                    ?.isPortabilityRequired
                    ? 'Yes'
                    : 'No',
                  name: `insuredDetails.${insured}.isPortabilityRequired`,
                },
                // (!viewRenewPolicy?.isProposalRenewed && idx ===
                // Object.keys(values?.insuredDetails)?.filter((insured)=>!values?.insuredDetails[insured]?.isHardDeleted)?.length - 1)
                //   ? {
                //       type: 'render',
                //       colSpan: repeatFormsReadOnly,
                //       colSpanOnEdit: repeatFormsonEdit,
                //       component: () => {
                //         return (
                //           <div className="flex justify-start w-full my-4">
                //             <Button
                //               type={'button'}
                //               size={`small`}
                //               className="h-10"
                //               disabled={
                //                 filteredMemberList?.length === 0 ||
                //                 viewRenewPolicy?.isProposalRenewed
                //               }
                //               iconPre={
                //                 <FontAwesomeIcon
                //                   icon={faPlus}
                //                   className="mr-2"
                //                 />
                //               }
                //               onClick={(_) =>
                //                 setModalAddMemberDisplay(true)
                //               }
                //             >
                //               <Text type="label">Add Member</Text>
                //             </Button>
                //           </div>
                //         );
                //       },
                //     }
                //   : null,
              ].filter((d) => d),
            };
          })
        : []),
      Object.keys(values?.insuredDetails)?.length > 0 &&
      !viewRenewPolicy?.isProposalRenewed
        ? {
            grid_type: 'input',
            grid_data: [
              {
                type: 'render',
                colSpan: repeatFormsReadOnly,
                colSpanOnEdit:
                  screenType === 'desktop' ? repeatFormsonEdit : 2,
                component: () => {
                  return (
                    <Text
                      className={`flex ${
                        screenType === 'mobile' ? 'flex-col' : ''
                      } h-full justify-start w-full mb-4 space-${
                        screenType === 'mobile' ? 'y' : 'x'
                      }-4`}
                    >
                      <Text
                        className={
                          screenType === 'mobile' ? 'w-full' : ''
                        }
                      >
                      <Button
                        type={'button'}
                        size={`small`}
                          className={`h-10 w-${
                            screenType === 'mobile' ? 'full' : '40'
                          }`}
                        disabled={
                          filteredMemberList?.length === 0 ||
                            viewRenewPolicy?.isProposalRenewed ||
                            values?.isCalculatingPremium ||
                            values?.planLoading
                            || viewRenewPolicy?.proposalStatus ==='Renewal Collected'
                            ||
                            renewalFlag?.toString()?.toLowerCase() ===
                              'expired'
                        }
                        iconPre={
                          <FontAwesomeIcon
                            icon={faPlus}
                            className="mr-2"
                          />
                        }
                        onClick={(_) =>
                          setModalAddMemberDisplay(true)
                        }
                      >
                        <Text type="label">Add Member</Text>
                      </Button>
                      </Text>
                    </Text>
                  );
                },
              },
            ],
          }
        : null,
    ]?.filter((d) => d);

    const nomineeDetailsData =
      Object.keys(values?.nomineeDetails)?.length > 0
        ? Object.keys(values?.nomineeDetails)
            ?.filter(
              (nominee) =>
                !values?.nomineeDetails[nominee]?.isHardDeleted,
            )
            ?.map((nominee, idx) => {
              return {
                title: (
                  <Text
                    type="normal"
                    className={`${
                      values?.insuredDetails[nominee]?.isMemberDeleted
                        ? 'text-neutral-darker'
                        : ''
                    }`}
                  >
                    {/* {nominee} - Nominee */}
                    {(productCode==='2877')?(Object.keys(values?.insuredDetails)[0]):nominee} - Nominee
                    {/* {values?.insuredDetails[nominee]?.isMemberDeleted
                    ? ' (Nominee excluded)'
                    : ''} */}
                  </Text>
                ),
                grid_type: 'input',
                clickToEdit: true,
                resetOnCancel: false,
                editDisplayDisabled:
                  viewRenewPolicy?.isProposalRenewed ||
                  renewalFlag?.toString()?.toLowerCase() ===
                    'expired',
                isCancelRequired:
                  !values?.nomineeDetails[nominee]?.isSoftAdded,
                isBorderRequired: idx !== 0,
                disableSubmit:
                  values?.isCalculatingPremium ||
                  values?.nomineeDetails[nominee]?.isHardDeleted ||
                  values?.insuredDetails[nominee]?.isMemberDeleted
                    ? true
                    : Object.keys(validate(values))?.length > 0 &&
                      Object.keys(
                        validate(values)?.nomineeDetails[nominee],
                      )?.length > 0,
                borderClassName: 'border-t-2 border-neutral pt-4',
                isSectionDeleted:
                  values?.nomineeDetails[nominee]?.isHardDeleted,
                isDeleted:
                  values?.insuredDetails[nominee]?.isMemberDeleted,
                onEdit: (_) => {
                  setEnableRenew(false);
                  setFieldValue(
                    `countEditsOpen`,
                    values?.countEditsOpen + 1,
                  );
                  expandedCard.current = [
                    ...expandedCard.current.filter(
                      (exp) => exp?.cardName !== 'nomineeDetails',
                    ),
                    {
                      ...expandedCard.current.find(
                        (exp) => exp?.cardName === 'nomineeDetails',
                      ),
                      cardFlag: true,
                      subSections: [
                        ...expandedCard?.current?.find(
                          (exp) => exp?.cardName === 'nomineeDetails',
                        )?.subSections,
                        `${nominee}`,
                      ],
                    },
                  ];
                  if (
                    props.forwardedAlertsRef &&
                    props.forwardedAlertsRef.current
                  ) {
                    props.forwardedAlertsRef.current = [];
                  }
                  updateViewRenewPolicy({
                    isProposalReadyForRenewal: false,
                  });
                  setNomineeDetailsCardToggle(false);
                },
                onSave: (_) => {
                  setEnableRenew(true);
                  if (values?.countEditsOpen === 1) {
                    updateViewRenewPolicy({
                      isProposalReadyForRenewal: true,
                    });
                    // setEnableRenew(true);
                  }
                  setFieldValue(
                    `countEditsOpen`,
                    values?.countEditsOpen - 1,
                  );
                  if (values?.nomineeDetails[nominee]?.isSoftAdded) {
                    setFieldValue(
                      `nomineeDetails.${nominee}.isSoftAdded`,
                      false,
                    );
                  }
                  if (
                    props.forwardedAlertsRef &&
                    props.forwardedAlertsRef.current
                  ) {
                    props.forwardedAlertsRef.current = [];
                  }
                  expandedCard.current = [
                    ...expandedCard.current.filter(
                      (exp) => exp?.cardName !== 'nomineeDetails',
                    ),
                    {
                      ...expandedCard.current.find(
                        (exp) => exp?.cardName === 'nomineeDetails',
                      ),
                      cardFlag: false,
                      subSections: [
                        ...expandedCard?.current
                          ?.find(
                            (exp) =>
                              exp?.cardName === 'nomineeDetails',
                          )
                          ?.subSections?.filter(
                            (subSection) =>
                              subSection !== `${nominee}`,
                          ),
                      ],
                    },
                  ];
                  setNomineeDetailsCardToggle(true);
                },
                onCancel: (_, valuesBeforeEdit) => {
                  setAlerts([]);
                    if (
                      props.forwardedAlertsRef &&
                      props.forwardedAlertsRef.current
                    ) {
                      props.forwardedAlertsRef.current = [];
                    }
                  if (!values?.nomineeDetails[nominee]?.isSoftAdded) {
                    setFieldValue(
                      `nomineeDetails.${nominee}`,
                      valuesBeforeEdit?.nomineeDetails[nominee],
                    );
                    if (values?.countEditsOpen === 1) {
                    updateViewRenewPolicy({
                      isProposalReadyForRenewal: true,
                    });
                      setEnableRenew(true);
                    }
                    setFieldValue(
                      `countEditsOpen`,
                      values?.countEditsOpen - 1,
                    );
                  } else {
                    /**Hard delete */
                    let valuesAfterDeleteInsured = {},
                      valuesAfterDeleteNominee = {},
                      valuesAfterDeletePrevInsured = {};

                    Object.keys(values?.insuredDetails)?.forEach(
                      (ins) => {
                        if (
                          ins?.toLowerCase() !==
                          nominee?.toLowerCase()
                        ) {
                          valuesAfterDeleteInsured[ins] =
                            values?.insuredDetails[ins];
                        }
                      },
                    );
                    Object.keys(values?.nomineeDetails)?.forEach(
                      (nom) => {
                        if (
                          nom?.toLowerCase() !==
                          nominee?.toLowerCase()
                        ) {
                          valuesAfterDeleteNominee[nom] =
                            values?.nomineeDetails[nom];
                        }
                      },
                    );
                    Object.keys(
                      values?.prevInsuranceDetails,
                    )?.forEach((prevInsured) => {
                      if (
                        prevInsured?.toLowerCase() !==
                        nominee?.toLowerCase()
                      ) {
                        valuesAfterDeletePrevInsured[prevInsured] =
                          values?.prevInsuranceDetails[prevInsured];
                      }
                    });
                    setFieldValue(
                      `insuredDetails`,
                      valuesAfterDeleteInsured,
                    );
                    setFieldValue(
                      `nomineeDetails`,
                      valuesAfterDeleteNominee,
                    );
                    setFieldValue(
                      `prevInsuranceDetails`,
                      valuesAfterDeletePrevInsured,
                    );
                    setValueChanges(values);
                    setAlerts([
                      {
                        header: 'Member details removed',
                        id:
                          (alerts?.length + 1) *
                          Date.now() *
                          Math.random() *
                          10000,
                        content: (
                          <div className="flex flex-col flex-wrap space-y-2 w-full h-full">
                            <div className="flex justify-start space-x-2 w-full items-start">
                              <Text
                                severity="warning"
                                type="large"
                                className="flex flex-col justify-start items-start"
                              >
                                •
                              </Text>
                              <Text>
                                {nominee} details has been removed for
                                renewal
                              </Text>
                            </div>
                            <div className="flex justify-start space-x-2 w-full items-start">
                              <Text
                                severity="warning"
                                type="large"
                                className="flex flex-col justify-start items-start"
                              >
                                •
                              </Text>
                              <Text>
                                Choose plan and covers apart from{' '}
                                {nominee}
                              </Text>
                            </div>
                          </div>
                        ),
                        type: 'warning',
                        timeout: null,
                        disableClose: false,
                      },
                      ...alerts,
                    ]);
                    if (
                      props.forwardedAlertsRef &&
                      props.forwardedAlertsRef.current
                    ) {
                      props.forwardedAlertsRef.current = [];
                    }
                    if (values?.countEditsOpen === 1) {
                    updateViewRenewPolicy({
                      planName: '',
                      totalPremium: '',
                      isProposalReadyForRenewal: true,
                    });
                      setEnableRenew(true);
                    } else {
                      updateViewRenewPolicy({
                        planName: '',
                        totalPremium: '',
                      });
                    }
                    setFieldValue(
                      `countEditsOpen`,
                      values?.countEditsOpen - 1,
                    );
                  }
                  expandedCard.current = [
                    ...expandedCard.current.filter(
                      (exp) => exp?.cardName !== 'nomineeDetails',
                    ),
                    {
                      ...expandedCard.current.find(
                        (exp) => exp?.cardName === 'nomineeDetails',
                      ),
                      cardFlag: false,
                      subSections: [
                        ...expandedCard?.current
                          ?.find(
                            (exp) =>
                              exp?.cardName === 'nomineeDetails',
                          )
                          ?.subSections?.filter(
                            (subSection) =>
                              subSection !== `${nominee}`,
                          ),
                      ],
                    },
                  ];
                  setNomineeDetailsCardToggle(true);
                },
                onValueChanges: (values) => {
                  setValueChanges(values);
                },
                disableEdit: values?.isCalculatingPremium,
                disableCancel: values?.isCalculatingPremium,
                initDisplayEdit: viewRenewPolicy?.isProposalRenewed
                  ? false
                  : values?.nomineeDetails[nominee]?.isSoftAdded ||
                    expandedCard?.current
                      ?.find(
                        (exp) => exp?.cardName === 'nomineeDetails',
                      )
                      ?.subSections?.find(
                        (subSection) => subSection === `${nominee}`,
                      ) !== undefined,
                grid_data: [
                  {
                    label: (
                      <div
                        className={`${
                          values?.insuredDetails[nominee]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Name <Text severity="error">*</Text>
                      </div>
                    ),
                    isTextDisabled:
                      values?.insuredDetails[nominee]
                        ?.isMemberDeleted,
                    disabled:
                      values?.insuredDetails[nominee]
                        ?.isMemberDeleted ||
                      values?.isCalculatingPremium,
                    labelReadOnly: (
                      <div
                        className={`${
                          values?.insuredDetails[nominee]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Name <Text severity="error"></Text>
                      </div>
                    ),
                    type: 'text',
                    name: `nomineeDetails.${nominee}.name`,
                  },
                  {
                    label: (
                      <div
                        className={`${
                          values?.insuredDetails[nominee]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Date Of Birth <Text severity="error">*</Text>
                      </div>
                    ),
                    isTextDisabled:
                      values?.insuredDetails[nominee]
                        ?.isMemberDeleted,
                    disabled:
                      values?.insuredDetails[nominee]
                        ?.isMemberDeleted ||
                      values?.isCalculatingPremium,
                    labelReadOnly: (
                      <div
                        className={`${
                          values?.insuredDetails[nominee]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Date Of Birth <Text severity="error"></Text>
                      </div>
                    ),
                    type: 'date',
                    name: `nomineeDetails.${nominee}.dob`,
                    onDataChange: (val, setFieldValue) => {
                      if (
                        moment(new Date(), 'DD/MM/YYYY').diff(
                          moment(val, 'DD/MM/YYYY'),
                          'years',
                        ) >= MINOR_THRESHOLD_AGE
                      ) {
                        setFieldValue(
                          `nomineeDetails.${nominee}.nameOfAppointee`,
                          '',
                        );
                        setFieldValue(
                          `nomineeDetails.${nominee}.relationshipWithAppointee`,
                          '',
                        );
                      }
                    },
                  },
                  {
                    label: (
                      <div
                        className={`${
                          values?.insuredDetails[nominee]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Relation with Member{' '}
                        <Text severity="error">*</Text>
                      </div>
                    ),
                    isTextDisabled:
                      values?.insuredDetails[nominee]
                        ?.isMemberDeleted,
                    disabled:
                      values?.insuredDetails[nominee]
                        ?.isMemberDeleted ||
                      values?.isCalculatingPremium,
                    labelReadOnly: (
                      <div
                        className={`${
                          values?.insuredDetails[nominee]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Relation with Member{' '}
                        <Text severity="error"></Text>
                      </div>
                    ),
                    type: 'select',
                    searchable: true,
                    readOnlyValue: getDomainData(
                      PRD_NomiRelationWithMemb,
                      values?.nomineeDetails[nominee]
                        ?.relationshipWithInsured,
                      'code',
                      'value',
                    )?.toString(),
                    name: `nomineeDetails.${nominee}.relationshipWithInsured`,
                    data: PRD_NomiRelationWithMemb
                      ? [
                          ...PRD_NomiRelationWithMemb.map(
                            (relationshipWithMember) => {
                              return {
                                label: relationshipWithMember?.value
                                  ? relationshipWithMember?.value
                                  : '',
                                value: relationshipWithMember?.code
                                  ? relationshipWithMember?.code
                                  : '',
                              };
                            },
                          ),
                        ]
                      : [],
                  },
                  {
                    label: (
                      <div
                        className={`${
                          values?.insuredDetails[nominee]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Appointee Name (for Minor){' '}
                        <Text severity="error">
                          {moment(new Date(), 'DD/MM/YYYY').diff(
                            moment(
                              values?.nomineeDetails[nominee]?.dob,
                              'DD/MM/YYYY',
                            ),
                            'years',
                          ) < MINOR_THRESHOLD_AGE
                            ? '*'
                            : ''}
                        </Text>
                      </div>
                    ),
                    type: 'text',
                    isTextDisabled:
                      values?.insuredDetails[nominee]
                        ?.isMemberDeleted,
                    name: `nomineeDetails.${nominee}.nameOfAppointee`,
                    disabled:
                      moment(new Date(), 'DD/MM/YYYY').diff(
                        moment(
                          values?.nomineeDetails[nominee]?.dob,
                          'DD/MM/YYYY',
                        ),
                        'years',
                      ) >= MINOR_THRESHOLD_AGE ||
                      values?.insuredDetails[nominee]
                        ?.isMemberDeleted ||
                      values?.isCalculatingPremium,
                  },
                  {
                    label: (
                      <div
                        className={`${
                          values?.insuredDetails[nominee]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Relation with Nominee{' '}
                        <Text severity="error">
                          {moment(new Date(), 'DD/MM/YYYY').diff(
                            moment(
                              values?.nomineeDetails[nominee]?.dob,
                              'DD/MM/YYYY',
                            ),
                            'years',
                          ) < MINOR_THRESHOLD_AGE
                            ? '*'
                            : ''}
                        </Text>
                      </div>
                    ),
                    type: 'select',
                    searchable: true,
                    isTextDisabled:
                      values?.insuredDetails[nominee]
                        ?.isMemberDeleted,
                    name: `nomineeDetails.${nominee}.relationshipWithAppointee`,
                    readOnlyValue: getDomainData(
                      PRD_ApointRelationWithMinNomi,
                      values?.nomineeDetails[nominee]
                        ?.relationshipWithAppointee,
                      'code',
                      'value',
                    )?.toString(),
                    disabled:
                      moment(new Date(), 'DD/MM/YYYY').diff(
                        moment(
                          values?.nomineeDetails[`${nominee}`]?.dob,
                          'DD/MM/YYYY',
                        ),
                        'years',
                      ) >= MINOR_THRESHOLD_AGE ||
                      values?.insuredDetails[nominee]
                        ?.isMemberDeleted ||
                      values?.isCalculatingPremium,
                    data: PRD_ApointRelationWithMinNomi
                      ? [
                          ...PRD_ApointRelationWithMinNomi.map(
                            (relationshipWithAppointee) => {
                              return {
                                label:
                                  relationshipWithAppointee?.value
                                    ? relationshipWithAppointee?.value
                                    : '',
                                value: relationshipWithAppointee?.code
                                  ? relationshipWithAppointee?.code
                                  : '',
                              };
                            },
                          ),
                        ]
                      : [],
                  },
                ].filter((d) => d),
              };
            })
        : [];

    const prevInsuranceDetailsData =
      Object.keys(values?.prevInsuranceDetails)?.length > 0
        ? Object.keys(values?.prevInsuranceDetails)
            ?.filter(
              (prevInsured) =>
                !values?.prevInsuranceDetails[prevInsured]
                  ?.isHardDeleted,
            )
            ?.map((prevInsured, idx) => {
              return {
                title: (
                  <Text
                    type="normal"
                    className={`${
                      values?.insuredDetails[prevInsured]
                        ?.isMemberDeleted
                        ? 'text-neutral-darker'
                        : ''
                    }`}
                  >
                    {prevInsured} - Previous Insurance Policy {'&'}{' '}
                    Claims
                    {/* {values?.insuredDetails[prevInsured]
                      ?.isMemberDeleted
                      ? ' (Claim excluded)'
                      : ''} */}
                  </Text>
                ),
                grid_type: 'input',
                clickToEdit: true,
                resetOnCancel: false,
                isBorderRequired: idx !== 0,
                disableSubmit:
                  values?.isCalculatingPremium ||
                  values?.prevInsuranceDetails[prevInsured]
                    ?.isHardDeleted ||
                  values?.insuredDetails[prevInsured]?.isMemberDeleted
                    ? true
                    : Object.keys(validate(values))?.length > 0 &&
                      Object.keys(
                        validate(values)?.prevInsuranceDetails[
                          prevInsured
                        ],
                      ).length > 0,
                borderClassName: 'border-t-2 border-neutral pt-4',
                isSectionDeleted:
                  values?.prevInsuranceDetails[prevInsured]
                    ?.isHardDeleted,
                isDeleted:
                  values?.insuredDetails[prevInsured]
                    ?.isMemberDeleted,
                onEdit: (_) => {
                  setEnableRenew(false);
                  setDisplayEditExternalsPreviousInsured([...displayEditExternalsPreviousInsured,prevInsured]);
                  setFieldValue(
                    `countEditsOpen`,
                    values?.countEditsOpen + 1,
                  );
                  if (
                    props.forwardedAlertsRef &&
                    props.forwardedAlertsRef.current
                  ) {
                    props.forwardedAlertsRef.current = [];
                  }
                  updateViewRenewPolicy({
                    isProposalReadyForRenewal: false,
                  });
                  expandedCard.current = [
                    ...expandedCard.current.filter(
                      (exp) => exp?.cardName !== 'prevInsuredDetails',
                    ),
                    {
                      ...expandedCard.current.find(
                        (exp) =>
                          exp?.cardName === 'prevInsuredDetails',
                      ),
                      cardFlag: true,
                      subSections: [
                        ...expandedCard?.current?.find(
                          (exp) =>
                            exp?.cardName === 'prevInsuredDetails',
                        )?.subSections,
                        `${prevInsured}`,
                      ],
                    },
                  ];
                  setPrevInsuredDetailsCardToggle(true);
                },
                displayEditExternal: displayEditExternalsPreviousInsured?.find((d)=> d=== prevInsured) ? true: false,
                onSave: (_) => {
                  // setEnableRenew(true);-- removed sharmila changes
                  if (values?.countEditsOpen === 1) {
                    updateViewRenewPolicy({
                      isProposalReadyForRenewal: true,
                    });
                      setEnableRenew(true);
                  }
                  setDisplayEditExternalsPreviousInsured(displayEditExternalsPreviousInsured?.filter((d)=>d!==prevInsured));
                  setFieldValue(
                    `countEditsOpen`,
                    values?.countEditsOpen - 1,
                  );
                  if (
                    values?.prevInsuranceDetails[prevInsured]
                      ?.isSoftAdded
                  ) {
                    setFieldValue(
                      `prevInsuranceDetails.${prevInsured}.isSoftAdded`,
                      false,
                    );
                  }
                  if (
                    props.forwardedAlertsRef &&
                    props.forwardedAlertsRef.current
                  ) {
                    props.forwardedAlertsRef.current = [];
                  }
                  expandedCard.current = [
                    ...expandedCard.current.filter(
                      (exp) => exp?.cardName !== 'prevInsuredDetails',
                    ),
                    {
                      ...expandedCard.current.find(
                        (exp) =>
                          exp?.cardName === 'prevInsuredDetails',
                      ),
                      cardFlag: false,
                      subSections: [
                        ...expandedCard?.current
                          ?.find(
                            (exp) =>
                              exp?.cardName === 'prevInsuredDetails',
                          )
                          ?.subSections?.filter(
                            (subSection) =>
                              subSection !== `${prevInsured}`,
                          ),
                      ],
                    },
                  ];
                  setPrevInsuredDetailsCardToggle(true);
                },
                onCancel: (_, valuesBeforeEdit) => {
                  if (values?.countEditsOpen === 1) {
                    updateViewRenewPolicy({
                      isProposalReadyForRenewal: true,
                    });
                    setEnableRenew(true);
                  }
                  setFieldValue(
                    `countEditsOpen`,
                    values?.countEditsOpen - 1,
                  );
                  setFieldValue(
                    `prevInsuranceDetails.${prevInsured}`,
                    valuesBeforeEdit?.prevInsuranceDetails[
                      prevInsured
                    ],
                  );
                  if (
                    props.forwardedAlertsRef &&
                    props.forwardedAlertsRef.current
                  ) {
                    props.forwardedAlertsRef.current = [];
                  }
                  expandedCard.current = [
                    ...expandedCard.current.filter(
                      (exp) => exp?.cardName !== 'prevInsuredDetails',
                    ),
                    {
                      ...expandedCard.current.find(
                        (exp) =>
                          exp?.cardName === 'prevInsuredDetails',
                      ),
                      cardFlag: false,
                      subSections: [
                        ...expandedCard?.current
                          ?.find(
                            (exp) =>
                              exp?.cardName === 'prevInsuredDetails',
                          )
                          ?.subSections?.filter(
                            (subSection) =>
                              subSection !== `${prevInsured}`,
                          ),
                      ],
                    },
                  ];
                  setPrevInsuredDetailsCardToggle(true);
                },
                disableEdit: values?.isCalculatingPremium,
                disableCancel: values?.isCalculatingPremium,
                onValueChanges: (values) => {
                  setValueChanges(values);
                },
                // initDisplayEdit: viewRenewPolicy?.isProposalRenewed
                //   ? false
                //   : values?.prevInsuranceDetails[prevInsured]
                //       ?.isSoftAdded ||
                //     expandedCard?.current
                //       ?.find(
                //         (exp) =>
                //           exp?.cardName === 'prevInsuredDetails',
                //       )
                //       ?.subSections?.includes(`${prevInsured}`),
                editDisplayDisabled:
                  values?.insuredDetails[prevInsured]?.memberID !==
                    '' || viewRenewPolicy?.isProposalRenewed
                    ||
                  viewRenewPolicy?.isProposalRenewed ||
                  renewalFlag?.toString()?.toLowerCase() ===
                    'expired',
                grid_data: [
                  {
                    label: (
                      <div
                        className={`${
                          values?.insuredDetails[prevInsured]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Previous Insurer Name{' '}
                        <Text severity="error">
                          {validate(values)?.prevInsuranceDetails &&
                          validate(values)?.prevInsuranceDetails[
                            prevInsured
                          ]?.prevInsurerName
                            ? `*`
                            : ``}
                        </Text>
                      </div>
                    ),
                    labelReadOnly: (
                      <div
                        className={`${
                          values?.insuredDetails[prevInsured]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Previous Insurer Name{' '}
                        <Text severity="error"></Text>
                      </div>
                    ),
                    isTextDisabled:
                      values?.insuredDetails[prevInsured]
                        ?.isMemberDeleted,
                    disabled:
                      values?.insuredDetails[prevInsured]
                        ?.isMemberDeleted ||
                      values?.isCalculatingPremium,
                    searchable: true,
                    type: 'select',
                    name: `prevInsuranceDetails.${prevInsured}.prevInsurerName`,
                    readOnlyValue: getDomainData(
                      rolloverCompanyList,
                      values?.prevInsuranceDetails[prevInsured]
                        ?.prevInsurerName,
                      'code',
                      'value',
                    )?.toString(),
                    data:
                      rolloverCompanyList &&
                      rolloverCompanyList?.length > 0
                        ? rolloverCompanyList?.map((company) => {
                            return {
                              label: company?.value
                                ? company?.value
                                : '',
                              value: company?.code
                                ? company?.code
                                : '',
                            };
                          })
                        : [],
                  },
                  {
                    label: (
                      <div
                        className={`${
                          values?.insuredDetails[prevInsured]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Previous Policy Number{' '}
                        <Text severity="error">
                          {validate(values)?.prevInsuranceDetails &&
                          validate(values)?.prevInsuranceDetails[
                            prevInsured
                          ]?.prevPolicyNo
                            ? `*`
                            : ``}
                        </Text>
                      </div>
                    ),
                    labelReadOnly: (
                      <div
                        className={`${
                          values?.insuredDetails[prevInsured]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Previous Policy Number{' '}
                        <Text severity="error"></Text>
                      </div>
                    ),
                    isTextDisabled:
                      values?.insuredDetails[prevInsured]
                        ?.isMemberDeleted,
                    disabled:
                      values?.insuredDetails[prevInsured]
                        ?.isMemberDeleted ||
                      values?.isCalculatingPremium,
                    type: 'text',
                    name: `prevInsuranceDetails.${prevInsured}.prevPolicyNo`,
                  },
                  {
                    label: (
                      <div
                        className={`${
                          values?.insuredDetails[prevInsured]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Sum Insured{' '}
                        <Text severity="error">
                          {validate(values)?.prevInsuranceDetails &&
                          validate(values)?.prevInsuranceDetails[
                            prevInsured
                          ]?.prevPolicySI
                            ? `*`
                            : ``}
                        </Text>
                      </div>
                    ),
                    labelReadOnly: (
                      <div
                        className={`${
                          values?.insuredDetails[prevInsured]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Sum Insured <Text severity="error"></Text>
                      </div>
                    ),
                    type: 'number',
                    min: 0,
                    isTextDisabled:
                      values?.insuredDetails[prevInsured]
                        ?.isMemberDeleted,
                    disabled:
                      values?.insuredDetails[prevInsured]
                        ?.isMemberDeleted ||
                      values?.isCalculatingPremium,
                    readOnlyValue: CurrencyFormater(
                      values?.prevInsuranceDetails[prevInsured]
                        ?.prevPolicySI,
                      true,
                      false,
                      branding,
                    ),
                    iconPre: (
                      <Text
                        severity={`${
                          values?.insuredDetails[prevInsured]
                            ?.isMemberDeleted ||
                          values?.isCalculatingPremium
                            ? 'neutral'
                            : 'info'
                        }`}
                      >
                        {branding.currency}
                      </Text>
                    ),
                    className:
                      values?.insuredDetails[prevInsured]
                        ?.isMemberDeleted ||
                      values?.isCalculatingPremium
                        ? 'border-neutral-dark'
                        : '',
                    onKeyDown: (evt) =>
                      (evt.key === 'e' || evt.key === '-') &&
                      evt.preventDefault(),
                    name: `prevInsuranceDetails.${prevInsured}.prevPolicySI`,
                  },
                  {
                    label: (
                      <div
                        className={`${
                          values?.insuredDetails[prevInsured]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Policy Start Date{' '}
                        <Text severity="error">
                          {validate(values)?.prevInsuranceDetails &&
                          validate(values)?.prevInsuranceDetails[
                            prevInsured
                          ]?.prevPolicyStartDate
                            ? `*`
                            : ``}
                        </Text>
                      </div>
                    ),
                    labelReadOnly: (
                      <div
                        className={`${
                          values?.insuredDetails[prevInsured]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Policy Start Date{' '}
                        <Text severity="error"></Text>
                      </div>
                    ),
                    type: 'date',
                    isTextDisabled:
                      values?.insuredDetails[prevInsured]
                        ?.isMemberDeleted,
                    disabled:
                      values?.insuredDetails[prevInsured]
                        ?.isMemberDeleted ||
                      values?.isCalculatingPremium,
                    name: `prevInsuranceDetails.${prevInsured}.prevPolicyStartDate`,
                  },
                  {
                    label: (
                      <div
                        className={`${
                          values?.insuredDetails[prevInsured]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Policy Expiry Date{' '}
                        <Text severity="error">
                          {validate(values)?.prevInsuranceDetails &&
                          validate(values)?.prevInsuranceDetails[
                            prevInsured
                          ]?.prevPolicyEndDate
                            ? `*`
                            : ``}
                        </Text>
                      </div>
                    ),
                    labelReadOnly: (
                      <div
                        className={`${
                          values?.insuredDetails[prevInsured]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Policy Expiry Date{' '}
                        <Text severity="error"></Text>
                      </div>
                    ),
                    type: 'date',
                    isTextDisabled:
                      values?.insuredDetails[prevInsured]
                        ?.isMemberDeleted,
                    disabled:
                      values?.insuredDetails[prevInsured]
                        ?.isMemberDeleted ||
                      values?.isCalculatingPremium,
                    name: `prevInsuranceDetails.${prevInsured}.prevPolicyEndDate`,
                  },
                  {
                    label: (
                      <div
                        className={`${
                          values?.insuredDetails[prevInsured]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Claims lodged in past policy?{' '}
                        <Text severity="error">
                          {validate(values)?.prevInsuranceDetails &&
                          validate(values)?.prevInsuranceDetails[
                            prevInsured
                          ]?.prevClaimLodged
                            ? `*`
                            : ``}
                        </Text>
                      </div>
                    ),
                    labelReadOnly: (
                      <div
                        className={`${
                          values?.insuredDetails[prevInsured]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Claims lodged in past policy?
                        <Text severity="error"></Text>
                      </div>
                    ),
                    type: 'select',
                    name: `prevInsuranceDetails.${prevInsured}.prevClaimLodged`,
                    isTextDisabled:
                      values?.insuredDetails[prevInsured]
                        ?.isMemberDeleted,
                    disabled:
                      values?.insuredDetails[prevInsured]
                        ?.isMemberDeleted ||
                      values?.isCalculatingPremium,
                    data: [
                      {
                        label: 'Yes',
                        value: 'YES',
                      },
                      {
                        label: 'No',
                        value: 'NO',
                      },
                    ],
                    onDataChange: (val, setFieldValue) => {
                      if (val?.toLowerCase() === 'no') {
                        setFieldValue(
                          `prevInsuranceDetails.${prevInsured}.claimAmount`,
                          '',
                        );
                        setFieldValue(
                          `prevInsuranceDetails.${prevInsured}.cbAmount`,
                          '',
                        );
                      }
                    },
                  },
                  {
                    label: (
                      <div
                        className={`${
                          values?.insuredDetails[prevInsured]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Claim Amount{' '}
                        {values?.prevInsuranceDetails[
                          `${prevInsured}`
                        ]?.prevClaimLodged?.toLowerCase() ===
                        'yes' ? (
                          <Text severity="error">
                            {validate(values)?.prevInsuranceDetails &&
                            validate(values)?.prevInsuranceDetails[
                              prevInsured
                            ]?.claimAmount
                              ? `*`
                              : ``}
                          </Text>
                        ) : (
                          <Text></Text>
                        )}
                      </div>
                    ),
                    labelReadOnly: (
                      <div
                        className={`${
                          values?.insuredDetails[prevInsured]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Claim Amount <Text></Text>
                      </div>
                    ),
                    type: 'number',
                    min: 0,
                    name: `prevInsuranceDetails.${prevInsured}.claimAmount`,
                    className: `${
                      values?.isCalculatingPremium ||
                      values?.insuredDetails[prevInsured]
                        ?.isMemberDeleted ||
                      values?.prevInsuranceDetails[
                        `${prevInsured}`
                      ]?.prevClaimLodged?.toLowerCase() === 'no'
                        ? 'border-neutral-dark'
                        : ''
                    }`,
                    isTextDisabled:
                      values?.insuredDetails[prevInsured]
                        ?.isMemberDeleted,
                    disabled:
                      values?.isCalculatingPremium ||
                      values?.insuredDetails[prevInsured]
                        ?.isMemberDeleted ||
                      values?.prevInsuranceDetails[
                        `${prevInsured}`
                      ]?.prevClaimLodged?.toLowerCase() === 'no',
                    readOnlyValue: CurrencyFormater(
                      values?.prevInsuranceDetails[prevInsured]
                        ?.claimAmount,
                      true,
                      false,
                      branding,
                    ),
                    onDataChange: (val, setFieldValue) => {
                      if (
                        !val &&
                        !values?.prevInsuranceDetails[
                          `${prevInsured}`
                        ]?.cbAmount
                      ) {
                        setFieldValue(
                          `prevInsuranceDetails.${prevInsured}.prevClaimLodged`,
                          '',
                        );
                      } else {
                        if (
                          !values?.prevInsuranceDetails[
                            `${prevInsured}`
                          ]?.prevClaimLodged
                        ) {
                          setFieldValue(
                            `prevInsuranceDetails.${prevInsured}.prevClaimLodged`,
                            'YES',
                          );
                        }
                      }
                    },
                    onKeyDown: (evt) =>
                      (evt.key === 'e' || evt.key === '-') &&
                      evt.preventDefault(),
                    iconPre: (
                      <Text
                        severity={`${
                          values?.isCalculatingPremium ||
                          values?.insuredDetails[prevInsured]
                            ?.isMemberDeleted ||
                          values?.prevInsuranceDetails[
                            `${prevInsured}`
                          ]?.prevClaimLodged?.toLowerCase() === 'no'
                            ? 'neutral'
                            : 'info'
                        }`}
                      >
                        {branding.currency}
                      </Text>
                    ),
                  },
                  {
                    label: (
                      <div
                        className={`${
                          values?.insuredDetails[prevInsured]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Cummulative Bonus Amount{' '}
                        {values?.prevInsuranceDetails[
                          `${prevInsured}`
                        ]?.prevClaimLodged?.toLowerCase() ===
                        'yes' ? (
                          <Text severity="error">
                            {validate(values)?.prevInsuranceDetails &&
                            validate(values)?.prevInsuranceDetails[
                              prevInsured
                            ]?.cbAmount
                              ? `*`
                              : ``}
                          </Text>
                        ) : (
                          <Text></Text>
                        )}
                      </div>
                    ),
                    labelReadOnly: (
                      <div
                        className={`${
                          values?.insuredDetails[prevInsured]
                            ?.isMemberDeleted
                            ? 'text-neutral-darker'
                            : ''
                        }`}
                      >
                        Cummulative Bonus Amount <Text></Text>
                      </div>
                    ),
                    type: 'number',
                    min: 0,
                    name: `prevInsuranceDetails.${prevInsured}.cbAmount`,
                    className: `${
                      values?.isCalculatingPremium ||
                      values?.insuredDetails[prevInsured]
                        ?.isMemberDeleted ||
                      values?.prevInsuranceDetails[
                        `${prevInsured}`
                      ]?.prevClaimLodged?.toLowerCase() === 'no'
                        ? 'border-neutral-dark'
                        : ''
                    }`,
                    isTextDisabled:
                      values?.insuredDetails[prevInsured]
                        ?.isMemberDeleted,
                    disabled:
                      values?.isCalculatingPremium ||
                      values?.insuredDetails[prevInsured]
                        ?.isMemberDeleted ||
                      values?.prevInsuranceDetails[
                        `${prevInsured}`
                      ]?.prevClaimLodged?.toLowerCase() === 'no',
                    readOnlyValue: CurrencyFormater(
                      values?.prevInsuranceDetails[prevInsured]
                        ?.cbAmount,
                      true,
                      false,
                      branding,
                    ),
                    onDataChange: (val, setFieldValue) => {
                      if (
                        !val &&
                        !values?.prevInsuranceDetails[
                          `${prevInsured}`
                        ]?.claimAmount
                      ) {
                        setFieldValue(
                          `prevInsuranceDetails.${prevInsured}.prevClaimLodged`,
                          '',
                        );
                      } else {
                        if (
                          !values?.prevInsuranceDetails[
                            `${prevInsured}`
                          ]?.prevClaimLodged
                        ) {
                          setFieldValue(
                            `prevInsuranceDetails.${prevInsured}.prevClaimLodged`,
                            'YES',
                          );
                        }
                      }
                    },
                    onKeyDown: (evt) =>
                      (evt.key === 'e' || evt.key === '-') &&
                      evt.preventDefault(),
                    iconPre: (
                      <Text
                        severity={`${
                          values?.isCalculatingPremium ||
                          values?.insuredDetails[prevInsured]
                            ?.isMemberDeleted ||
                          values?.prevInsuranceDetails[
                            `${prevInsured}`
                          ]?.prevClaimLodged?.toLowerCase() === 'no'
                            ? 'neutral'
                            : 'info'
                        }`}
                      >
                        {branding.currency}
                      </Text>
                    ),
                  },
                ],
              };
            })
        : [];

    const underwritingAssignmentData = portabilityDetails
      ? portabilityDetails?.map((memberPortability) => {
          return {
            title: (
              <Text type="normal">
                {memberPortability?.insuredRelationship}
              </Text>
            ),
            grid_type: 'data',
            grid_data: [
              {
                label: 'Member ID',
                text: memberPortability?.memberId,
              },
              {
                label: 'Insured Name',
                text: memberPortability?.memberName,
              },
              {
                label:
                  'Sum Insured (including Cumulative Bonus, if any)',
                text: CurrencyFormater(
                  parseFloat(
                    memberPortability?.sumInsuredIncCumBonusifany,
                  ),
                  true,
                  false,
                  branding,
                ),
              },
              {
                label: '30 Days Waiting Period',
                text: memberPortability?.thirtyDaysWaitingPeriod,
              },
              {
                label: '2 Years Waiting Period',
                text: memberPortability?.twoYearsWaitingPeriod,
              },
              {
                label: 'PED (4 Years) Waiting Period',
                text: memberPortability?.ped4YearsWaitingPeriod,
              },
            ],
          };
        })
      : [];

    const renewalMandateData = [
      {
        grid_type: 'data',
        grid_data: [
          
          { 
            type: 'checkbox',
            name: 'renewalPaymentMandate',
                label: (
              <Text>
                    Do you want to set up a renewal payment mandate in
                    the name of{' '}
                {
                  PRD_RenewalPaymentMandateTakenInTheNameOf[0]
                    ?.value
                }
                    ?
                  </Text>
                ),
            colSpan: repeat,
          },
        ].filter((d) => d),
      },
    ];
    const renewalMandateData1 = [
      {
        title: (
        <Text
          type="normal"
          className={`text-neutral-darker`}
        >
          Renewal Mandate
          </Text>
        ),
        grid_type: 'input',
        clickToEdit:false,
        //  renewalMandateDetails?.renewalPaymentMandate?.toString()?.toLowerCase() === 'yes' ? false : true,
      resetOnCancel: false,
      // isBorderRequired: idx !== 0,
      // disableSubmit:  values?.isCalculatingPremium ,
      borderClassName: 'border-t-2 border-neutral pt-4',
      editDisplayDisabled:
      viewRenewPolicy?.isProposalRenewed,
        onEdit: (_) => {
          setEnableRenew(false);
        setFieldValue(
          `countEditsOpen`,
          values?.countEditsOpen + 1,
        );
        if (
          props.forwardedAlertsRef &&
          props.forwardedAlertsRef.current
        ) {
          props.forwardedAlertsRef.current = [];
              }
        updateViewRenewPolicy({
          isProposalReadyForRenewal: false,
        });
          expandedCard.current = [
            ...expandedCard.current.filter(
            (exp) => exp?.cardName !== 'RenewalMandate',
            ),
          {
              ...expandedCard.current.find(
              (exp) =>
                exp?.cardName === 'RenewalMandate',
              ),
              cardFlag: true,
              subSections: [
                ...expandedCard.current.find(
                  (exp) => exp?.cardName === 'RenewalMandate',
                )?.subSections,
                'RenewalMandateDetails',
              ],
          },
          ];
          setRenewalMandateCardToggle(true);
          },
      //displayEditExternal: displayEditExternalsPreviousInsured?.find((d)=> d=== prevInsured) ? true: false,
      onSave: (_) => {
         setEnableRenew(true);
          if (values?.countEditsOpen === 1) {
          updateViewRenewPolicy({
              isProposalReadyForRenewal: true,
            });
            setEnableRenew(true);
          }
        // setDisplayEditExternalsPreviousInsured(displayEditExternalsPreviousInsured?.filter((d)=>d!==prevInsured));
          setFieldValue(
          `countEditsOpen`,
          values?.countEditsOpen - 1,
          );
        if (
            values?.renewalMandateDetails?.renewalPaymentMandate === true
        ) {
          setFieldValue(
              `renewalMandateDetails.renewalPaymentMandate`, true,
          );
            //  setRenewalPaymentMandatevalue('Yes')
        }
        else{
          setFieldValue(
              `renewalMandateDetails.renewalPaymentMandate`, false,
          );
            // setRenewalPaymentMandatevalue('No')
        }
        if (
          props.forwardedAlertsRef &&
          props.forwardedAlertsRef.current
        ) {
          props.forwardedAlertsRef.current = [];
        }
          expandedCard.current = [
            ...expandedCard.current.filter(
            (exp) => exp?.cardName !== 'RenewalMandate',
            ),
          {
              ...expandedCard.current.find(
              (exp) =>
                exp?.cardName === 'RenewalMandate',
              ),
              cardFlag: false,
              subSections: [
                ...expandedCard.current
                  .find(
                    (exp) => exp?.cardName === 'RenewalMandate',
                )
                  ?.subSections?.filter(
                  (subSection) =>
                      subSection !==
                      'RenewalMandateDetails',
                  ),
              ],
          },
          ];
          setRenewalMandateCardToggle(true);
          },
      onCancel: (_, valuesBeforeEdit) => {
        if (values?.countEditsOpen === 1) {
          updateViewRenewPolicy({
              isProposalReadyForRenewal: true,
            });
            setEnableRenew(true);
          }
        setFieldValue(
          `countEditsOpen`,
          values?.countEditsOpen - 1,
        );
        setFieldValue(
            `renewalMandateDetails.renewalPaymentMandate`,
          valuesBeforeEdit?.renewalPaymentMandate
        );
        if (
          props.forwardedAlertsRef &&
          props.forwardedAlertsRef.current
        ) {
          props.forwardedAlertsRef.current = [];
        }
          expandedCard.current = [
            ...expandedCard.current.filter(
            (exp) => exp?.cardName !== 'RenewalMandate',
            ),
          {
              ...expandedCard.current.find(
              (exp) =>
                exp?.cardName === 'RenewalMandate',
              ),
              cardFlag: false,
              subSections: [
                ...expandedCard.current
                  .find(
                    (exp) => exp?.cardName === 'RenewalMandate',
                  )
                  ?.subSections?.filter(
                    (subSection) =>
                      subSection !==
                      'RenewalMandateDetails',
                  ),
              ],
          },
          ];
          setRenewalMandateCardToggle(true);
          },
          editDisplayDisabled: renewalFlag?.toString()?.toLowerCase() === 'expired',    
      disableEdit: values?.isCalculatingPremium,
      disableCancel: values?.isCalculatingPremium,
      disableEdit: values?.isCalculatingPremium,
        resetOnCancel: false,
      onValueChanges: (values) => {
        setValueChanges(values);
          },
      initDisplayEdit: false,
      // viewRenewPolicy?.isProposalRenewed
      // ? false
      // : expandedCard.current
      //     .find((exp) => exp?.cardName === 'RenewalMandate')
      //     ?.subSections?.includes(
      //       'RenewalMandateDetails',
      //     ),
      editDisplayDisabled: viewRenewPolicy?.isProposalRenewed,
        grid_data: [
          {
            labelReadOnly:  (
              <>
              <Text>
                Do you want to set up a renewal payment mandate in
                the name of {' '}
          {
                  PRD_RenewalPaymentMandateTakenInTheNameOf[0]
                    ?.value
                }{}
                ?
              </Text>
              <br/>
                <Text>{(values?.renewalMandateDetails?.renewalPaymentMandate === true
                  || values?.renewalMandateDetails?.renewalPaymentMandate?.toString()?.toLowerCase() === 'yes')
                  ? 'Yes' : 'No'}</Text>
              </>
            ),
          label: (
            <Text>
              Do you want to set up a renewal payment mandate in
              the name of{' '}
          {
                PRD_RenewalPaymentMandateTakenInTheNameOf[0]
                  ?.value
              }
              ?
            </Text>
          ),
          // isTextDisabled:
          //   values?.insuredDetails[prevInsured]
          //     ?.isMemberDeleted,
          // disabled:
          //   values?.isCalculatingPremium,
            disabled:true,
            // values?.isCalculatingPremium || renewalMandateDetails?.renewalPaymentMandate?.toString()?.toLowerCase() === 'yes',
          searchable: true,
          type: 'checkbox',
            name: `renewalMandateDetails.renewalPaymentMandate`,
          // readOnlyValue: getDomainData(
          //   rolloverCompanyList,
          //   values?.prevInsuranceDetails[prevInsured]
          //     ?.prevInsurerName,
          //   'code',
          //   'value',
          // )?.toString(),
              }
      ],
              }
   ]
    const healthDeclarationData = [
      {
        title: (
          <span className="flex flex-col space-y-4">
            <Text type="large">Health Declaration</Text>
            <Text type="label" className="text-base text-black">
              Has any person proposed to be insured under the policy
              suffered from any medical conditions or disabilities of
              health problems listed below or has been hospitalised or
              has had any surgical operation be it intermittent
              recurring or otherwise?
            </Text>
          </span>
        ),
        grid_data: [
          {
            type: 'radiogroup',
            name: 'isHealthDeclarationSelected',
            disabledGlobal:
              viewRenewPolicy?.isProposalRenewed ||
              values?.isCalculatingPremium,
            //     ? true
            //     : initialHealthDeclarationSelected?.toLowerCase() ===
            //       'ye'
            //     ? true
            //     : Object.keys(values?.medicalUnderwriting)?.find(
            //         (m) => !values?.insuredDetails[m]?.memberID,
            //       )
            //     ? false
            //     : true,
            data: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
            ],
          },
        ],
      },
    ];

    const TitleSubParts = () => {
      const data = [
        {
          grid_data: [
            policyNumber
              ? {
                  type: 'render',
                  colSpan:
                    repeatFormsReadOnly === 2
                      ? repeatFormsReadOnly
                      : 1,
                  component: () => (
                    <div className="flex flex-col">
                      <Text type="label" severity="info">
                        Expiry Policy Number
                      </Text>
                      <Text>{policyNumber}</Text>
                    </div>
                  ),
                }
              : null,
            {
              label: (
                <Text type="label" severity="info">
                  Proposal Type
                </Text>
              ),
              type: 'radiogroup',
              name: 'proposalPaymentType',
              className: '-mb-7',
              disabledGlobal:
                viewRenewPolicy?.isProposalRenewed ||
                values?.isCalculatingPremium,
              data: dataPaymentType
                ? dataPaymentType.ProposalPaymentTypeList?.map(
                    (paymentMethod) => {
                      return {
                        label: paymentMethod.value
                          ? paymentMethod.value
                          : '',
                        value: paymentMethod.code
                          ? paymentMethod.code
                          : '',
                      };
                    },
                  )
                : [],
            },
            repeatFormsReadOnly === 3
              ? {
                  type: 'render',
                  component: () => (
                    <div className="flex flex-col">
                      <Text type="label" severity="info">
                        Zone
                      </Text>
                      <Text>
                       NA
                      </Text>
                    </div>
                  ),
                }
              : null,
          ].filter((d) => d),
        },
      ];

      const other_props = {
        flow: 'cols',
        repeat: repeatFormsReadOnly,
        gapX: 6,
        gapY: 0,
        spaceY: 2,
        size: 'full',
        titleSeverity: 'info',
        textType: 'normal',
        useExpandablePaper: false,
      };
      return <MixedGridGroup {...{ data, ...other_props }} />;
    };

    const TitlePart = () => {
      const data = [
        {
          grid_type: 'data',
          grid_data: [
            {
              text: <TitleSubParts />,
              colSpan: repeatFormsReadOnly,
            },
            repeatFormsReadOnly === 2
              ? {
                  label: 'Zone',
                  text: 'NA',
                }
              : null,
            {
              label: 'Policy Start Date',
              name: 'startDate',
              text: renewalFlag?.toString()?.toLowerCase() === 'grace'
              ? dateTimeData?.datetimeValue?.date
         : viewRenewPolicy?.policy?.startDate,
            },
            {
              label: 'Tenure',
              text: viewRenewPolicy?.quoteData?.cover?.tenure,
            },
            {
              label: 'Policy End Date',
              name: 'endDate',
              text: renewalFlag?.toString()?.toLowerCase() === 'grace'
              ? moment(
                  moment()
                    .add(
                      parseInt(
                        viewRenewPolicy?.quoteData?.cover?.tenure,
                      ),
                      'years',
                    )
                    .format('DD/MM/YYYY'),
                  'DD/MM/YYYY',
                )
                  .subtract(1, 'day')
                  .format('DD/MM/YYYY')
              : viewRenewPolicy?.policy?.endDate,
            },
          ].filter((d) => d),
        },
      ];

      const other_props = {
        flow: 'cols',
        repeat: repeatFormsReadOnly,
        gapX: 6,
        gapY: 0,
        spaceY: 2,
        size: 'full',
        titleSeverity: 'info',
        textType: 'normal',
        useExpandablePaper: false,
      };
      return <MixedGridGroup {...{ data, ...other_props }} />;
    };

    const other_props = {
      flow: 'cols',
      textType: 'normal',
      repeat: repeatFormsReadOnly,
      repeatOnEdit: repeatFormsonEdit,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      useExpandablePaper: false,
      useGlobalExpandablePaper: true,
      globalTitleSeverity: 'info',
      globalTitleType: 'large',
      nullData: () => <Text severity="neutral">Not Captured</Text>,
    };

    const other_props1 = {
      flow: 'cols',
      textType: 'normal',
      repeat: repeatFormsReadOnly1,
      repeatOnEdit: repeatFormsonEdit1,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      useExpandablePaper: false,
      useGlobalExpandablePaper: true,
      globalTitleSeverity: 'info',
      globalTitleType: 'large',
      // nullData: () => <Text severity="neutral">Not Captured</Text>,
    };
    return (
      <>
        <QuantaForm className="space-y-4">
          <Text severity={'info'} type={'title'}>
            Review Proposal
          </Text>
          {intermediaryDetailsData?.length > 0 && (
            <MixedGridGroup
              {...{
                data: intermediaryDetailsData,
                ...{
                  ...other_props,
                  useGlobalExpandablePaper: false,
                },
                globalTitle: 'Intermediary Details',
                isToggleEnabled:
                  !expandedCard.current.find(
                    (exp) => exp?.cardName === 'intermediaryDetails',
                  )?.cardFlag || intermediaryDetailsCardToggle,
                expanded: renderExpandedCards?.current[0],
                setExpandedCards: (expanded) => {
                  renderExpandedCards.current = [
                    expanded,
                    ...renderExpandedCards?.current?.slice(1),
                  ];
                },
              }}
            />
          )}
          <TitlePart />
          <MixedGridGroup
            {...{
              data: ProposerCustomerEditable({
                renewalFlag,
                setEnableRenew,
                setValueChanges,
                repeat,
                repeatFormsReadOnly,
                customerTypeList,
                expandedCard,
                genderList,
                getDomainData,
                idProofTypeList,
                loadingPermCustAddr,
                loadingCommCustAddr,
                maritalStatusList,
                nationalityList,
                onCommAddrLookup,
                onPermAddrLookup,
                organisationList,
                proposerDetails,
                proposerDetailsMeta,
                salutationList,
                setFieldValue,
                setProposerDetailsCardToggle,
                updateViewRenewPolicyData: updateViewRenewPolicy,
                validate,
                values,
                viewRenewPolicyData: viewRenewPolicy,
                ...props,
              }),
              ...other_props,
              globalTitle: 'Proposer Customer',
              isToggleEnabled:
                !expandedCard.current.find(
                  (exp) => exp?.cardName === 'proposerDetails',
                )?.cardFlag || proposerDetailsCardToggle,
              expanded: renderExpandedCards?.current[1],
              setExpandedCards: (expanded) => {
                renderExpandedCards.current = [
                  ...renderExpandedCards?.current?.slice(0, 1),
                  expanded,
                  ...renderExpandedCards?.current?.slice(2),
                ];
              },
            }}
          />
          {insuredDetailsData?.length > 0 && (
            <MixedGridGroup
              {...{
                data: insuredDetailsData,
                ...other_props,
                globalTitle: 'Insured Members',
                isToggleEnabled:
                  !expandedCard.current.find(
                    (exp) => exp?.cardName === 'insuredDetails',
                  )?.cardFlag || insuredDetailsCardToggle,
                expanded: renderExpandedCards?.current[2],
                setExpandedCards: (expanded) => {
                  renderExpandedCards.current = [
                    ...renderExpandedCards?.current?.slice(0, 2),
                    expanded,
                    ...renderExpandedCards?.current?.slice(3),
                  ];
                },
              }}
            />
          )}
          {nomineeDetailsData?.length > 0 && (
            <MixedGridGroup
              {...{
                data: nomineeDetailsData,
                ...other_props,
                globalTitle: 'Nominee Details',
                isToggleEnabled:
                  !expandedCard.current.find(
                    (exp) => exp?.cardName === 'nomineeDetails',
                  )?.cardFlag || nomineeDetailsCardToggle,
                expanded: renderExpandedCards?.current[3],
                setExpandedCards: (expanded) => {
                  renderExpandedCards.current = [
                    ...renderExpandedCards?.current?.slice(0, 3),
                    expanded,
                    ...renderExpandedCards?.current?.slice(4),
                  ];
                },
              }}
            />
          )}
          {prevInsuranceDetailsData?.length > 0 && (
            <MixedGridGroup
              {...{
                data: prevInsuranceDetailsData,
                ...other_props,
                globalTitle: 'Previous Insurance & Claims',
                isToggleEnabled:
                  !expandedCard.current.find(
                    (exp) => exp?.cardName === 'prevInsuredDetails',
                  )?.cardFlag || prevInsuredDetailsCardToggle,
                expanded: renderExpandedCards?.current[4],
                setExpandedCards: (expanded) => {
                  renderExpandedCards.current = [
                    ...renderExpandedCards?.current?.slice(0, 4),
                    expanded,
                    ...renderExpandedCards?.current?.slice(5),
                  ];
                },
              }}
            />
          )}
          {portabilityDetails && portabilityDetails?.length > 0 && (
            <MixedGridGroup
              {...{
                data: underwritingAssignmentData,
                ...other_props,
                globalTitle: 'Underwriting Assessment',
                expanded: renderExpandedCards?.current[5],
                setExpandedCards: (expanded) => {
                  renderExpandedCards.current = [
                    ...renderExpandedCards?.current?.slice(0, 5),
                    expanded,
                    ...renderExpandedCards?.current?.slice(6),
                  ];
                },
              }}
            />
          )}
          {/* {renewalMandateDetails && (
            <MixedGridGroup
              {...{
                data: renewalMandateData,
                ...other_props,
                globalTitle: 'Renewal Mandate Details',
                expanded: renderExpandedCards?.current[6],
                setExpandedCards: (expanded) => {
                  renderExpandedCards.current = [
                    ...renderExpandedCards?.current?.slice(0, 6),
                    expanded,
                    ...renderExpandedCards?.current?.slice(7),
                  ];
                },
              }}
            />
          )} */}
          {renewalMandateDetails && (
            <MixedGridGroup
              {...{
                data: renewalMandateData1,
                ...other_props1,
                globalTitle: 'Renewal Mandate Details',
                isToggleEnabled:
                  !expandedCard.current.find(
                    (exp) => exp?.cardName === 'RenewalMandate',
                  )?.cardFlag || RenewalMandateCardToggle,
                expanded: renderExpandedCards?.current[6],
                setExpandedCards: (expanded) => {
                  renderExpandedCards.current = [
                    ...renderExpandedCards?.current?.slice(0, 6),
                    expanded,
                    ...renderExpandedCards?.current?.slice(6),
                  ];
                },
              }}
            />
          )}
          {healthDeclarationData?.length > 0 && (
            <MixedGridGroup
              {...{
                data: healthDeclarationData,
                ...{
                  ...other_props,
                  useGlobalExpandablePaper: false,
                },
              }}
            />
          )}
          <Button
            type="button"
            flat={true}
            disabled={
              values?.isHealthDeclarationSelected?.toLowerCase() ===
                'no' || values?.isCalculatingPremium
                || viewRenewPolicy?.proposalStatus ==='Renewal Collected'
            }
            iconPre={
              <FontAwesomeIcon
                icon={faFileMedical}
                className={
                  values?.isHealthDeclarationSelected?.toLowerCase() ===
                  'no'
                    ? 'mr-1'
                    : 'ml-2 mr-1'
                }
              />
            }
            onClick={(_) => {
              setMedicalUnderwritingDataBeforeEdit(
                values?.medicalUnderwriting,
              );
              setMedicalQuestionaireDisplay(true);
            }}
          >
            {' '}
            Medical Questionaire
          </Button>
          {Object.keys(values?.insuredDetails)?.find(
            (insured) =>
              !values?.insuredDetails[insured]?.memberID &&
              !values.insuredDetails[insured]?.isSoftAdded &&
              !values?.insuredDetails[insured]?.isHardDeleted,
          ) &&
            values?.isHealthDeclarationSelected
              ?.toString()
              ?.toLowerCase() === 'es' && (
            <Text
              type="normal"
              severity="warning"
              className="flex gap-2 w-full"
            >
              <Text>
                <FontAwesomeIcon icon={faExclamationTriangle} />
              </Text>
              <Text>
                Medical Questionaire needs to be filled for newly
                added members
              </Text>
            </Text>
          )}
          <div>
            <NotificationList
              {...{
                items: alerts,
                resetAlerts: (idx) => {
                  const alertToBeRemovedPos = alerts.findIndex(
                    (a) => a.id === idx,
                  );
                  setAlerts([
                    ...alerts.slice(0, alertToBeRemovedPos),
                    ...alerts.slice(
                      alertToBeRemovedPos + 1,
                      alerts.length,
                    ),
                  ]);
                },
              }}
            />
          </div>
        </QuantaForm>
        <div>
          <ModalAddMembers
            {...{
              genderList: genderList,
              memberList: filteredMemberList,
              modalAddMemberDisplay,
              setModalAddMemberDisplay,
              setFieldValue,
              insuredDetails: values?.insuredDetails,
              countEditsOpen: values?.countEditsOpen,
              setEnableRenew,
              pedValue
            }}
          />
        </div>
        <div>
          <ModalMedicalQuestionaire
            {...{
              medicalQuestionaireDisplay,
              setMedicalQuestionaireDisplay,
              questions: productQuestionList,
              readOnlyMode: viewRenewPolicy?.isProposalRenewed,
              insuredDetails: values?.insuredDetails,
              medicalQuestionaire,
              insuredDetailsReactiveVar: insuredDetails,
              masterQuestion: productQuestionList?.find(
                (q) => q?.srNo?.toLowerCase() === 'master',
              ),
              medicalQuestionaireData: values?.medicalUnderwriting,
              valuesBeforeEdit: medicalUnderwritingDataBeforeEdit,
              productCode
            }}
          />
        </div>
      </>
    );
  };

  if (
    loading ||
    dropDownLoadingCustomer ||
    loadingCustTypeDomain ||
    dateTimeLoading ||
    loadingPaymentType ||
    loadingQuestions ||
    loadingRollOverCompanyList ||
    loadingProductCustomerDropdown ||
    dropDownLoadingOrganisation ||
    loadingApplicableMemberTypes ||
    loadingRenewalMandateData ||
    loadingMyIntermediaries ||
    loadingProfileData ||
    loadingMobileNumberLength ||
    loadingNameLimit ||
    loadingCoverTypeLimit ||
    (data && !data?.viewRenewPolicy?.proposalNumber)
  ) {
    return (
      <div className="min-h-screen">
        <Loading />
      </div>
    );
  }

  if (
    error ||
    errorCustTypeDomain ||
    errorTimeLoading ||
    errorPaymentType ||
    errorQuestions ||
    errorRollOverCompanyList ||
    dropDownErrorCustomer ||
    dropDownErrorOrganisation ||
    errorProductCustomerDropdown ||
    errorApplicableMemberTypes ||
    errorRenewalMandateData ||
    errorMyIntermediaries ||
    errorProfileData ||
    errorMobileNumberLength ||
    errorNameLimit ||
    errorCoverTypeLimit
  ) {
    return (
      <Error
        error={
          error ||
          errorCustTypeDomain ||
          errorTimeLoading ||
          errorPaymentType ||
          errorQuestions ||
          errorRollOverCompanyList ||
          dropDownErrorCustomer ||
          dropDownErrorOrganisation ||
          errorProductCustomerDropdown ||
          errorApplicableMemberTypes ||
          errorRenewalMandateData ||
          errorMyIntermediaries ||
          errorProfileData ||
          errorMobileNumberLength ||
          errorNameLimit ||
          errorCoverTypeLimit
        }
      />
    );
  }

  const { productQuestionList } = dataQuestions;
  const viewRenewPolicy = data
    ? data?.viewRenewPolicy
    : previousData
    ? previousData?.viewRenewPolicy
    : null;
  const selectedIntermediary = data
    ? data?.selectedIntermediary
    : previousData
    ? previousData?.selectedIntermediary
    : null;
  const { rolloverCompanyList } = dataRollOverCompanyList;
  const {
    proposerDetails,
    proposerDetailsMeta,
    insuredDetails,
    nomineeDetails,
    portabilityDetails,
    renewalMandateDetails,
    prevInsuranceDetails,
    isHealthDeclarationSelected,
    initialHealthDeclarationSelected,
    policyNumber,
    medicalQuestionaire,
  } = viewRenewPolicy;
  const {
    idProofTypeList,
    salutationList,
    genderList,
    maritalStatusList,
    nationalityList,
  } = dropDownDetails;
  const { customerTypeList } = dataCustTypeDomain;
  const {
    PRD_OccupationList,
    PRD_PreExistDiseaseWaitPeriod,
    PRD_NomiRelationWithMemb,
    PRD_ApointRelationWithMinNomi,
    PRD_CumulativeBonus,
  } = dataProductCustomerDropdown;
  const { organisationList } = dropDownDetailsOrganisation;
  const { productDetails } = dataApplicableMemberTypes;
  const { applicableMemberTypes } = productDetails;
  const {
    PRD_TermForMandate,
    typeOfDebit,
    destinationBankAccountType,
    PRD_RenewalPaymentMandateTakenInTheNameOf,
  } = renewalMandateData;
  const { myIntermediaries } = dataMyIntermediaries;
  const { userMyDetail } = profileData;
  const { userType } = userMyDetail;
  const { typeName } = userType;
  const { mobileNumberStartingWith } = dataMobileNumberLength;
  const { characterLimitList } = dataNameLimit;
  const { maxInsuredLimitList } = dataCoverTypeLimit;

  const getInitObjInsuredMembers = () => {
    let initObj = {};
    insuredDetails.forEach((insured) => {
      initObj[insured?.relationship] = {
        isMemberDeleted: insured?.isDeleted
          ? insured?.isDeleted
          : false,
        isSoftAdded: false,
        isHardDeleted: false,
        title: insured?.title
          ? insured?.title
          : insured?.relationship?.toLowerCase() === 'self'
          ? viewRenewPolicy?.proposerDetails?.title
          : '',
        gender: insured?.gender
          ? insured?.gender
          : insured?.relationship?.toLowerCase() === 'self'
          ? viewRenewPolicy?.proposerDetails?.gender
            ? viewRenewPolicy.proposerDetails?.gender
            : viewRenewPolicy?.quoteData?.members?.find(
                (m) =>
                  m?.relationship?.toLowerCase() ===
                  insured?.relationship?.toLowerCase(),
              )?.gender
          : viewRenewPolicy?.quoteData?.members?.find(
              (m) =>
                m?.relationship?.toLowerCase() ===
                insured?.relationship?.toLowerCase(),
            )?.gender,
        isGenderReadOnly:
          getDomainData(
            genderList,
            applicableMemberTypes?.find((mem) =>
              insured?.relationship
                ?.toLowerCase()
                ?.startsWith(mem?.label?.toLowerCase()),
            )?.gender,
            'value',
            'code',
          ) !== '',
        dob: insured?.dob
          ? insured?.dob
          : insured?.relationship?.toLowerCase() === 'self'
          ? viewRenewPolicy?.proposerDetails?.proposerDOB
            ? viewRenewPolicy?.proposerDetails?.proposerDOB
            : viewRenewPolicy?.quoteData?.members?.find(
                (m) =>
                  m?.relationship?.toLowerCase() ===
                  insured?.relationship?.toLowerCase(),
              )?.dob
          : viewRenewPolicy?.quoteData?.members?.find(
              (m) =>
                m?.relationship?.toLowerCase() ===
                insured?.relationship?.toLowerCase(),
            )?.dob,
        age: insured?.age ? insured?.age : '',
        firstName: insured?.firstName
          ? insured?.firstName
          : insured?.relationship?.toLowerCase() === 'self'
          ? viewRenewPolicy?.proposerDetails?.firstName
          : '',
        middleName: insured?.middleName
          ? insured?.middleName
          : insured?.relationship?.toLowerCase() === 'self'
          ? viewRenewPolicy?.proposerDetails?.middleName
          : '',
        lastName: insured?.lastName
          ? insured?.lastName
          : insured?.relationship?.toLowerCase() === 'self'
          ? viewRenewPolicy?.proposerDetails?.lastName
          : '',
        maritalStatus: insured?.maritalStatus
          ? insured?.maritalStatus
          : insured?.relationship?.toLowerCase() === 'self'
          ? viewRenewPolicy?.proposerDetails?.maritalStatus
          : '',
        height: insured?.height ? insured?.height : '',
        weight: insured?.weight ? insured?.weight : '',
        occupation: insured?.occupation ? insured?.occupation : '',
        otherOccupation: insured?.otherOccupation
          ? insured?.otherOccupation
          : '',
        pedWaitingPeriod: insured?.pedWaitingPeriod
          ? insured?.pedWaitingPeriod
          : '',
        cbBonusPct: insured?.cbBonusPct ? insured?.cbBonusPct : '',
        isPortabilityRequired: insured?.isPortabilityRequired
          ? insured?.isPortabilityRequired
          : false,
        ppcTestLevel: insured?.ppcTestLevel
          ? insured?.ppcTestLevel
          : '',
        memberID: insured?.memberID ? insured?.memberID : '',
        memberStatus: insured?.memberStatus
          ? insured?.memberStatus
          : '',
      };
    });
    return initObj;
  };

  const getInitObjNomineeDetails = () => {
    let initObj = {};
    nomineeDetails.forEach((nominee, idx) => {
      initObj[nominee?.relationship] = {
        isSoftAdded: false,
        isHardDeleted: false,
        name: nominee?.name ? nominee?.name : '',
        dob: nominee?.dob ? nominee?.dob : '',
        relationshipWithInsured: nominee?.relationshipWithInsured
          ? nominee?.relationshipWithInsured
          : '',
        relationshipWithAppointee: nominee?.relationshipWithAppointee
          ? nominee?.relationshipWithAppointee
          : '',
        nameOfAppointee: nominee?.nameOfAppointee
          ? nominee?.nameOfAppointee
          : '',
      };
    });
    return initObj;
  };

  const getInitObjPrevInsuranceDetails = () => {
    let initObj = {};
    prevInsuranceDetails?.forEach((prevInsured) => {
      initObj[prevInsured?.insuredRelationship] = {
        isSoftAdded: false,
        isHardDeleted: false,
        prevInsurerName: prevInsured?.prevInsurerName
          ? prevInsured?.prevInsurerName
          : '',
        prevPolicyNo: prevInsured?.prevPolicyNo
          ? prevInsured?.prevPolicyNo
          : '',
        prevPolicyStartDate: prevInsured?.prevPolicyStartDate
          ? prevInsured?.prevPolicyStartDate
          : '',
        prevPolicyEndDate: prevInsured?.prevPolicyEndDate
          ? prevInsured?.prevPolicyEndDate
          : '',
        prevPolicySI: prevInsured?.prevPolicySI
          ? prevInsured?.prevPolicySI
          : '',
        prevClaimLodged: prevInsured?.prevClaimLodged
          ? prevInsured?.prevClaimLodged
          : '',
        claimAmount: prevInsured?.claimAmount
          ? prevInsured?.claimAmount
          : '',
        cbAmount: prevInsured?.cbAmount ? prevInsured?.cbAmount : '',
      };
    });
    return initObj;
  };

  const getInitObjectMedicalQuestionaire = () => {
    let initObj = {};
    let questionObj = {};
    productQuestionList?.forEach((medicalQuestionaire) => {
      questionObj[`${medicalQuestionaire.srNo}`] = {
        checkboxAnswer:
          medicalQuestionaire?.srNo?.toLowerCase() === 'master'
            ? !productQuestionList?.find(
                (q) => q?.srNo?.toLowerCase() === 'master',
              )?.condToChild
              ? 'Yes'
              : 'No'
            : 'No',
        textareaAnswer: '',
      };
    });
    insuredDetails?.forEach((insured) => {
      if (
        medicalQuestionaire &&
        medicalQuestionaire?.find(
          (m) =>
            m?.relationship?.toString()?.toLowerCase() ===
            insured?.relationship?.toString()?.toLowerCase(),
        )
      ) {
        let questionObjFromReactiveVar = {};
        medicalQuestionaire
          ?.find(
            (m) =>
              m?.relationship?.toString()?.toLowerCase() ===
              insured?.relationship?.toString()?.toLowerCase(),
          )
          ?.questions?.forEach((q) => {
            const { answerText, ...restAnswer } = q?.answer;
            questionObjFromReactiveVar[`${q?.srNo}`] = {
              checkboxAnswer: restAnswer?.checkboxAnswer
                ? restAnswer?.checkboxAnswer
                : '',
              textareaAnswer:
                answerText === ''
                  ? ''
                  : restAnswer?.textareaAnswer
                  ? restAnswer?.textareaAnswer
                  : '',
            };
          });
        initObj[`${insured?.relationship}`] =
          questionObjFromReactiveVar;
      } else {
        initObj[`${insured?.relationship}`] = questionObj;
      }
    });
    return initObj;
  };
  const initialValues = {
    intermediaryData: {
      intermediary:
        viewRenewPolicy?.intermediaryDetails?.code &&
        getDomainDataStrict(
          myIntermediaries,
          viewRenewPolicy?.intermediaryDetails?.code,
          'intermediaryCode',
          'intermediaryName',
        )
          ? `${viewRenewPolicy?.intermediaryDetails?.code}`
          : selectedIntermediary?.intermediaryCode &&
            getDomainDataStrict(
              myIntermediaries,
              selectedIntermediary?.intermediaryCode,
              'intermediaryCode',
              'intermediaryName',
            )
          ? `${selectedIntermediary?.intermediaryCode}`
          : myIntermediaries?.length > 0 &&
            myIntermediaries[0]?.intermediaryCode
          ? `${myIntermediaries[0]?.intermediaryCode}`
          : '',
      businessLocation:
        viewRenewPolicy?.intermediaryDetails?.code &&
        myIntermediaries?.find(
          (myIntermediary) =>
            myIntermediary?.intermediaryCode
              ?.toString()
              ?.trim()
              ?.toLowerCase() ===
            viewRenewPolicy?.intermediaryDetails?.code
              ?.toString()
              ?.toLowerCase(),
        ) &&
        myIntermediaries
          ?.find(
            (myIntermediary) =>
              myIntermediary?.intermediaryCode
                ?.toString()
                ?.trim()
                ?.toLowerCase() ===
              viewRenewPolicy?.intermediaryDetails?.code
                ?.toString()
                ?.toLowerCase(),
          )
          ?.businessLocations?.find(
            (businessLocation) =>
              businessLocation?.code?.toString()?.toLowerCase() ===
              viewRenewPolicy?.intermediaryDetails?.location
                ?.toString()
                ?.toLowerCase(),
          )
          ? `${viewRenewPolicy?.intermediaryDetails?.location}`
          : '',
      fieldUser: '',
      fieldUserList: [],
    },
    countEditsOpen: 0,
    proposalPaymentType:dataPaymentType?.ProposalPaymentTypeList
    ?dataPaymentType?.ProposalPaymentTypeList[0]?.code
    :viewRenewPolicy?.proposalPaymentType,
    //  viewRenewPolicy?.proposalPaymentType
    //   ? viewRenewPolicy?.proposalPaymentType
    //   : dataPaymentType?.ProposalPaymentTypeList[0]?.value,
    isHealthDeclarationSelected: isHealthDeclarationSelected
      ? isHealthDeclarationSelected
      : 'No',
    proposerDetails: proposerDetails,
    insuredDetails: getInitObjInsuredMembers(),
    nomineeDetails: getInitObjNomineeDetails(),
    prevInsuranceDetails: getInitObjPrevInsuranceDetails(),
    medicalUnderwriting: getInitObjectMedicalQuestionaire(),
    isCalculatingPremium: false,
    planLoading: false,
    // renewalPaymentMandate:
    //   viewRenewPolicy?.renewalPaymentMandate,
    //  renewalMandateDetails?.renewalPaymentMandate,
    renewalMandateDetails: {
      accountNumber: viewRenewPolicy?.renewalMandateDetails?.accountNumber
        ? viewRenewPolicy?.renewalMandateDetails?.accountNumber : null,
      branchName: viewRenewPolicy?.renewalMandateDetails?.branchName ? viewRenewPolicy?.renewalMandateDetails?.branchName : null,
      destinationBankAccountType: viewRenewPolicy?.renewalMandateDetails?.destinationBankAccountType
        ? viewRenewPolicy?.renewalMandateDetails?.destinationBankAccountType
        : destinationBankAccountType[0]?.value,
      destinationBankName: viewRenewPolicy?.renewalMandateDetails?.destinationBankName ? viewRenewPolicy?.renewalMandateDetails?.destinationBankName : null,
      destinationIfscCode: viewRenewPolicy?.renewalMandateDetails?.destinationIfscCode ? viewRenewPolicy?.renewalMandateDetails?.destinationIfscCode : null,
      destinationMicrCode: viewRenewPolicy?.renewalMandateDetails?.destinationMicrCode ? viewRenewPolicy?.renewalMandateDetails?.destinationMicrCode : null,
      finalCollectionDate: viewRenewPolicy?.renewalMandateDetails?.finalCollectionDate ? viewRenewPolicy?.renewalMandateDetails?.finalCollectionDate : null,
      mandateAmount: viewRenewPolicy?.renewalMandateDetails?.mandateAmount ? viewRenewPolicy?.renewalMandateDetails?.mandateAmount : null,
      renewalPaymentMandate:false,
      //   RenewalPaymentMandatevalue ?
      //     RenewalPaymentMandatevalue?.toString()?.toLowerCase() === 'Yes' ? true : false
      //     : (viewRenewPolicy?.renewalMandateDetails?.renewalPaymentMandate?.toString()?.toLowerCase() === 'yes' ||
      //       viewRenewPolicy?.renewalMandateDetails?.renewalPaymentMandate === true) ?
      //       true : false
      
      // ,
      renewalPaymentMandateTakenInNameOf: viewRenewPolicy?.renewalMandateDetails?.renewalPaymentMandateTakenInNameOf
        ? viewRenewPolicy?.renewalMandateDetails?.renewalPaymentMandateTakenInNameOf
        : PRD_RenewalPaymentMandateTakenInTheNameOf[0]?.value,
      termForMandateOpted: viewRenewPolicy?.renewalMandateDetails?.termForMandateOpted ? viewRenewPolicy?.renewalMandateDetails?.termForMandateOpted : null,
      typeOfDebit: viewRenewPolicy?.renewalMandateDetails?.typeOfDebit ? viewRenewPolicy?.renewalMandateDetails?.typeOfDebit : null,
    }
  };

  const getInsuredDetailsObj = (values, planValues) => {
    let insuredDetailsArr = [];
    Object?.keys(values?.insuredDetails)
      ?.filter(
        (insured) =>
          !values?.insuredDetails[insured]?.isSoftAdded &&
          !values?.insuredDetails[insured]?.isHardDeleted,
      )
      ?.forEach((insured) => {
        let insuredDetailsObj = {};
        insuredDetailsObj.relationship = insured;
        insuredDetailsObj.gender =
          values?.insuredDetails[insured]?.gender;
        insuredDetailsObj.title =
          values?.insuredDetails[insured]?.title;
        insuredDetailsObj.dob = values?.insuredDetails[insured]?.dob;
        insuredDetailsObj.age = values?.insuredDetails[insured]?.age;
        insuredDetailsObj.firstName =
          values?.insuredDetails[insured]?.firstName;
        insuredDetailsObj.middleName =
          values?.insuredDetails[insured]?.middleName;
        insuredDetailsObj.lastName =
          values?.insuredDetails[insured]?.lastName;
        insuredDetailsObj.maritalStatus =
          values?.insuredDetails[insured]?.maritalStatus;
        insuredDetailsObj.occupation =
          values?.insuredDetails[insured]?.occupation;
        insuredDetailsObj.otherOccupation =
          values?.insuredDetails[insured]?.otherOccupation;
        insuredDetailsObj.height =
          values?.insuredDetails[insured]?.height;
        insuredDetailsObj.weight =
          values?.insuredDetails[insured]?.weight;
        insuredDetailsObj.pedWaitingPeriod =
          values?.insuredDetails[insured]?.pedWaitingPeriod;
        insuredDetailsObj.isPortabilityRequired =
          values?.insuredDetails[insured]?.isPortabilityRequired;
        insuredDetailsObj.cbBonusPct =
          values?.insuredDetails[insured]?.cbBonusPct !== null &&
          values?.insuredDetails[insured]?.cbBonusPct !== undefined
            ? parseFloat(values?.insuredDetails[insured]?.cbBonusPct)
            : null;
        insuredDetailsObj.isDeleted =
          values?.insuredDetails[insured]?.isMemberDeleted;
        insuredDetailsObj.memberID =
          values?.insuredDetails[insured]?.memberID;
        insuredDetailsObj.memberStatus =
          values?.insuredDetails[insured]?.memberStatus;
        insuredDetailsObj.nomineeDetails = {
          name: values?.nomineeDetails[insured]?.name,
          dob: values?.nomineeDetails[insured]?.dob,
          relationshipWithInsured:
            values?.nomineeDetails[insured]?.relationshipWithInsured,
          insuredRelationship: insured,
          nameOfAppointee:
            values?.nomineeDetails[insured]?.nameOfAppointee,
          relationshipWithAppointee:
            values?.nomineeDetails[insured]
              ?.relationshipWithAppointee,
        };
        // insuredDetailsObj.medicalQuestionaire = {
        //   relationship: insured,
        //   questions:
        //     values?.medicalUnderwriting[insured]['MASTER']
        //       ?.checkboxAnswer === 'No'||
        //       values?.medicalUnderwriting[insured]['MASTER']
        //       ?.checkboxAnswer === 'Yes' &&
        //     values?.isHealthDeclarationSelected?.toLowerCase() ===
        //       'yes'
        //       ? Object.keys(values?.medicalUnderwriting[insured])
        //           ?.filter((srNo) => srNo?.toLowerCase() !== 'master')
        //           ?.map((srNo) => {
        //             let answerText = '';
        //             const question = productQuestionList.find(
        //               (question) => question.srNo === srNo,
        //             );
        //             if (question) {
        //               if (!question.isParent) {
        //                 const parentQuestion =
        //                   productQuestionList.find((q) =>
        //                     q.childQuesNo.find(
        //                       (c) =>
        //                         c.toLowerCase() ===
        //                         question.srNo.toLowerCase(),
        //                     ),
        //                   );
        //                 if (
        //                   parentQuestion &&
        //                   ((values?.medicalUnderwriting[insured][
        //                     `${parentQuestion?.srNo}`
        //                   ]?.checkboxAnswer === 'Yes' &&
        //                     !parentQuestion?.condToChild) ||
        //                     (values?.medicalUnderwriting[insured][
        //                       `${parentQuestion?.srNo}`
        //                     ]?.checkboxAnswer === 'No' &&
        //                       parentQuestion?.condToChild))
        //                 ) {
        //                   answerText = '';
        //                 } else {
        //                   answerText =
        //                     question?.isChkTxtReq &&
        //                     values?.medicalUnderwriting[insured][srNo]
        //                       .checkboxAnswer === 'Yes'
        //                       ? values?.medicalUnderwriting[insured][
        //                           srNo
        //                         ]?.textareaAnswer
        //                       : question?.isChkTxtReq &&
        //                         values?.medicalUnderwriting[insured][
        //                           srNo
        //                         ]?.checkboxAnswer === 'No'
        //                       ? values?.medicalUnderwriting[insured][
        //                           srNo
        //                         ]?.checkboxAnswer
        //                       : question?.isChkReq
        //                       ? values?.medicalUnderwriting[insured][
        //                           srNo
        //                         ]?.checkboxAnswer
        //                       : values?.medicalUnderwriting[insured][
        //                           srNo
        //                         ]?.textareaAnswer;
        //                 }
        //               } else {
        //                 answerText =
        //                   question?.isChkTxtReq &&
        //                   values?.medicalUnderwriting[insured][srNo]
        //                     ?.checkboxAnswer === 'Yes'
        //                     ? values?.medicalUnderwriting[insured][
        //                         srNo
        //                       ]?.textareaAnswer
        //                     : question?.isChkTxtReq &&
        //                       values?.medicalUnderwriting[insured][
        //                         srNo
        //                       ]?.checkboxAnswer === 'No'
        //                     ? values?.medicalUnderwriting[insured][
        //                         srNo
        //                       ]?.checkboxAnswer
        //                     : question?.isChkReq
        //                     ? values?.medicalUnderwriting[insured][
        //                         srNo
        //                       ]?.checkboxAnswer
        //                     : values?.medicalUnderwriting[insured][
        //                         srNo
        //                       ]?.textareaAnswer;
        //               }
        //             } else {
        //               answerText =
        //                 values?.medicalUnderwriting[insured][srNo]
        //                   ?.checkboxAnswer;
        //             }
        //             return {
        //               srNo,
        //               answer: answerText,
        //             };
        //           })
        //       : [],
        // };
        let medicalQuestionaireObj =
          values?.medicalUnderwriting[insured]['MASTER']
            ?.checkboxAnswer === 'No' ||
            values?.medicalUnderwriting[insured]['MASTER']
              ?.checkboxAnswer === 'Yes' &&
            values?.isHealthDeclarationSelected?.toLowerCase() ===
            'yes'
            ? getMedicalQuestionsMapped(values, insured)
            : { relationship: insured, questions: [] };
        if (
          medicalQuestionaireObj &&
          medicalQuestionaireObj?.questions &&
          medicalQuestionaireObj?.questions?.length > 0
        ) {
          medicalQuestionaireObj = {
            relationship: insured,
            questions: medicalQuestionaireObj?.questions?.map(
              (question) => {
                    return {
                  srNo: question?.srNo,
                  answer: question?.answer?.answerText,
                    };
              },
            ),
          };
          medicalQuestionaireObj = {
            ...medicalQuestionaireObj,
            questions:
              medicalQuestionaireObj?.questions
                ?.find((q) => q?.srNo?.toLowerCase() === 'master')
                ?.answer?.toLowerCase() !== 'ye'
                ? medicalQuestionaireObj?.questions?.filter(
                  (q) => q?.srNo?.toLowerCase() !== '',
                )
              : [],
        };
        }
        insuredDetailsObj.medicalQuestionaire = medicalQuestionaireObj
          ? medicalQuestionaireObj
          : { relationship: member, questions: [] };
        insuredDetailsObj.addOnCovers = planValues?.covers?.packs
          ?.filter((pack) => pack?.index?.includes(insured))
          .flatMap((pack) => {
            return pack.addOnCovers
              .filter((addOnCover) => addOnCover.selected)
              .map((addOnCover) => {
                return {
                  ...addOnCover,
                  isDeleted: false,
                };
              });
          });
        insuredDetailsObj.addOnCovers = insuredDetailsObj.addOnCovers
          ? insuredDetailsObj.addOnCovers
          : [];
        insuredDetailsObj.prevInsuranceInput = {
          prevInsurerName: reformData(
            values?.prevInsuranceDetails[insured]?.prevInsurerName,
            '',
          ),
          prevPolicyNo: reformData(
            values?.prevInsuranceDetails[insured]?.prevPolicyNo,
            '',
          ),
          prevPolicySI: reformData(
            values?.prevInsuranceDetails[insured]?.prevPolicySI,
            '',
          ),
          prevClaimLodged: reformData(
            values?.prevInsuranceDetails[
              insured
            ]?.prevClaimLodged?.toLowerCase() === 'yes'
              ? true
              : false,
            false,
            false,
          ),
          claimAmount: reformData(
            values?.prevInsuranceDetails[insured]?.claimAmount,
            '',
          ),
          prevPolicyStartDate: reformData(
            values?.prevInsuranceDetails[insured]
              ?.prevPolicyStartDate,
            '',
          ),
          prevPolicyEndDate: reformData(
            values?.prevInsuranceDetails[insured]?.prevPolicyEndDate,
            '',
          ),
          cbAmount: reformData(
            values?.prevInsuranceDetails[insured]?.cbAmount,
            null,
          ),
        };
        insuredDetailsArr.push(insuredDetailsObj);
      });
    return insuredDetailsArr;
  };

  const submitRenewalVariables = (values, planValues) => {
   
    let manamount;
    let Prem_data = planValues?.totalPremium
      ? planValues?.totalPremium
      : planValues?.premium?.totalPremium;

    manamount = productCode.toString() !== '2885' ?
      Prem_data ? 1.5 * Prem_data
        : null : null;
    return {
      input: {
        proposerDetails: {
          id: values?.proposerDetails?.id,
          customerType: values?.proposerDetails?.customerType,
          isThinCustomer: proposerDetailsMeta?.isNewCustomer,
          title: values?.proposerDetails?.title,
          gender: values?.proposerDetails?.gender,
          firstName: values?.proposerDetails?.firstName,
          middleName: values?.proposerDetails?.middleName,
          lastName: values?.proposerDetails?.lastName,
          fullName: values?.proposerDetails?.fullName,
          proposerDOB: values?.proposerDetails?.proposerDOB,
          maritalStatus: values?.proposerDetails?.maritalStatus,
          occupation: values?.proposerDetails?.occupation,
          nationality: values?.proposerDetails?.nationality,
          idProofType: values?.proposerDetails?.idProofType,
          idProofNumber: values?.proposerDetails?.idProofNumber,
          panNumber: values?.proposerDetails?.panNumber,
          orgName: values?.proposerDetails?.orgName,
          orgType: values?.proposerDetails?.orgType,
          contactName: values?.proposerDetails?.contactName,
          regNumber: values?.proposerDetails?.regNumber,
          tanNumber: values?.proposerDetails?.tanNumber,
          gstNumber: values?.proposerDetails?.gstNumber,
          permAddressLine1: values?.proposerDetails?.permAddressLine1,
          permAddressLine2: values?.proposerDetails?.permAddressLine2,
          permAddressLine3: values?.proposerDetails?.permAddressLine3,
          permLandmark: values?.proposerDetails?.permLandmark,
          permPincode: values?.proposerDetails?.permPincode,
          permCityTownVillage:
            values?.proposerDetails?.permCityTownVillage,
          permDistrict: values?.proposerDetails?.permDistrict,
          permState: values?.proposerDetails?.permState,
          permCommAddressYN:
            values?.proposerDetails?.permCommAddressYN,
          commAddressLine1: values?.proposerDetails?.commAddressLine1,
          commAddressLine2: values?.proposerDetails?.commAddressLine2,
          commAddressLine3: values?.proposerDetails?.commAddressLine3,
          commLandmark: values?.proposerDetails?.commLandmark,
          commPincode: values?.proposerDetails?.commPincode,
          commCityTownVillage:
            values?.proposerDetails?.commCityTownVillage,
          commDistrict: values?.proposerDetails?.commDistrict,
          commState: values?.proposerDetails?.commState,
          phoneNo: values?.proposerDetails?.phoneNo,
          mobileNo: values?.proposerDetails?.mobileNo,
          emailID: values?.proposerDetails?.emailID,
          faxNo: values?.proposerDetails?.faxNo,
          altPhoneNo: values?.proposerDetails?.altPhoneNo,
          altMobileNo: values?.proposerDetails?.altMobileNo,
          ifscCode: proposerDetailsMeta?.ifscCode,
          bankName: proposerDetailsMeta?.bankName,
          bankAcno: proposerDetailsMeta?.bankAcno,
          accountHolderName: proposerDetailsMeta?.accountHolderName,
          micrCode: proposerDetailsMeta?.micrCode,
          employeeNumber: values?.proposerDetails?.employeeNumber,
        },
        proposalPaymentType: values?.proposalPaymentType,
        quotationType: viewRenewPolicy?.businessType,
        intermediary: {
          intermediaryCode: values?.intermediaryData?.intermediary
            ? `${values?.intermediaryData?.intermediary}`
            : '',
          locationCode: values?.intermediaryData?.businessLocation
            ? `${values?.intermediaryData?.businessLocation}`
            : '',
          fieldUserCode: viewRenewPolicy?.intermediaryDetails
            ?.fieldUserCode
            ? `${viewRenewPolicy?.intermediaryDetails?.fieldUserCode}`
            : '',
        },
        startDate: viewRenewPolicy?.policy?.startDate,
        endDate: viewRenewPolicy?.policy?.endDate,
        startTime: '00:00',
        zone: 'NA',
        coverType: planValues?.coverType,
        sumInsured: parseFloat(planValues?.sumInsured),
        deductSumInsured:parseFloat(planValues?.deductSumInsured),
        tenure: viewRenewPolicy?.quoteData?.cover?.tenure,
        plan: {
          name: planValues?.planName,
          code: viewRenewPolicy?.planData?.plans?.find(
            (plan) =>
              plan?.name?.toLowerCase() ===
              planValues?.planName?.toLowerCase(),
          )?.code,
          covers: planValues?.covers?.baseCovers,
          packs: planValues?.covers?.packs,
          premium: planValues?.premium,
        },
        insuredDetails: getInsuredDetailsObj(values, planValues),
        isHealthDeclarationSelected:
          values?.isHealthDeclarationSelected?.toLowerCase() === 'yes'
            ? true
            : false,
        quoteNumber: viewRenewPolicy?.quoteNumber,
        productCode,
        existingPolicyNumber: (viewRenewPolicy?.Please_provide_existing_policy_number!='' || viewRenewPolicy?.Please_provide_existing_policy_number!=undefined)?viewRenewPolicy?.Please_provide_existing_policy_number:'',//viewRenewPolicy?.policyNumber,
        isExistingEmployee:
          values?.proposerDetails?.employeeNumber !== ''
            ? true
            : false,
        renewalMandateDetails: {
          renewalPaymentMandate:
            (values?.renewalMandateDetails?.renewalPaymentMandate?.toString()?.toLowerCase() === 'yes' || values?.renewalMandateDetails?.renewalPaymentMandate)
              ? true : false,
          // (values?.renewalPaymentMandate ==='No'||values?.renewalPaymentMandate ==='Yes')
          // ?false
          // :values?.renewalPaymentMandate,
          // renewalMandateDetails?.renewalPaymentMandate?.toLowerCase() ===
          // 'yes'
          //   ? true
          //   : false,
          renewalPaymentMandateTakenInNameOf:
            values?.renewalMandateDetails?.renewalPaymentMandateTakenInNameOf, //renewalMandateDetails?.renewalPaymentMandateTakenInNameOf,
          termForMandateOpted: values?.renewalMandateDetails?.termForMandateOpted,    // renewalMandateDetails?.termForMandateOpted,
          typeOfDebit: values?.renewalMandateDetails?.typeOfDebit,              //renewalMandateDetails?.typeOfDebit,
          accountNumber: values?.renewalMandateDetails?.accountNumber,               //renewalMandateDetails?.accountNumber,
          destinationBankName: values?.renewalMandateDetails?.destinationBankName,  //renewalMandateDetails?.destinationBankName,
          destinationIfscCode: values?.renewalMandateDetails?.destinationIfscCode,  //renewalMandateDetails?.destinationIfscCode,
          destinationMicrCode: values?.renewalMandateDetails?.destinationMicrCode, //renewalMandateDetails?.destinationMicrCode,
          destinationBranchName: values?.renewalMandateDetails?.branchName,        // renewalMandateDetails?.branchName,
          mandateAmount: manamount ? manamount : values?.renewalMandateDetails?.mandateAmount,  //renewalMandateDetails?.mandateAmount,
          finalCollectionDate: values?.renewalMandateDetails?.finalCollectionDate,  //renewalMandateDetails?.finalCollectionDate,
          destinationBankAccountType: values?.renewalMandateDetails?.destinationBankAccountType, //renewalMandateDetails?.destinationBankAccountType,
        },
        renewalMode,
        proposerPincode: values?.proposerDetails?.commPincode,
        policyNumber: viewRenewPolicy?.policyNumber,
        proposalNumber: viewRenewPolicy?.proposalNumber,
      },
    };
  };
  const onSubmit = async (values) => {
    if (!values?.isCalculatingPremium && !values?.planLoading) {
    if (!viewRenewPolicy?.isProposalRenewed) {
      try {
        const doRenewProposal = mutateQuery({
          mutation: RENEWAL_PROPOSAL,
          variables: submitRenewalVariables(
            values,
            props?.forwardedPremiumFormRef?.current?.values,
          ),
        });
        setParentAlerts([]);
          updateViewRenewPolicy({isProposalRenewing: true});
        setCustomLoadingMessage('Renewing Proposal');
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setLoadingStep(true);
        let { data } = await doRenewProposal;
        updatePlanPremium(
          props?.forwardedPremiumFormRef?.current?.values?.planName,
          data?.submitRenewal?.premium,
        );
        if (
          props.forwardedAlertsRef &&
          props.forwardedAlertsRef.current
        ) {
          props.forwardedAlertsRef.current = [];
        }
        updateViewRenewPolicy({
            isProposalRenewing: false,
          intermediaryDetails: {
            intermediaryName: getDomainData(
              myIntermediaries,
              values?.intermediaryData?.intermediary,
              'intermediaryCode',
              'intermediaryName',
            )
              ? getDomainData(
                  myIntermediaries,
                  values?.intermediaryData?.intermediary,
                  'intermediaryCode',
                  'intermediaryName',
                )
              : '',
            branchOfficeName: getDomainData(
              myIntermediaries?.find(
                (intermediary) =>
                  intermediary?.intermediaryCode
                    ?.toString()
                    ?.toLowerCase() ===
                  values?.intermediaryData?.intermediary
                    ?.toString()
                    ?.toLowerCase(),
              )?.businessLocations,
              values?.intermediaryData?.businessLocation,
              'code',
              'name',
            )
              ? getDomainData(
                  myIntermediaries?.find(
                    (intermediary) =>
                      intermediary?.intermediaryCode
                        ?.toString()
                        ?.toLowerCase() ===
                      values?.intermediaryData?.intermediary
                        ?.toString()
                        ?.toLowerCase(),
                  )?.businessLocations,
                  values?.intermediaryData?.businessLocation,
                  'code',
                  'name',
                )
              : '',
            code: values?.intermediaryData?.intermediary
              ? `${values?.intermediaryData?.intermediary}`
              : '',
            location: values?.intermediaryData?.businessLocation
              ? `${values?.intermediaryData?.businessLocation}`
              : '',
              // fieldUserCode: values?.intermediaryData?.fieldUser
              //   ? `${values?.intermediaryData?.fieldUser}`
              //   : '',
            fieldUserCode: values?.intermediaryData?.fieldUser
              ? values?.intermediaryData?.fieldUserList?.find(
                (d ) =>  d.fieldUserName === values?.intermediaryData?.fieldUser 
              )?.fieldUserCode
              : '',
            fieldUserName:
              values?.intermediaryData?.fieldUser &&
              getDomainDataStrict(
                values?.intermediaryData?.fieldUserList,
                values?.intermediaryData?.fieldUser,
                'fieldUserCode',
                'fieldUserName',
              )
                ? getDomainDataStrict(
                    values?.intermediaryData?.fieldUserList,
                    values?.intermediaryData?.fieldUser,
                    'fieldUserCode',
                    'fieldUserName',
                  )
                : '',
          },
          proposalNumber: data?.submitRenewal?.proposalNumber,
          proposalStatus: data?.submitRenewal?.proposalStatus,
          isProposalApplicableForPayment:
            data?.submitRenewal?.isApplicableForPayment,
          proposalPaymentType: values?.proposalPaymentType,
          isHealthDeclarationSelected:
            values?.isHealthDeclarationSelected,
          isProposalRenewed: true,
          totalPremium: data?.submitRenewal?.premium?.totalPremium,
          proposerDetails: {
            ...proposerDetails,
            permAddressLine1:
              values?.proposerDetails?.permAddressLine1,
            permAddressLine2:
              values?.proposerDetails?.permAddressLine2,
            permAddressLine3:
              values?.proposerDetails?.permAddressLine3,
            permLandmark: values?.proposerDetails?.permLandmark,
            permPincode: values?.proposerDetails?.permPincode,
            permCityTownVillage:
              values?.proposerDetails?.permCityTownVillage,
            permDistrict: values?.proposerDetails?.permDistrict,
            permState: values?.proposerDetails?.permState,
            commAddressLine1:
              values?.proposerDetails?.commAddressLine1,
            commAddressLine2:
              values?.proposerDetails?.commAddressLine2,
            commAddressLine3:
              values?.proposerDetails?.commAddressLine3,
            commLandmark: values?.proposerDetails?.commLandmark,
            commPincode: values?.proposerDetails?.commPincode,
            commCityTownVillage:
              values?.proposerDetails?.commCityTownVillage,
            commDistrict: values?.proposerDetails?.commDistrict,
            commState: values?.proposerDetails?.commState,
            mobileNo: values?.proposerDetails?.mobileNo,
            emailID: values?.proposerDetails?.emailID,
            phoneNo: values?.proposerDetails?.phoneNo,
            altPhoneNo: values?.proposerDetails?.altPhoneNo,
            altMobileNo: values?.proposerDetails?.altMobileNo,
            panNumber : values?.proposerDetails?.panNumber,
          },
          insuredDetails:
            Object.keys(values?.insuredDetails)?.length > 0
              ? Object.keys(values?.insuredDetails)
                  .filter(
                    (insured) =>
                        !values?.insuredDetails[insured]
                          ?.isSoftAdded &&
                        !values?.insuredDetails[insured]
                          ?.isHardDeleted,
                  )
                  .map((insured) => {
                    return {
                      relationship: insured,
                      title: values?.insuredDetails[insured]?.title,
                        gender:
                          values?.insuredDetails[insured]?.gender,
                      dob: values?.insuredDetails[insured]?.dob,
                      age: values?.insuredDetails[insured]?.age,
                      firstName:
                        values?.insuredDetails[insured]?.firstName,
                      middleName:
                        values?.insuredDetails[insured]?.middleName,
                      lastName:
                        values?.insuredDetails[insured]?.lastName,
                      maritalStatus:
                        values?.insuredDetails[insured]
                          ?.maritalStatus,
                        height:
                          values?.insuredDetails[insured]?.height,
                        weight:
                          values?.insuredDetails[insured]?.weight,
                      occupation:
                        values?.insuredDetails[insured]?.occupation,
                      otherOccupation:
                        values?.insuredDetails[insured]
                          ?.otherOccupation,
                      pedWaitingPeriod:
                        values?.insuredDetails[insured]
                          ?.pedWaitingPeriod,
                      ppcTestLevel:
                          values?.insuredDetails[insured]
                            ?.ppcTestLevel,
                      memberStatus:
                          values?.insuredDetails[insured]
                            ?.memberStatus,
                      isPortabilityRequired:
                        values?.insuredDetails[insured]
                          ?.isPortabilityRequired,
                      cbBonusPct:
                        values?.insuredDetails[insured]?.cbBonusPct,
                      memberID:
                        values?.insuredDetails[insured]?.memberID,
                      isDeleted:
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted,
                    };
                  })
              : [],
          nomineeDetails:
            Object.keys(values?.nomineeDetails)?.length > 0
              ? Object.keys(values?.nomineeDetails)
                  .filter(
                    (nominee) =>
                        !values?.nomineeDetails[nominee]
                          ?.isSoftAdded &&
                        !values?.nomineeDetails[nominee]
                          ?.isHardDeleted,
                  )
                  .map((nominee) => {
                    return {
                      relationship: nominee,
                      name: values?.nomineeDetails[nominee]?.name,
                      dob: values?.nomineeDetails[nominee]?.dob,
                      relationshipWithInsured:
                        values?.nomineeDetails[nominee]
                          ?.relationshipWithInsured,
                      relationshipWithAppointee:
                        values?.nomineeDetails[nominee]
                          ?.relationshipWithAppointee,
                      nameOfAppointee:
                        values?.nomineeDetails[nominee]
                          ?.nameOfAppointee,
                    };
                  })
              : [],
          prevInsuranceDetails:
            Object.keys(values?.prevInsuranceDetails)?.length > 0
              ? Object.keys(values?.prevInsuranceDetails)
                  .filter(
                    (prevInsured) =>
                      !values?.prevInsuranceDetails[prevInsured]
                        ?.isSoftAdded &&
                      !values?.prevInsuranceDetails[prevInsured]
                        ?.isHardDeleted,
                  )
                  .map((prevInsured) => {
                    return {
                      prevInsurerName: reformData(
                        values?.prevInsuranceDetails[prevInsured]
                          ?.prevInsurerName,
                        '',
                      ),
                      prevPolicyNo: reformData(
                        values?.prevInsuranceDetails[prevInsured]
                          ?.prevPolicyNo,
                        '',
                      ),
                      prevPolicySI: reformData(
                        values?.prevInsuranceDetails[prevInsured]
                          ?.prevPolicySI,
                        '',
                      ),
                      noOfClaim: reformData(
                        values?.prevInsuranceDetails[prevInsured]
                          ?.noOfClaim,
                        '',
                      ),
                      claimAmount: reformData(
                        values?.prevInsuranceDetails[prevInsured]
                          ?.claimAmount,
                        '',
                      ),
                      prevPolicyStartDate: reformData(
                        values?.prevInsuranceDetails[prevInsured]
                          ?.prevPolicyStartDate,
                      ),
                      prevPolicyEndDate: reformData(
                        values?.prevInsuranceDetails[prevInsured]
                          ?.prevPolicyEndDate,
                        '',
                      ),
                      insuredRelationship: reformData(
                        prevInsured,
                        '',
                      ),
                      insuredName: reformData(
                        [
                          values?.insuredDetails[
                            prevInsured
                          ]?.firstName
                            ?.toString()
                            ?.trim(),
                          values?.insuredDetails[
                            prevInsured
                          ]?.middleName
                            ?.toString()
                            ?.trim(),
                          values?.insuredDetails[
                            prevInsured
                          ]?.lastName
                            ?.toString()
                            ?.trim(),
                        ]
                          .filter((d) => d)
                          .join(' '),
                        '',
                      ),
                      cbAmount: reformData(
                        values?.prevInsuranceDetails[prevInsured]
                          ?.cbAmount,
                        '',
                      ),
                      prevClaimLodged: reformData(
                        values?.prevInsuranceDetails[prevInsured]
                          ?.prevClaimLodged,
                        '',
                      ),
                    };
                  })
              : [],
          medicalQuestionaire:
            Object?.keys(values?.medicalUnderwriting)?.length > 0
              ? Object.keys(values?.medicalUnderwriting)
                  .filter(
                    (insured) =>
                        !values?.insuredDetails[insured]
                          ?.isSoftAdded &&
                        !values?.insuredDetails[insured]
                          ?.isHardDeleted,
                  )
                  .map((insured) => {
                    return {
                      relationship: insured,
                      questions: [
                        {
                          srNo: 'MASTER',
                          answer: {
                            checkboxAnswer:
                              values?.medicalUnderwriting['MASTER']
                                ?.checkboxAnswer,
                            answerText:
                              values?.medicalUnderwriting['MASTER']
                                ?.checkboxAnswer,
                            textareaAnswer: '',
                          },
                        },
                        ,
                        ...Object.keys(
                          values?.medicalUnderwriting[insured],
                        )?.map((srNo) => {
                          let answerText = '';
                          const question = productQuestionList.find(
                            (question) => question.srNo === srNo,
                          );
                          if (question) {
                            if (!question.isParent) {
                              const parentQuestion =
                                productQuestionList.find((q) =>
                                  q?.childQuesNo?.find(
                                    (c) =>
                                      c?.toLowerCase() ===
                                      question?.srNo?.toLowerCase(),
                                  ),
                                );
                              if (
                                parentQuestion &&
                                ((values?.medicalUnderwriting[
                                  insured
                                ][`${parentQuestion?.srNo}`]
                                  ?.checkboxAnswer === 'Yes' &&
                                  !parentQuestion?.condToChild) ||
                                  (values?.medicalUnderwriting[
                                    insured
                                  ][`${parentQuestion.srNo}`]
                                    ?.checkboxAnswer === 'No' &&
                                    parentQuestion?.condToChild))
                              ) {
                                answerText = '';
                              } else {
                                answerText =
                                  question?.isChkTxtReq &&
                                  values?.medicalUnderwriting[
                                    insured
                                  ][srNo]?.checkboxAnswer === 'Yes'
                                    ? values?.medicalUnderwriting[
                                        insured
                                      ][srNo]?.textareaAnswer
                                    : question?.isChkTxtReq &&
                                      values?.medicalUnderwriting[
                                        insured
                                        ][srNo]?.checkboxAnswer ===
                                          'No'
                                    ? values?.medicalUnderwriting[
                                        insured
                                      ][srNo]?.checkboxAnswer
                                    : question?.isChkReq
                                    ? values?.medicalUnderwriting[
                                        insured
                                      ][srNo]?.checkboxAnswer
                                    : values?.medicalUnderwriting[
                                        insured
                                      ][srNo]?.textareaAnswer;
                              }
                            } else {
                              answerText =
                                question?.isChkTxtReq &&
                                  values?.medicalUnderwriting[
                                    insured
                                  ][srNo]?.checkboxAnswer === 'Yes'
                                  ? values?.medicalUnderwriting[
                                      insured
                                    ][srNo]?.textareaAnswer
                                  : question?.isChkTxtReq &&
                                    values?.medicalUnderwriting[
                                      insured
                                    ][srNo]?.checkboxAnswer === 'No'
                                  ? values?.medicalUnderwriting[
                                      insured
                                    ][srNo]?.checkboxAnswer
                                  : question?.isChkReq
                                  ? values?.medicalUnderwriting[
                                      insured
                                    ][srNo]?.checkboxAnswer
                                  : values?.medicalUnderwriting[
                                      insured
                                    ][srNo]?.textareaAnswer;
                            }
                          } else {
                            answerText =
                              values?.medicalUnderwriting[insured][
                                srNo
                              ]?.checkboxAnswer;
                          }
                          return {
                            srNo,
                            answer: {
                              checkboxAnswer:
                                  values?.medicalUnderwriting[
                                    insured
                                  ][srNo]?.checkboxAnswer,
                              answerText,
                              textareaAnswer:
                                  values?.medicalUnderwriting[
                                    insured
                                  ][srNo]?.textareaAnswer,
                            },
                          };
                        }),
                      ],
                    };
                  })
              : [],
                renewalMandateDetails : values?.renewalMandateDetails,
        });
        setLoadingStep(false);
          if (data?.submitRenewal?.warningMsg) {
            setParentAlerts([
              {
                header: 'Proposal Renewed Successfully',
                content: (
                  <div className="flex flex-col w-full h-full">
                    <Text type="normal">
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="text-success"
                      />{' '}
                      Proposal Number:{' '}
                      {data?.submitRenewal?.proposalNumber}
                    </Text>
                  </div>
                ),
                type: 'success',
                timeout: null,
                disableClose: false,
              },
              {
                content: (
                  <Text type="normal">
                    {data?.submitRenewal?.warningMsg}
                  </Text>
                ),
                type: 'warning',
                timeout: null,
                disableClose: false,
              },
            ]);
          } else {
        setParentAlerts([
          {
            header: 'Proposal Renewed Successfully',
            id: Date.now(),
            content: (
              <div className="flex flex-col w-full h-full">
                <Text type="normal">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="text-success"
                  />{' '}
                      Proposal Number:{' '}
                      {data?.submitRenewal?.proposalNumber}
                </Text>
              </div>
            ),
            type: 'success',
            timeout: null,
            disableClose: false,
          },
        ]);
          }
        sessionStorage?.setItem(
          'intermediaryName',
          getDomainData(
            myIntermediaries,
            values?.intermediaryData?.intermediary,
            'intermediaryCode',
            'intermediaryName',
          )
            ? getDomainData(
                myIntermediaries,
                values?.intermediaryData?.intermediary,
                'intermediaryCode',
                'intermediaryName',
              )
            : '',
        );
        sessionStorage?.setItem(
          'intermediaryCode',
          values?.intermediaryData?.intermediary
            ? `${values?.intermediaryData?.intermediary}`
            : '',
        );
        sessionStorage?.setItem(
          'branchOfficeCode',
          values?.intermediaryData?.businessLocation
            ? `${values?.intermediaryData?.businessLocation}`
            : '',
        );
        sessionStorage?.setItem(
          'branchOfficeName',
          getDomainData(
            myIntermediaries?.find(
              (intermediary) =>
                intermediary?.intermediaryCode
                  ?.toString()
                  ?.toLowerCase() ===
                values?.intermediaryData?.intermediary
                  ?.toString()
                  ?.toLowerCase(),
            )?.businessLocations,
            values?.intermediaryData?.businessLocation,
            'code',
            'name',
          )
            ? getDomainData(
                myIntermediaries?.find(
                  (intermediary) =>
                    intermediary?.intermediaryCode
                      ?.toString()
                      ?.toLowerCase() ===
                    values?.intermediaryData?.intermediary
                      ?.toString()
                      ?.toLowerCase(),
                )?.businessLocations,
                values?.intermediaryData?.businessLocation,
                'code',
                'name',
              )
            : '',
        );
        sessionStorage?.setItem(
          'fieldUserCode',
          values?.intermediaryData?.fieldUser
            ? `${values?.intermediaryData?.fieldUser}`
            : '',
        );
        sessionStorage?.setItem(
          'fieldUserName',
          values?.intermediaryData?.fieldUser &&
            getDomainData(
              values?.intermediaryData?.fieldUserList,
              values?.intermediaryData?.fieldUser,
              'fieldUserCode',
              'fieldUserName',
            )
            ? getDomainData(
                values?.intermediaryData?.fieldUserList,
                values?.intermediaryData?.fieldUser,
                'fieldUserCode',
                'fieldUserName',
              )
            : '',
        );
        updateAllIntermediaryFields({
          intermediaryName: getDomainData(
            myIntermediaries,
            values?.intermediaryData?.intermediary,
            'intermediaryCode',
            'intermediaryName',
          )
            ? getDomainData(
                myIntermediaries,
                values?.intermediaryData?.intermediary,
                'intermediaryCode',
                'intermediaryName',
              )
            : '',
          intermediaryCode: values?.intermediaryData?.intermediary
            ? `${values?.intermediaryData?.intermediary}`
            : '',
            branchOfficeCode: values?.intermediaryData
              ?.businessLocation
            ? `${values?.intermediaryData?.businessLocation}`
            : '',
          branchOfficeName: getDomainData(
            myIntermediaries?.find(
              (intermediary) =>
                intermediary?.intermediaryCode
                  ?.toString()
                  ?.toLowerCase() ===
                values?.intermediaryData?.intermediary
                  ?.toString()
                  ?.toLowerCase(),
            )?.businessLocations,
            values?.intermediaryData?.businessLocation,
            'code',
            'name',
          )
            ? getDomainData(
                myIntermediaries?.find(
                  (intermediary) =>
                    intermediary?.intermediaryCode
                      ?.toString()
                      ?.toLowerCase() ===
                    values?.intermediaryData?.intermediary
                      ?.toString()
                      ?.toLowerCase(),
                )?.businessLocations,
                values?.intermediaryData?.businessLocation,
                'code',
                'name',
              )
            : '',
          fieldUserCode: values?.intermediaryData?.fieldUser
              ? values?.intermediaryData?.fieldUserList?.find(
                (d ) =>  d.fieldUserName === values?.intermediaryData?.fieldUser 
              )?.fieldUserCode
            : '',
            // fieldUserCode: values?.intermediaryData?.fieldUser
            //   ? `${values?.intermediaryData?.fieldUser}`
            //   : '',
          fieldUserName:
            values?.intermediaryData?.fieldUser &&
            getDomainData(
              values?.intermediaryData?.fieldUserList,
              values?.intermediaryData?.fieldUser,
              'fieldUserCode',
              'fieldUserName',
            )
              ? getDomainData(
                  values?.intermediaryData?.fieldUserList,
                  values?.intermediaryData?.fieldUser,
                  'fieldUserCode',
                  'fieldUserName',
                )
              : '',
        });
        return true;
      } catch (error) {
        setParentAlerts([
          {
            header: 'Error',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                {error.message}
              </div>
            ),
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ]);
        setLoadingStep(false);
        if (
          props.forwardedAlertsRef &&
          props.forwardedAlertsRef.current
        ) {
          props.forwardedAlertsRef.current = [];
        }
        updateViewRenewPolicy({
            isProposalRenewing: false,
          intermediaryDetails: {
            code: values?.intermediaryData?.intermediary
              ? `${values?.intermediaryData?.intermediary}`
              : '',
            location: values?.intermediaryData?.businessLocation
              ? `${values?.intermediaryData?.businessLocation}`
              : '',
            fieldUserCode: values?.intermediaryData?.fieldUser
                ? values?.intermediaryData?.fieldUserList?.find(
                  (d ) =>  d.fieldUserName === values?.intermediaryData?.fieldUser 
                )?.fieldUserCode
              : '',
              // fieldUserCode: values?.intermediaryData?.fieldUser
              //   ? `${values?.intermediaryData?.fieldUser}`
              //   : '',
            fieldUserName:
              values?.intermediaryData?.fieldUser &&
              getDomainDataStrict(
                values?.intermediaryData?.fieldUserList,
                values?.intermediaryData?.fieldUser,
                'fieldUserCode',
                'fieldUserName',
              )
                ? getDomainDataStrict(
                    values?.intermediaryData?.fieldUserList,
                    values?.intermediaryData?.fieldUser,
                    'fieldUserCode',
                    'fieldUserName',
                  )
                : '',
          },
          proposalPaymentType: values?.proposalPaymentType,
          isHealthDeclarationSelected:
            values?.isHealthDeclarationSelected,
          proposerDetails: {
            ...proposerDetails,
            permAddressLine1:
              values?.proposerDetails?.permAddressLine1,
            permAddressLine2:
              values?.proposerDetails?.permAddressLine2,
            permAddressLine3:
              values?.proposerDetails?.permAddressLine3,
            permLandmark: values?.proposerDetails?.permLandmark,
            permPincode: values?.proposerDetails?.permPincode,
            permCityTownVillage:
              values?.proposerDetails?.permCityTownVillage,
            permDistrict: values?.proposerDetails?.permDistrict,
            permState: values?.proposerDetails?.permState,
            commAddressLine1:
              values?.proposerDetails?.commAddressLine1,
            commAddressLine2:
              values?.proposerDetails?.commAddressLine2,
            commAddressLine3:
              values?.proposerDetails?.commAddressLine3,
            commLandmark: values?.proposerDetails?.commLandmark,
            commPincode: values?.proposerDetails?.commPincode,
            commCityTownVillage:
              values?.proposerDetails?.commCityTownVillage,
            commDistrict: values?.proposerDetails?.commDistrict,
            commState: values?.proposerDetails?.commState,
            mobileNo: values?.proposerDetails?.mobileNo,
            emailID: values?.proposerDetails?.emailID,
            phoneNo: values?.proposerDetails?.phoneNo,
            altPhoneNo: values?.proposerDetails?.altPhoneNo,
            altMobileNo: values?.proposerDetails?.altMobileNo,
            panNumber : values?.proposerDetails?.panNumber,
          },
          insuredDetails:
            Object.keys(values?.insuredDetails)?.length > 0
              ? Object.keys(values?.insuredDetails)
                  ?.filter(
                    (insured) =>
                        !values?.insuredDetails[insured]
                          ?.isHardDeleted,
                  )
                  ?.map((insured) => {
                    return {
                      relationship: insured,
                      title: values?.insuredDetails[insured]?.title,
                        gender:
                          values?.insuredDetails[insured]?.gender,
                      dob: values?.insuredDetails[insured]?.dob,
                      age: values?.insuredDetails[insured]?.age,
                      firstName:
                        values?.insuredDetails[insured]?.firstName,
                      middleName:
                        values?.insuredDetails[insured]?.middleName,
                      lastName:
                        values?.insuredDetails[insured]?.lastName,
                      maritalStatus:
                        values?.insuredDetails[insured]
                          ?.maritalStatus,
                        height:
                          values?.insuredDetails[insured]?.height,
                        weight:
                          values?.insuredDetails[insured]?.weight,
                      occupation:
                        values?.insuredDetails[insured]?.occupation,
                      otherOccupation:
                        values?.insuredDetails[insured]
                          ?.otherOccupation,
                      pedWaitingPeriod:
                        values?.insuredDetails[insured]
                          ?.pedWaitingPeriod,
                      ppcTestLevel:
                          values?.insuredDetails[insured]
                            ?.ppcTestLevel,
                      memberStatus:
                          values?.insuredDetails[insured]
                            ?.memberStatus,
                      isPortabilityRequired:
                        values?.insuredDetails[insured]
                          ?.isPortabilityRequired,
                      cbBonusPct:
                        values?.insuredDetails[insured]?.cbBonusPct,
                      memberID:
                        values?.insuredDetails[insured]?.memberID,
                      isDeleted:
                        values?.insuredDetails[insured]
                          ?.isMemberDeleted,
                    };
                  })
              : [],
          nomineeDetails:
            Object.keys(values?.nomineeDetails)?.length > 0
              ? Object.keys(values?.nomineeDetails)
                  ?.filter(
                    (nominee) =>
                        !values?.nomineeDetails[nominee]
                          ?.isHardDeleted,
                  )
                  ?.map((nominee) => {
                    return {
                      relationship: nominee,
                      name: values?.nomineeDetails[nominee]?.name,
                      dob: values?.nomineeDetails[nominee]?.dob,
                      relationshipWithInsured:
                        values?.nomineeDetails[nominee]
                          ?.relationshipWithInsured,
                      relationshipWithAppointee:
                        values?.nomineeDetails[nominee]
                          ?.relationshipWithAppointee,
                      nameOfAppointee:
                        values?.nomineeDetails[nominee]
                          ?.nameOfAppointee,
                    };
                  })
              : [],
          prevInsuranceDetails:
            Object.keys(values?.prevInsuranceDetails)?.length > 0
              ? Object.keys(values?.prevInsuranceDetails)
                  ?.filter(
                    (prevInsured) =>
                      !values?.prevInsuranceDetails[prevInsured]
                        ?.isHardDeleted,
                  )
                  ?.map((prevInsured) => {
                    return {
                      prevInsurerName: reformData(
                        values?.prevInsuranceDetails[prevInsured]
                          ?.prevInsurerName,
                        '',
                      ),
                      prevPolicyNo: reformData(
                        values?.prevInsuranceDetails[prevInsured]
                          ?.prevPolicyNo,
                        '',
                      ),
                      prevPolicySI: reformData(
                        values?.prevInsuranceDetails[prevInsured]
                          ?.prevPolicySI,
                        '',
                      ),
                      noOfClaim: reformData(
                        values?.prevInsuranceDetails[prevInsured]
                          ?.noOfClaim,
                        '',
                      ),
                      claimAmount: reformData(
                        values?.prevInsuranceDetails[prevInsured]
                          ?.claimAmount,
                        '',
                      ),
                      prevPolicyStartDate: reformData(
                        values?.prevInsuranceDetails[prevInsured]
                          ?.prevPolicyStartDate,
                      ),
                      prevPolicyEndDate: reformData(
                        values?.prevInsuranceDetails[prevInsured]
                          ?.prevPolicyEndDate,
                        '',
                      ),
                      insuredRelationship: reformData(
                        prevInsured,
                        '',
                      ),
                      insuredName: reformData(
                        [
                          values?.insuredDetails[
                            prevInsured
                          ]?.firstName
                            ?.toString()
                            ?.trim(),
                          values?.insuredDetails[
                            prevInsured
                          ]?.middleName
                            ?.toString()
                            ?.trim(),
                          values?.insuredDetails[
                            prevInsured
                          ]?.lastName
                            ?.toString()
                            ?.trim(),
                        ]
                          .filter((d) => d)
                          .join(' '),
                        '',
                      ),
                      cbAmount: reformData(
                        values?.prevInsuranceDetails[prevInsured]
                          ?.cbAmount,
                        '',
                      ),
                      prevClaimLodged: reformData(
                        values?.prevInsuranceDetails[prevInsured]
                          ?.prevClaimLodged,
                        '',
                      ),
                    };
                  })
              : [],
          medicalQuestionaire:
            Object?.keys(values?.medicalUnderwriting)?.length > 0
              ? Object.keys(values?.medicalUnderwriting).map(
                  (insured) => {
                    return {
                      relationship: insured,
                      questions: [
                        {
                          srNo: 'MASTER',
                          answer: {
                            checkboxAnswer:
                              values?.medicalUnderwriting['MASTER']
                                ?.checkboxAnswer,
                            answerText:
                              values?.medicalUnderwriting['MASTER']
                                ?.checkboxAnswer,
                            textareaAnswer: '',
                          },
                        },
                        ...Object.keys(
                          values?.medicalUnderwriting[insured],
                        )?.map((srNo) => {
                          let answerText = '';
                          const question = productQuestionList.find(
                            (question) => question?.srNo === srNo,
                          );
                          if (question) {
                            if (!question?.isParent) {
                              const parentQuestion =
                                productQuestionList.find((q) =>
                                  q?.childQuesNo?.find(
                                    (c) =>
                                      c?.toLowerCase() ===
                                      question?.srNo?.toLowerCase(),
                                  ),
                                );
                              if (
                                parentQuestion &&
                                ((values?.medicalUnderwriting[
                                  insured
                                ][`${parentQuestion?.srNo}`]
                                  ?.checkboxAnswer === 'Yes' &&
                                  !parentQuestion?.condToChild) ||
                                  (values?.medicalUnderwriting[
                                    insured
                                  ][`${parentQuestion?.srNo}`]
                                    ?.checkboxAnswer === 'No' &&
                                    parentQuestion?.condToChild))
                              ) {
                                answerText = '';
                              } else {
                                answerText =
                                  question?.isChkTxtReq &&
                                  values?.medicalUnderwriting[
                                    insured
                                  ][srNo]?.checkboxAnswer === 'Yes'
                                    ? values?.medicalUnderwriting[
                                        insured
                                      ][srNo].textareaAnswer
                                    : question?.isChkTxtReq &&
                                      values?.medicalUnderwriting[
                                        insured
                                        ][srNo]?.checkboxAnswer ===
                                          'No'
                                    ? values?.medicalUnderwriting[
                                        insured
                                      ][srNo]?.checkboxAnswer
                                    : question?.isChkReq
                                    ? values?.medicalUnderwriting[
                                        insured
                                      ][srNo]?.checkboxAnswer
                                    : values?.medicalUnderwriting[
                                        insured
                                      ][srNo]?.textareaAnswer;
                              }
                            } else {
                              answerText =
                                question?.isChkTxtReq &&
                                  values?.medicalUnderwriting[
                                    insured
                                  ][srNo]?.checkboxAnswer === 'Yes'
                                  ? values?.medicalUnderwriting[
                                      insured
                                    ][srNo]?.textareaAnswer
                                  : question?.isChkTxtReq &&
                                    values?.medicalUnderwriting[
                                      insured
                                    ][srNo]?.checkboxAnswer === 'No'
                                  ? values?.medicalUnderwriting[
                                      insured
                                    ][srNo]?.checkboxAnswer
                                  : question?.isChkReq
                                  ? values?.medicalUnderwriting[
                                      insured
                                    ][srNo]?.checkboxAnswer
                                  : values?.medicalUnderwriting[
                                      insured
                                    ][srNo]?.textareaAnswer;
                            }
                          } else {
                            answerText =
                              values?.medicalUnderwriting[insured][
                                srNo
                              ]?.checkboxAnswer;
                          }
                          return {
                            srNo,
                            answer: {
                              checkboxAnswer:
                                  values?.medicalUnderwriting[
                                    insured
                                  ][srNo]?.checkboxAnswer,
                              answerText,
                              textareaAnswer:
                                  values?.medicalUnderwriting[
                                    insured
                                  ][srNo]?.textareaAnswer,
                            },
                          };
                        }),
                      ],
                    };
                  },
                )
              : [],
            renewalMandateDetails : values?.renewalMandateDetails,
        });
        return false;
      }
    } else {
    setParentAlerts([]);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return true;
      }
    }
    return false;
  };

  return (
    <>
      {viewRenewPolicy && viewRenewPolicy?.proposalNumber && (
        <QuantaFormik
          innerRef={props?.forwardedRenewFormRef}
          enableReinitialize={true}
          {...{
            initialValues,
            validate,
            onSubmit,
          }}
        >
          <RenewReviewForm {...{ validate }} />
        </QuantaFormik>
      )}
    </>
  );
}
